import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any; }
  /** JSON scalar for flexible data structures */
  Json: { input: any; output: any; }
  /**
   * The `Naive DateTime` scalar type represents a naive date and time without
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string.
   */
  NaiveDateTime: { input: any; output: any; }
  /** Represents an uploaded file. */
  Upload: { input: any; output: any; }
};

/** Input for adding a target to a trigger */
export type AddTriggerTargetInput = {
  /** Whether the target is active (default: true) */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Map to transform trigger event data */
  inputMapping?: InputMaybe<Scalars['Json']['input']>;
  /** Execution order (default: 0) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the workflow or job */
  targetId: Scalars['ID']['input'];
  /** Type of target */
  targetType: TriggerTargetType;
};

/** An agent or template agent */
export type Agent = Node & {
  __typename?: 'Agent';
  agentGreeting?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['Json']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Display order for sorting agents (nulls last) */
  displayOrder?: Maybe<Scalars['Int']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  knowledgeBaseIds?: Maybe<Array<Scalars['ID']['output']>>;
  knowledgeBases?: Maybe<Array<KnowledgeBase>>;
  /** Model code name */
  model?: Maybe<ModelCode>;
  name: Scalars['String']['output'];
  systemMessage?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateMetadata?: Maybe<Scalars['Json']['output']>;
  tools?: Maybe<Scalars['Json']['output']>;
  toolsCount?: Maybe<Scalars['Int']['output']>;
  /** Agent version number for tracking changes */
  version: Scalars['Int']['output'];
};

/** Connection type for paginated Agent */
export type AgentConnection = {
  __typename?: 'AgentConnection';
  edges?: Maybe<Array<Maybe<AgentEdge>>>;
  pageInfo: PageInfo;
};

export type AgentEdge = {
  __typename?: 'AgentEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Agent>;
};

/** Filter for agents */
export type AgentFilterInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new agent */
export type AgentInput = {
  agentGreeting?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Model code name (fast, balanced, smart, powerful, premium) */
  model?: InputMaybe<ModelCode>;
  name?: InputMaybe<Scalars['String']['input']>;
  systemMessage?: InputMaybe<Scalars['String']['input']>;
  /** Optional template ID to create agent from */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Tools configuration (can be JSONB object with mcp_servers or array of strings) */
  tools?: InputMaybe<Scalars['Json']['input']>;
};

/** Association between an agent and a knowledge base */
export type AgentKnowledgeBase = {
  __typename?: 'AgentKnowledgeBase';
  agent?: Maybe<Agent>;
  agentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['String']['output']>;
  knowledgeBase?: Maybe<KnowledgeBase>;
  knowledgeBaseId: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
};

export enum AgentStatus {
  /** Agent is waiting for client to execute tools */
  AwaitingClientTools = 'AWAITING_CLIENT_TOOLS',
  /** Agent is requesting permission to execute a tool */
  AwaitingConsent = 'AWAITING_CONSENT',
  /** Agent encountered an error */
  Error = 'ERROR',
  /** Agent is executing tools */
  ExecutingTools = 'EXECUTING_TOOLS',
  /** Agent is ready to handle your query */
  Idle = 'IDLE',
  /** Agent is processing the request */
  Streaming = 'STREAMING',
  /** Agent has finished streaming the response */
  StreamEnd = 'STREAM_END',
  /** Response was truncated due to output token limit */
  Truncated = 'TRUNCATED'
}

/** Agent status event for real-time UI feedback */
export type AgentStatusEvent = {
  __typename?: 'AgentStatusEvent';
  agentId: Scalars['ID']['output'];
  agentStatus: AgentStatus;
  conversationId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  toolCallDetails?: Maybe<Scalars['String']['output']>;
  toolCallResults?: Maybe<Scalars['String']['output']>;
  toolName?: Maybe<Scalars['String']['output']>;
};

/** An agent task with its status and metadata */
export type AgentTask = {
  __typename?: 'AgentTask';
  dependencies?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parentTaskId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Navigation configuration for sidebar placement */
export type AppNavigationConfig = {
  __typename?: 'AppNavigationConfig';
  /** Custom icon for nav item */
  icon?: Maybe<Scalars['String']['output']>;
  /** Custom label in nav (defaults to app name) */
  label?: Maybe<Scalars['String']['output']>;
  /** Display order within parent (lower = higher priority) */
  order?: Maybe<Scalars['Int']['output']>;
  /** Menu hierarchy path as list of menu names (e.g., ['Acme', 'Dashboards']) */
  path?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Placement type: 'top-level', 'nested', or 'hidden' */
  placement: Scalars['String']['output'];
};

/** Summary of array task execution statuses */
export type ArrayTaskStatusSummary = {
  __typename?: 'ArrayTaskStatusSummary';
  /** Number of failed sub-tasks */
  failed: Scalars['Int']['output'];
  /** Number of pending sub-tasks */
  pending: Scalars['Int']['output'];
  /** Number of queued sub-tasks */
  queued: Scalars['Int']['output'];
  /** Number of running sub-tasks */
  running: Scalars['Int']['output'];
  /** Number of succeeded sub-tasks */
  succeeded: Scalars['Int']['output'];
  /** Total number of sub-tasks */
  total: Scalars['Int']['output'];
};

/** Artifact produced by a task or workflow execution */
export type Artifact = {
  __typename?: 'Artifact';
  /** Unique artifact identifier */
  artifactId: Scalars['String']['output'];
  /** MIME type of the artifact */
  contentType?: Maybe<Scalars['String']['output']>;
  /** When the artifact was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Content hash for integrity verification */
  hash?: Maybe<Scalars['String']['output']>;
  /** Additional artifact metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Human-readable artifact name */
  name?: Maybe<Scalars['String']['output']>;
  /** Size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Storage backend (e.g., 'minio', 's3') */
  storageBackend?: Maybe<Scalars['String']['output']>;
  /** Storage URI for the artifact */
  uri: Scalars['String']['output'];
};

/** Input for attaching a knowledge base to an agent */
export type AttachKnowledgeBaseInput = {
  agentId: Scalars['ID']['input'];
  config?: InputMaybe<Scalars['Json']['input']>;
  knowledgeBaseId: Scalars['ID']['input'];
};

/** Input for a single branch case */
export type BranchCaseInput = {
  /** Condition to evaluate */
  condition: BranchConditionInput;
  /** Task ID to execute if condition is true */
  then: Scalars['String']['input'];
};

/** Input for branch condition */
export type BranchConditionInput = {
  /** Boolean expression (e.g., '{{task.output}} == value') */
  expression: Scalars['String']['input'];
};

/** Input for branch task configuration */
export type BranchConfigInput = {
  /** List of conditional cases to evaluate */
  cases: Array<BranchCaseInput>;
  /** Default task ID to execute if no cases match (optional) */
  default?: InputMaybe<Scalars['String']['input']>;
};

/** Input for building a workflow specification */
export type BuildWorkflowSpecInput = {
  /** Workflow description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Edges connecting tasks */
  edges?: InputMaybe<Array<InputMaybe<WorkflowEdgeInput>>>;
  /** Additional metadata */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** Workflow name */
  name: Scalars['String']['input'];
  /** Tasks in the workflow */
  tasks?: InputMaybe<Array<InputMaybe<WorkflowTaskInput>>>;
  /** Workflow version */
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Child message event for task progress updates */
export type ChildMessageEvent = {
  __typename?: 'ChildMessageEvent';
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  messageType: Scalars['String']['output'];
  sourceConversationId: Scalars['ID']['output'];
  sourceConversationTitle?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Child node phase information */
export type ChildNodePhase = {
  __typename?: 'ChildNodePhase';
  /** Child node ID */
  nodeId: Scalars['String']['output'];
  /** Child node execution phase */
  phase: Scalars['String']['output'];
};

/** A client tool specification */
export type ClientToolSpec = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['Json']['input'];
};

/** An app provided by an external connector */
export type ConnectorApp = {
  __typename?: 'ConnectorApp';
  /** Connector address (tenant.type.instance) */
  address: Scalars['String']['output'];
  /** Connector type identifier */
  connectorType?: Maybe<Scalars['String']['output']>;
  /** App description */
  description?: Maybe<Scalars['String']['output']>;
  /** Default entry path (e.g., '/') */
  entryPath: Scalars['String']['output'];
  /** App icon (heroicons name) */
  icon: Scalars['String']['output'];
  /** App display name */
  name: Scalars['String']['output'];
  /** Navigation configuration for sidebar placement */
  navigation?: Maybe<AppNavigationConfig>;
  /** List of available routes */
  routes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Sandbox token for iframe authentication (when session cookie is unavailable) */
  sandboxToken?: Maybe<Scalars['String']['output']>;
};

/** A tool provided by an external connector */
export type ConnectorTool = {
  __typename?: 'ConnectorTool';
  /** Connector address that provides this tool */
  connectorAddress: Scalars['String']['output'];
  /** Tool description */
  description?: Maybe<Scalars['String']['output']>;
  /** Tool name/identifier */
  name: Scalars['String']['output'];
  /** Tool parameter schema (JSON Schema format) */
  parameters?: Maybe<Scalars['Json']['output']>;
};

/** A connector that provides tools, with metadata and list of its tools */
export type ConnectorToolsGroup = {
  __typename?: 'ConnectorToolsGroup';
  /** Connector address (tenant.type.instance) */
  address: Scalars['String']['output'];
  /** Connector type identifier */
  connectorType?: Maybe<Scalars['String']['output']>;
  /** Connector description */
  description?: Maybe<Scalars['String']['output']>;
  /** Connector icon (heroicons name) */
  icon?: Maybe<Scalars['String']['output']>;
  /** Connector display name */
  name?: Maybe<Scalars['String']['output']>;
  /** Tools provided by this connector */
  tools: Array<ConnectorTool>;
  /** Connector vendor */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** Consent action for tool call resolution */
export enum ConsentAction {
  /** Approve the tool call for execution */
  Approve = 'APPROVE',
  /** Deny the tool call with an error message */
  Deny = 'DENY'
}

/** A single consent decision for a tool call */
export type ConsentDecisionInput = {
  /** The action to take (approve or deny) */
  action: ConsentAction;
  /** The tool call ID to apply this decision to */
  id: Scalars['String']['input'];
  /** Approval mode (required when action is approve) */
  mode?: InputMaybe<ConsentMode>;
  /** Modified parameters to use instead of original (optional) */
  params?: InputMaybe<Scalars['Json']['input']>;
  /** Reason for denial (required when action is deny) */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Consent mode for approved tools */
export enum ConsentMode {
  /** Approve and persist this tool for future auto-approval */
  Always = 'ALWAYS',
  /** Approve this tool call for one-time execution */
  Once = 'ONCE'
}

/** A conversation */
export type Conversation = Node & {
  __typename?: 'Conversation';
  /** Current agent status for this conversation */
  agentStatus: AgentStatus;
  documentCount: Scalars['Int']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  messages: Array<Message>;
  metadata: Scalars['Json']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  systemPrompts: Array<SystemPrompt>;
  title: Scalars['String']['output'];
  type: ConversationType;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Conversation snapshot compaction completion event */
export type ConversationCompactedEvent = {
  __typename?: 'ConversationCompactedEvent';
  conversationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastMessageId: Scalars['ID']['output'];
  messagesSummarized: Scalars['Int']['output'];
  snapshotId: Scalars['ID']['output'];
  snapshotSizeBytes: Scalars['Int']['output'];
  snapshotTokens: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

/** Conversation snapshot compaction start event */
export type ConversationCompactingEvent = {
  __typename?: 'ConversationCompactingEvent';
  conversationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  messageCount: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

/** Connection type for paginated Conversation */
export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges?: Maybe<Array<Maybe<ConversationEdge>>>;
  pageInfo: PageInfo;
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Conversation>;
};

/** Union type for all conversation events */
export type ConversationEvent = AgentStatusEvent | ChildMessageEvent | ConversationCompactedEvent | ConversationCompactingEvent | ConversationUpdateEvent | Message | MessagePartStreamingEvent | ThinkingStreamingEvent | ToolCallApprovalEvent | ToolCallMessageEvent | ToolResultCompactedEvent | ToolResultCompactingEvent;

export type ConversationFilterInput = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationInput = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  clientTools?: InputMaybe<Array<ClientToolSpec>>;
  conversationId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parts: Array<MessagePartInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ConversationType>;
};

export type ConversationResponse = {
  __typename?: 'ConversationResponse';
  aiResponse?: Maybe<Message>;
  session?: Maybe<Conversation>;
  userMessage?: Maybe<Message>;
};

/** Result of generating a conversation summary */
export type ConversationSummaryResult = {
  __typename?: 'ConversationSummaryResult';
  /** Error message (if failed) */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the summary was successfully generated */
  success: Scalars['Boolean']['output'];
  /** The generated summary (if successful) */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Conversation type enumeration */
export enum ConversationType {
  /** Chat conversation */
  Chat = 'CHAT',
  /** Job conversation */
  Job = 'JOB',
  /** Workflow-initiated conversation */
  Workflow = 'WORKFLOW'
}

/** Conversation update event for title changes */
export type ConversationUpdateEvent = {
  __typename?: 'ConversationUpdateEvent';
  id: Scalars['ID']['output'];
  metadata: Scalars['Json']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateConversationInput = {
  /** Client-side tools to register with the conversation */
  clientTools?: InputMaybe<Array<ClientToolSpec>>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ConversationType>;
};

/** Input for creating a folder in the tenant */
export type CreateFolderInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  name: Scalars['String']['input'];
};

/** Input for creating a knowledge base */
export type CreateKnowledgeBaseInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name: Scalars['String']['input'];
};

/** Input for creating a secret */
export type CreateSecretInput = {
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name: Scalars['String']['input'];
  type: SecretType;
  url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

/** Input for creating a new trigger */
export type CreateTriggerInput = {
  /** Cron expression (required for cron triggers) */
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the trigger is active (default: true) */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional metadata */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** Unique name for the trigger */
  name: Scalars['String']['input'];
  /** Payload to send when cron trigger fires (workflow inputs or job prompts) */
  payload?: InputMaybe<Scalars['Json']['input']>;
  /** Timezone for cron evaluation (default: UTC) */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Type of trigger */
  triggerType: TriggerType;
  /** Webhook endpoint ID (required for webhook triggers) */
  webhookEndpointId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for creating a webhook endpoint */
export type CreateWebhookEndpointInput = {
  /** Description of the webhook endpoint */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the webhook endpoint */
  name: Scalars['String']['input'];
  /** Endpoint status: active, disabled. Defaults to active */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Either 'incoming' or 'outgoing' */
  webhookType: Scalars['String']['input'];
};

/** Input for creating a workflow definition */
export type CreateWorkflowInput = {
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Workflow execution engine (handoff) */
  engine?: InputMaybe<Scalars['String']['input']>;
  /** Additional metadata */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** Unique name for the workflow */
  name: Scalars['String']['input'];
  /** Version of the workflow */
  version?: InputMaybe<Scalars['String']['input']>;
  /** The workflow specification */
  workflowSpec: Scalars['Json']['input'];
  /** Workflow type (root, subworkflow, or shared) */
  workflowType?: InputMaybe<Scalars['String']['input']>;
};

/** Result of deleting a webhook endpoint */
export type DeleteWebhookEndpointResult = {
  __typename?: 'DeleteWebhookEndpointResult';
  success: Scalars['Boolean']['output'];
  webhookEndpoint?: Maybe<WebhookEndpoint>;
};

/** Delete workspace result */
export type DeleteWorkspaceResult = {
  __typename?: 'DeleteWorkspaceResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** A document stored in the conversation's tool state */
export type Document = Node & {
  __typename?: 'Document';
  content?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  id: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Connection type for paginated Document */
export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  edges?: Maybe<Array<Maybe<DocumentEdge>>>;
  pageInfo: PageInfo;
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Document>;
};

/** Filter for listing documents */
export type DocumentFilterInput = {
  knowledgeBaseId: Scalars['ID']['input'];
  status?: InputMaybe<DocumentStatus>;
};

/** Document processing event */
export type DocumentProcessingEvent = {
  __typename?: 'DocumentProcessingEvent';
  documentId: Scalars['ID']['output'];
  event: Scalars['String']['output'];
  processingResponse?: Maybe<ProcessingTrackResponse>;
  timestamp: Scalars['String']['output'];
};

/** Document processing status details */
export type DocumentProcessingStatus = {
  __typename?: 'DocumentProcessingStatus';
  chunksCount?: Maybe<Scalars['Int']['output']>;
  contentLength?: Maybe<Scalars['Int']['output']>;
  contentSummary?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  errorMsg?: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Document status enumeration */
export enum DocumentStatus {
  /** Document soft deleted */
  Deleted = 'DELETED',
  /** Document processing failed */
  Failed = 'FAILED',
  /** Document successfully processed */
  Loaded = 'LOADED',
  /** Document being processed */
  Loading = 'LOADING',
  /** Document fully indexed and searchable */
  Processed = 'PROCESSED',
  /** Document removed from index */
  Unloaded = 'UNLOADED',
  /** Document being removed */
  Unloading = 'UNLOADING',
  /** Document uploaded, awaiting processing */
  Uploaded = 'UPLOADED'
}

/** Input for enabling an MCP server for the tenant */
export type EnableMcpServerInput = {
  /** Consent mode: manual, approve_always, deny_always */
  consentMode?: InputMaybe<Scalars['String']['input']>;
  /** Map of header names to template strings (e.g., {"Authorization": "Bearer {{secrets.auth}}"}) */
  headers?: InputMaybe<Scalars['Json']['input']>;
  /** Map of secret names to secret IDs (e.g., {"auth": "uuid-123"}) */
  secrets?: InputMaybe<Scalars['Json']['input']>;
  /** MCP template identifier */
  templateId: Scalars['String']['input'];
  /** Request timeout in milliseconds */
  timeout?: InputMaybe<Scalars['Int']['input']>;
  /** Custom URL (optional, defaults to template URL) */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Enabled status enumeration for agents */
export enum EnabledStatus {
  /** All agents regardless of enabled status */
  All = 'ALL',
  /** Only disabled agents */
  Disabled = 'DISABLED',
  /** Only enabled agents */
  Enabled = 'ENABLED'
}

/** Input for executing a single task */
export type ExecuteTaskInput = {
  /**
   * Optional input schema for type coercion.
   * Format: {"fieldName": {"type": "number|integer|boolean|string|array|object"}}
   * When provided, input values will be coerced to match their schema types.
   * This is useful when inputs are received as strings (e.g., from JSON) but need to be numbers, booleans, etc.
   */
  inputSchema?: InputMaybe<Scalars['Json']['input']>;
  /** Input values as JSON object */
  inputs: Scalars['Json']['input'];
  /** Task specification as protobuf JSON (full task node data) */
  task: Scalars['Json']['input'];
};

/** Input for executing a workflow */
export type ExecuteWorkflowInput = {
  /** Input parameters for the workflow */
  inputs?: InputMaybe<Scalars['Json']['input']>;
  /** Additional metadata for the execution */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** ID of the workflow to execute */
  workflowId: Scalars['ID']['input'];
};

/** Execution event */
export type ExecutionEvent = {
  __typename?: 'ExecutionEvent';
  /** Type of event */
  eventType?: Maybe<Scalars['String']['output']>;
  /** Event ID */
  id: Scalars['String']['output'];
  /** Event message */
  message?: Maybe<Scalars['String']['output']>;
  /** When the event occurred */
  occurredAt?: Maybe<Scalars['String']['output']>;
  /** Execution phase */
  phase?: Maybe<Scalars['String']['output']>;
  /** Producer of the event */
  producerId?: Maybe<Scalars['String']['output']>;
};

/** Filter for listing executions */
export type ExecutionFilter = {
  /** Filter by status */
  status?: InputMaybe<ExecutionStatus>;
  /** Filter by user who triggered */
  triggeredById?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by workflow */
  workflowDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Execution logs result */
export type ExecutionLogs = {
  __typename?: 'ExecutionLogs';
  /** Token for fetching more logs */
  continuationToken?: Maybe<Scalars['String']['output']>;
  /** Whether more logs are available */
  hasMore: Scalars['Boolean']['output'];
  /** Log lines */
  lines: Array<LogLine>;
  /** Additional metadata about the logs */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Where logs came from */
  source: LogSource;
};

/** A signal waiting for input in a workflow execution */
export type ExecutionSignal = {
  __typename?: 'ExecutionSignal';
  /** When the signal was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether this signal has been set */
  hasValue: Scalars['Boolean']['output'];
  /** Human-readable message explaining what approval is needed */
  message?: Maybe<Scalars['String']['output']>;
  /** The workflow node ID that created this signal */
  nodeId?: Maybe<Scalars['String']['output']>;
  /** JSON schema describing the expected structure for object types */
  schema?: Maybe<Scalars['Json']['output']>;
  /** The unique identifier for this signal */
  signalId: Scalars['String']['output'];
  /** When the signal will timeout */
  timeoutAt?: Maybe<Scalars['DateTime']['output']>;
  /** The expected value type for this signal */
  type: Scalars['String']['output'];
  /** The current value (if set) */
  value?: Maybe<Scalars['Json']['output']>;
};

/** Workflow execution status - Generated from protobuf ExecutionStatus enum */
export enum ExecutionStatus {
  /** User requested abort */
  Aborted = 'ABORTED',
  /** Execution failed */
  Failed = 'FAILED',
  /** Paused (waiting for gate signal) */
  Paused = 'PAUSED',
  /** Waiting for dependencies */
  Pending = 'PENDING',
  /** Queued for execution */
  Queued = 'QUEUED',
  /** Currently executing */
  Running = 'RUNNING',
  /** Completed successfully */
  Succeeded = 'SUCCEEDED',
  /** Timeout exceeded */
  TimedOut = 'TIMED_OUT',
  /** Unspecified status */
  Unspecified = 'UNSPECIFIED'
}

/** Detailed execution status information */
export type ExecutionStatusDetail = {
  __typename?: 'ExecutionStatusDetail';
  /** Status message or error details */
  message?: Maybe<Scalars['String']['output']>;
  /** The execution phase */
  phase: Scalars['String']['output'];
  /** The execution status */
  status: ExecutionStatus;
  /** When the status was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Event for execution status changes */
export type ExecutionStatusEvent = {
  __typename?: 'ExecutionStatusEvent';
  /** The execution ID */
  executionId: Scalars['ID']['output'];
  /** Status change message */
  message?: Maybe<Scalars['String']['output']>;
  /** Additional event metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** New status */
  newStatus: ExecutionStatus;
  /** Previous status */
  oldStatus?: Maybe<ExecutionStatus>;
  /** When the status changed */
  timestamp: Scalars['DateTime']['output'];
};

/** Update event for execution or node status changes */
export type ExecutionUpdate = {
  __typename?: 'ExecutionUpdate';
  /** What changed */
  changeType: Scalars['String']['output'];
  /** Updated execution (for execution_update type) */
  execution?: Maybe<WorkflowExecution>;
  /** Updated node (for node_update type) */
  nodeExecution?: Maybe<NodeExecution>;
  /** When the update occurred */
  timestamp: Scalars['DateTime']['output'];
  /** Type of update */
  type: ExecutionUpdateType;
};

/** Type of execution update */
export enum ExecutionUpdateType {
  /** Execution-level status change */
  ExecutionUpdate = 'EXECUTION_UPDATE',
  /** Node execution status change */
  NodeUpdate = 'NODE_UPDATE'
}

/** Result of generating a file upload URL */
export type FileUploadUrlResult = {
  __typename?: 'FileUploadUrlResult';
  /** Object key in the storage bucket */
  key: Scalars['String']['output'];
  /** S3 URI that will reference the uploaded file */
  s3Uri: Scalars['String']['output'];
  /** Presigned URL for uploading the file */
  uploadUrl: Scalars['String']['output'];
};

/** A file in the conversation's filesystem */
export type FilesystemFile = {
  __typename?: 'FilesystemFile';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** The filesystem state for a conversation */
export type FilesystemState = {
  __typename?: 'FilesystemState';
  currentDirectory?: Maybe<Scalars['String']['output']>;
  files: Array<FilesystemFile>;
};

/** A folder for organizing agents (tenant-scoped, accessible to all users in the tenant) */
export type Folder = {
  __typename?: 'Folder';
  config?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Input for granting agent access to a secret */
export type GrantAgentAccessInput = {
  agentId: Scalars['ID']['input'];
  secretId: Scalars['ID']['input'];
};

/** Input for granting multiple agents access to a secret */
export type GrantMultipleAgentsAccessInput = {
  agentIds: Array<Scalars['ID']['input']>;
  secretId: Scalars['ID']['input'];
};

/** EventRegistry PubSub event for Handoff daemon/reactive workflows */
export type HandoffEvent = {
  __typename?: 'HandoffEvent';
  /** Event payload data */
  data?: Maybe<Scalars['Json']['output']>;
  /** Type of handoff event (e.g., 'event_published', 'task_status') */
  eventType: Scalars['String']['output'];
  /** The execution ID */
  executionId?: Maybe<Scalars['String']['output']>;
  /** The task ID if event is task-specific */
  taskId?: Maybe<Scalars['String']['output']>;
  /** When the event occurred */
  timestamp: Scalars['DateTime']['output'];
};

/** An image URL within a message part */
export type ImageUrl = {
  __typename?: 'ImageUrl';
  detail?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ImageUrlInput = {
  detail?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** An image URL message part */
export type ImageUrlPart = {
  __typename?: 'ImageUrlPart';
  id: Scalars['ID']['output'];
  imageUrl: ImageUrl;
};

/** Input for importing a workflow */
export type ImportWorkflowInput = {
  /** Import as draft (default: true) */
  asDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional new name for the imported workflow */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional new version for the imported workflow */
  version?: InputMaybe<Scalars['String']['input']>;
  /** Workflow data from export */
  workflowData: Scalars['Json']['input'];
};

/** Input for installing an MCP server */
export type InstallMcpServerInput = {
  /** Consent mode: 'auto', 'manual', or 'per_request' */
  consentMode?: InputMaybe<Scalars['String']['input']>;
  /** Additional instance metadata */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** Authentication secrets (stored encrypted) */
  secrets?: InputMaybe<Scalars['Json']['input']>;
  /** Platform server ID or slug to install */
  serverId: Scalars['ID']['input'];
  /** Request timeout in milliseconds */
  timeout?: InputMaybe<Scalars['Int']['input']>;
  /** Optional custom URL (overrides default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A job configuration that defines scheduled tasks */
export type JobConfig = Node & {
  __typename?: 'JobConfig';
  agent?: Maybe<Agent>;
  agentId: Scalars['String']['output'];
  cronExpr?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  jobInstances?: Maybe<Array<Maybe<JobInstance>>>;
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  tenant?: Maybe<Tenant>;
  toolsApproved: Array<Scalars['String']['output']>;
  /** Triggers that target this job */
  triggers?: Maybe<Array<Maybe<Trigger>>>;
  updatedAt: Scalars['NaiveDateTime']['output'];
  user?: Maybe<User>;
};

/** Connection type for paginated JobConfig */
export type JobConfigConnection = {
  __typename?: 'JobConfigConnection';
  edges?: Maybe<Array<Maybe<JobConfigEdge>>>;
  pageInfo: PageInfo;
};

/** Aggregated count of job configurations grouped by agent */
export type JobConfigCountByAgent = {
  __typename?: 'JobConfigCountByAgent';
  agentId: Scalars['ID']['output'];
  agentName?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
};

export type JobConfigEdge = {
  __typename?: 'JobConfigEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<JobConfig>;
};

/** Filter input for job configurations */
export type JobConfigFilter = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for creating a job configuration */
export type JobConfigInput = {
  agentId: Scalars['String']['input'];
  cronExpr?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  toolsApproved?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for updating a job configuration */
export type JobConfigUpdateInput = {
  agentId?: InputMaybe<Scalars['String']['input']>;
  cronExpr?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  toolsApproved?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** An instance of a job execution */
export type JobInstance = Node & {
  __typename?: 'JobInstance';
  agent?: Maybe<Agent>;
  completedAt?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  isRead: Scalars['Boolean']['output'];
  jobConfig: JobConfig;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: JobInstanceStatus;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Connection type for paginated JobInstance */
export type JobInstanceConnection = {
  __typename?: 'JobInstanceConnection';
  edges?: Maybe<Array<Maybe<JobInstanceEdge>>>;
  pageInfo: PageInfo;
};

/** Aggregated count of job instances grouped by agent */
export type JobInstanceCountByAgent = {
  __typename?: 'JobInstanceCountByAgent';
  agentId: Scalars['ID']['output'];
  agentName?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
};

/** Filter input for job instance counts */
export type JobInstanceCountFilter = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  jobConfigId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<JobInstanceStatus>;
};

export type JobInstanceEdge = {
  __typename?: 'JobInstanceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<JobInstance>;
};

/** Filter input for job instances */
export type JobInstanceFilter = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  jobConfigId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<JobInstanceStatus>;
};

/** Job instance status enumeration */
export enum JobInstanceStatus {
  /** Job is waiting for tool approval */
  AwaitingConsent = 'AWAITING_CONSENT',
  /** Job was cancelled */
  Cancelled = 'CANCELLED',
  /** Job completed successfully */
  Completed = 'COMPLETED',
  /** Job failed with an error */
  Failed = 'FAILED',
  /** Job is queued for execution */
  Pending = 'PENDING',
  /** Job is currently running */
  Running = 'RUNNING'
}

/** Keycloak configuration */
export type KeycloakConfig = {
  __typename?: 'KeycloakConfig';
  clientId?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A knowledge base containing documents for RAG */
export type KnowledgeBase = {
  __typename?: 'KnowledgeBase';
  config?: Maybe<Scalars['Json']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentCount?: Maybe<Scalars['Int']['output']>;
  documents?: Maybe<Array<KnowledgeBaseDocument>>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  name: Scalars['String']['output'];
  status: KnowledgeBaseStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** A document within a knowledge base */
export type KnowledgeBaseDocument = {
  __typename?: 'KnowledgeBaseDocument';
  contentType: Scalars['String']['output'];
  fileHash: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['String']['output']>;
  knowledgeBaseId: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  originalFilename: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['String']['output']>;
  processingError?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Filter for listing knowledge bases */
export type KnowledgeBaseFilterInput = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<KnowledgeBaseStatus>;
};

/** Result from querying knowledge bases */
export type KnowledgeBaseQueryResult = {
  __typename?: 'KnowledgeBaseQueryResult';
  content: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  sourceDocuments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Knowledge base status enumeration */
export enum KnowledgeBaseStatus {
  /** Knowledge base is active and available */
  Active = 'ACTIVE',
  /** Knowledge base encountered an error */
  Error = 'ERROR',
  /** Knowledge base is inactive */
  Inactive = 'INACTIVE',
  /** Knowledge base is starting up */
  Starting = 'STARTING',
  /** Knowledge base is shutting down */
  Stopping = 'STOPPING'
}

/** Knowledge base update event */
export type KnowledgeBaseUpdateEvent = {
  __typename?: 'KnowledgeBaseUpdateEvent';
  document?: Maybe<KnowledgeBaseDocument>;
  knowledgeBase?: Maybe<KnowledgeBase>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  type: UpdateEventType;
};

/** Filter input for paginated agent list */
export type ListAgentsFilter = {
  enabledStatus?: InputMaybe<EnabledStatus>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filter input for paginated conversation list */
export type ListConversationsFilter = {
  agentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search conversations by title (case-insensitive partial match) */
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ConversationType>;
};

/** Filter input for paginated document list */
export type ListDocumentsFilter = {
  /** Filter documents from conversations where this agent has participated */
  agentId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Log level */
export enum LogLevel {
  /** Debug level */
  Debug = 'DEBUG',
  /** Error level */
  Error = 'ERROR',
  /** Info level */
  Info = 'INFO',
  /** Warning level */
  Warn = 'WARN'
}

/** Single log line */
export type LogLine = {
  __typename?: 'LogLine';
  /** Log level if parseable */
  level?: Maybe<LogLevel>;
  /** The log message content */
  message: Scalars['String']['output'];
  /** Additional metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Stream source (stdout/stderr) */
  source?: Maybe<LogStreamSource>;
  /** When the log was generated */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

/** Log source type */
export enum LogSource {
  /** CloudWatch logs */
  Cloudwatch = 'CLOUDWATCH',
  /** Handoff workflow engine logs */
  Handoff = 'HANDOFF',
  /** Kubernetes pod logs */
  Kubernetes = 'KUBERNETES',
  /** S3 stored logs */
  S3 = 'S3'
}

/** Log stream source */
export enum LogStreamSource {
  /** Standard error */
  Stderr = 'STDERR',
  /** Standard output */
  Stdout = 'STDOUT'
}

/** Logout result */
export type LogoutResult = {
  __typename?: 'LogoutResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Filter input for MCP catalog servers */
export type McpCatalogFilterInput = {
  /** Filter by category */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Filter by published status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search in name and description */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Tenant MCP server installation */
export type McpCatalogInstance = {
  __typename?: 'McpCatalogInstance';
  /** Consent mode (auto, manual, per_request) */
  consentMode?: Maybe<Scalars['String']['output']>;
  /** Whether instance is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Unique instance identifier */
  id: Scalars['ID']['output'];
  /** Creation timestamp */
  insertedAt: Scalars['DateTime']['output'];
  /** Installation timestamp */
  installedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who installed the server */
  installedById?: Maybe<Scalars['ID']['output']>;
  /** Instance-specific metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Platform server definition */
  server?: Maybe<McpCatalogServer>;
  /** Platform server identifier */
  serverId: Scalars['ID']['output'];
  /** Tenant identifier */
  tenantId: Scalars['ID']['output'];
  /** Request timeout in milliseconds */
  timeout?: Maybe<Scalars['Int']['output']>;
  /** Per-tool configuration map (tool_name => {enabled, consent_mode}) */
  toolConfigs?: Maybe<Scalars['Json']['output']>;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Instance-specific URL (overrides default) */
  url?: Maybe<Scalars['String']['output']>;
};

/** Platform MCP server catalog entry */
export type McpCatalogServer = {
  __typename?: 'McpCatalogServer';
  /** Whether authentication is required */
  authRequired: Scalars['Boolean']['output'];
  /** Server capabilities */
  capabilities?: Maybe<Scalars['Json']['output']>;
  /** Server category (e.g., 'developer_tools', 'ai_services') */
  category?: Maybe<Scalars['String']['output']>;
  /** When server was deprecated */
  deprecatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Server description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique server identifier */
  id: Scalars['ID']['output'];
  /** Creation timestamp */
  insertedAt: Scalars['DateTime']['output'];
  /** Additional server metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Display name */
  name: Scalars['String']['output'];
  /** When server was published */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** URL-friendly identifier */
  slug: Scalars['String']['output'];
  /** Supported authentication methods */
  supportedAuthTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Last update timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** Default server URL */
  url?: Maybe<Scalars['String']['output']>;
  /** Server vendor/provider */
  vendor?: Maybe<Scalars['String']['output']>;
};

/** Filter input for MCP server instances */
export type McpInstanceFilterInput = {
  /** Filter by enabled status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by platform server ID */
  serverId?: InputMaybe<Scalars['ID']['input']>;
};

/** MCP server configuration for a tenant */
export type McpServer = {
  __typename?: 'McpServer';
  /** Whether authentication is required */
  authRequired: Scalars['Boolean']['output'];
  /** JSON Schema defining required authentication fields. Used by UI to generate forms dynamically. Example: {"type": "object", "required": ["token"], "properties": {...}} */
  authSchema?: Maybe<Scalars['Json']['output']>;
  /** Server capabilities */
  capabilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether this server is coming soon */
  comingSoon: Scalars['Boolean']['output'];
  /** Whether this server is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Map of header names to template strings */
  headers?: Maybe<Scalars['Json']['output']>;
  /** Template showing how secrets are used in HTTP headers. Example: {"Authorization": "Bearer {{secrets.token}}"} */
  headersTemplate?: Maybe<Scalars['Json']['output']>;
  /** Map of secret names to secret IDs */
  secrets?: Maybe<Scalars['Json']['output']>;
  /** Supported authentication types */
  supportedAuthTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Description of the MCP server */
  templateDescription?: Maybe<Scalars['String']['output']>;
  /** MCP template identifier */
  templateId: Scalars['String']['output'];
  /** Human-readable name */
  templateName: Scalars['String']['output'];
  /** Server URL (if custom) */
  url?: Maybe<Scalars['String']['output']>;
};

/** Result of MCP server mutation */
export type McpServerResult = {
  __typename?: 'McpServerResult';
  /** Optional message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Number of tools available from the server */
  toolCount?: Maybe<Scalars['Int']['output']>;
  /** Validation details or error message */
  validationMessage?: Maybe<Scalars['String']['output']>;
  /** Connection validation status: success, warning, error */
  validationStatus?: Maybe<Scalars['String']['output']>;
};

/** MCP tool definition from an MCP server */
export type McpTool = {
  __typename?: 'McpTool';
  /** Tool description */
  description: Scalars['String']['output'];
  /** JSON Schema for tool input parameters */
  inputSchema: Scalars['Json']['output'];
  /** Tool name (unique identifier) */
  name: Scalars['String']['output'];
  /** Optional display title */
  title?: Maybe<Scalars['String']['output']>;
};

/** A chat message */
export type Message = Node & {
  __typename?: 'Message';
  conversationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['Json']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  parts: Array<MessagePart>;
  profile?: Maybe<Profile>;
  timestamp: Scalars['String']['output'];
};

/** A message part that can be text, a tool call, an image URL, or AI thinking */
export type MessagePart = ImageUrlPart | TextPart | ThinkingPart | ToolCallPart;

export type MessagePartInput = {
  imageUrl?: InputMaybe<ImageUrlInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: MessagePartType;
};

/** Message part streaming event for real-time text updates */
export type MessagePartStreamingEvent = {
  __typename?: 'MessagePartStreamingEvent';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
};

export enum MessagePartType {
  /** Image URL content */
  ImageUrl = 'IMAGE_URL',
  /** Text content */
  Text = 'TEXT'
}

/** Model code name enumeration */
export enum ModelCode {
  /** Cost-effective JSON extraction */
  CheapJson = 'CHEAP_JSON',
  /** Fast and efficient (Claude Haiku 4.5) */
  Fast = 'FAST',
  /** Fast JSON extraction */
  FastJson = 'FAST_JSON',
  /** Premium quality (Claude Sonnet 4.5) */
  Premium = 'PREMIUM',
  /** Smart and capable (Claude 3.7 Sonnet) */
  Smart = 'SMART'
}

export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

/** Task execution within a workflow execution */
export type NodeExecution = {
  __typename?: 'NodeExecution';
  /** Summary of sub-task statuses for array nodes */
  arrayTaskStatuses?: Maybe<ArrayTaskStatusSummary>;
  /** Artifacts produced by this task execution */
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  /** Current attempt number */
  attempt?: Maybe<Scalars['Int']['output']>;
  /** Cache status for this node */
  cacheStatus?: Maybe<Scalars['String']['output']>;
  /** Display name for the node */
  displayName: Scalars['String']['output'];
  /** Node execution duration */
  duration?: Maybe<Scalars['String']['output']>;
  /** Error message if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** S3 URI for input data */
  inputUri?: Maybe<Scalars['String']['output']>;
  /** Node inputs */
  inputs?: Maybe<Scalars['Json']['output']>;
  /** URI to node logs */
  logsUri?: Maybe<Scalars['String']['output']>;
  /** Node execution metadata including spec_node_id for mapping */
  metadata?: Maybe<NodeExecutionMetadata>;
  /** Node ID from workflow execution */
  nodeId: Scalars['String']['output'];
  /** S3 URI for output data */
  outputUri?: Maybe<Scalars['String']['output']>;
  /** Node outputs */
  outputs?: Maybe<Scalars['Json']['output']>;
  /** Execution phase */
  phase: Scalars['String']['output'];
  /** When the node started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Subworkflow execution information for TASK_SUBWORKFLOW tasks */
  subworkflowExecutionInfo?: Maybe<SubworkflowExecutionInfo>;
  /** Sub-task executions for array nodes */
  taskExecutions?: Maybe<Array<Maybe<TaskExecution>>>;
  /** When the node was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Metadata for workflow node (subworkflow) executions */
  workflowNodeMetadata?: Maybe<WorkflowNodeMetadata>;
};

/** Node execution metadata for mapping execution nodes to workflow spec */
export type NodeExecutionMetadata = {
  __typename?: 'NodeExecutionMetadata';
  /** Whether this is an array node */
  isArray?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a dynamic node */
  isDynamic?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this node is a parent node */
  isParentNode?: Maybe<Scalars['Boolean']['output']>;
  /** The node ID from the workflow spec (maps random execution IDs to spec) */
  specNodeId?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Result of importing a persona bundle */
export type PersonaBundleImportResult = {
  __typename?: 'PersonaBundleImportResult';
  /** The imported persona/agent */
  persona?: Maybe<Agent>;
  /** Warnings about items needing manual setup (e.g., KBs) */
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The imported workflows */
  workflows?: Maybe<Array<Maybe<WorkflowDefinition>>>;
};

/** Document processing tracking response */
export type ProcessingTrackResponse = {
  __typename?: 'ProcessingTrackResponse';
  documents?: Maybe<Array<Maybe<DocumentProcessingStatus>>>;
  statusSummary?: Maybe<Scalars['Json']['output']>;
  totalCount: Scalars['Int']['output'];
  trackId: Scalars['String']['output'];
};

/** A profile associated with a message */
export type Profile = {
  __typename?: 'Profile';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: ProfileType;
};

/** Profile type enumeration */
export enum ProfileType {
  /** Agent profile */
  Agent = 'AGENT',
  /** User profile */
  User = 'USER'
}

/** Public configuration available without authentication */
export type PublicConfig = {
  __typename?: 'PublicConfig';
  bypassKeycloakAuth: Scalars['Boolean']['output'];
  keycloak: KeycloakConfig;
};

/** Input for registering client tools */
export type RegisterClientToolsInput = {
  conversationId: Scalars['ID']['input'];
  tools: Array<ClientToolSpec>;
};

/** Result of register client tools mutation */
export type RegisterClientToolsResult = {
  __typename?: 'RegisterClientToolsResult';
  message?: Maybe<Scalars['String']['output']>;
  registeredCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for resolving consent for multiple tool calls */
export type ResolveConsentInput = {
  conversationId: Scalars['ID']['input'];
  decisions: Array<ConsentDecisionInput>;
};

/** Result of resolve consent mutation */
export type ResolveConsentResult = {
  __typename?: 'ResolveConsentResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for revoking agent access to a secret */
export type RevokeAgentAccessInput = {
  agentId: Scalars['ID']['input'];
  secretId: Scalars['ID']['input'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Add a target to a trigger */
  addTriggerTarget?: Maybe<TriggerTargetMutationResult>;
  /** Approve a pending signal to resume workflow execution */
  approveSignal?: Maybe<SignalActionResult>;
  /** Ask a question */
  ask?: Maybe<ConversationResponse>;
  /** Attach a knowledge base to an agent */
  attachKnowledgeBaseToAgent?: Maybe<AgentKnowledgeBase>;
  /** Build a workflow specification using the DSL (helper mutation) */
  buildWorkflowSpec?: Maybe<WorkflowSpecResult>;
  /** Cancel a running workflow execution */
  cancelExecution?: Maybe<WorkflowExecution>;
  /** Create a new agent */
  createAgent?: Maybe<Agent>;
  /** Create a new conversation */
  createConversation?: Maybe<Conversation>;
  /** Create a new folder in the tenant (accessible to all users in the tenant) */
  createFolder?: Maybe<Folder>;
  /** Create a new job configuration */
  createJobConfig?: Maybe<JobConfig>;
  /** Create a new knowledge base */
  createKnowledgeBase?: Maybe<KnowledgeBase>;
  /** Create a new secret */
  createSecret?: Maybe<Secret>;
  /** Create a new trigger */
  createTrigger?: Maybe<TriggerMutationResult>;
  /** Create a new webhook endpoint */
  createWebhookEndpoint?: Maybe<WebhookEndpointResult>;
  /** Create a new workflow definition */
  createWorkflow?: Maybe<WorkflowDefinition>;
  /** Create a workflow from a template using the Instantiator */
  createWorkflowFromTemplate?: Maybe<WorkflowDefinition>;
  /** Create a new version of an existing workflow */
  createWorkflowVersion?: Maybe<WorkflowDefinition>;
  /** Delete a conversation */
  deleteConversation?: Maybe<Conversation>;
  /** Delete a folder (any user in the tenant can delete) */
  deleteFolder?: Maybe<Folder>;
  /** Delete a job configuration */
  deleteJobConfig?: Maybe<JobConfig>;
  /** Delete a knowledge base */
  deleteKnowledgeBase?: Maybe<Scalars['Boolean']['output']>;
  /** Delete My Workspace: permanently deactivate user and their personal PLG workspace. This is irreversible. */
  deleteMyWorkspace?: Maybe<DeleteWorkspaceResult>;
  /** Delete a secret */
  deleteSecret?: Maybe<Secret>;
  /** Delete tenant token limit configuration (admin only) */
  deleteTenantLimitConfig?: Maybe<TokenLimitConfigResult>;
  /** Delete a trigger */
  deleteTrigger?: Maybe<TriggerDeleteResult>;
  /** Delete user-specific token limit override (admin only) */
  deleteUserLimitConfig?: Maybe<TokenLimitConfigResult>;
  /** Delete a webhook endpoint */
  deleteWebhookEndpoint?: Maybe<DeleteWebhookEndpointResult>;
  /** Delete (deprecate) a workflow definition */
  deleteWorkflow?: Maybe<WorkflowDefinition>;
  /** Detach a knowledge base from an agent */
  detachKnowledgeBaseFromAgent?: Maybe<Scalars['Boolean']['output']>;
  /** Dev auto-login: bypass Keycloak for local development (requires MATRIX_BYPASS_KEYCLOAK_AUTH=true) */
  devAutoLogin?: Maybe<UserDetails>;
  /** Disable MCP instance */
  disableMcpCatalogInstance?: Maybe<McpCatalogInstance>;
  /** Disable an MCP server for the tenant */
  disableMcpServer?: Maybe<McpServerResult>;
  /** Disable a trigger */
  disableTrigger?: Maybe<TriggerMutationResult>;
  /** Enable MCP instance */
  enableMcpCatalogInstance?: Maybe<McpCatalogInstance>;
  /** Enable an MCP server for the tenant */
  enableMcpServer?: Maybe<McpServerResult>;
  /** Enable a trigger */
  enableTrigger?: Maybe<TriggerMutationResult>;
  /** Execute a single task with provided inputs (for testing) */
  executeTask?: Maybe<TaskExecutionResult>;
  /** Execute a workflow with the provided inputs */
  executeWorkflow?: Maybe<WorkflowExecution>;
  /** Export a workflow definition as JSON */
  exportWorkflow?: Maybe<WorkflowExportResult>;
  /** Generate a presigned URL for uploading a file to workflow storage */
  generateFileUploadUrl?: Maybe<FileUploadUrlResult>;
  /** Grant an agent access to a secret */
  grantAgentSecretAccess?: Maybe<Secret>;
  /** Grant multiple agents access to a secret */
  grantMultipleAgentsSecretAccess?: Maybe<Secret>;
  /** Import an agent from exported JSON data (standalone, no dependency handling) */
  importAgent?: Maybe<Agent>;
  /** Import a persona bundle including all workflows, handling dependencies automatically */
  importPersonaBundle?: Maybe<PersonaBundleImportResult>;
  /** Import a workflow definition from JSON */
  importWorkflow?: Maybe<WorkflowDefinition>;
  /** Install MCP server for tenant */
  installMcpCatalogServer?: Maybe<McpCatalogInstance>;
  /** Logout: invalidate the current session */
  logout?: Maybe<LogoutResult>;
  /** Mark a job instance as read */
  markJobInstanceAsRead?: Maybe<JobInstance>;
  /** Mark a job instance as unread by removing the read status */
  markJobInstanceAsUnread?: Maybe<JobInstance>;
  /** Permanently delete a document from a knowledge base */
  permanentlyDeleteDocument?: Maybe<Scalars['Boolean']['output']>;
  /** Publish a workflow definition to make it executable */
  publishWorkflow?: Maybe<WorkflowDefinition>;
  /** Register client-provided tools for a conversation */
  registerClientTools?: Maybe<RegisterClientToolsResult>;
  /** Reject a pending signal to fail the workflow execution */
  rejectSignal?: Maybe<SignalActionResult>;
  /** Remove a document from a knowledge base (soft delete) */
  removeDocument?: Maybe<KnowledgeBaseDocument>;
  /** Remove a target from a trigger */
  removeTriggerTarget?: Maybe<TriggerTargetDeleteResult>;
  /** Resolve consent for multiple tool calls with flexible decisions (approve, deny, or modify parameters) */
  resolveConsent?: Maybe<ResolveConsentResult>;
  /** Resume a workflow execution from its last persisted state after a crash or restart */
  resumeExecution?: Maybe<WorkflowExecution>;
  /** Retry a failed, aborted, or timed out workflow execution */
  retryExecution?: Maybe<WorkflowExecution>;
  /** Revoke an agent's access to a secret */
  revokeAgentSecretAccess?: Maybe<Secret>;
  /** Set a signal value to resume a waiting workflow execution */
  setSignal?: Maybe<SetSignalResult>;
  /** Set tenant token limit configuration (admin only) */
  setTenantLimitConfig?: Maybe<TokenLimitConfigResult>;
  /** Set tool call policy (approve/deny) for an agent in a conversation */
  setToolCallPolicy?: Maybe<ToolCallPolicyResult>;
  /** Inject a tool response from a client-handled tool */
  setToolResult?: Maybe<SetToolResultResult>;
  /** Set user-specific token limit override (admin only) */
  setUserLimitConfig?: Maybe<TokenLimitConfigResult>;
  /** Stop an agent's stream */
  stopAgentStream?: Maybe<Scalars['Boolean']['output']>;
  /** Generate a summary of a conversation using AI */
  summarizeConversation?: Maybe<ConversationSummaryResult>;
  /** Manually fire a trigger for testing. Creates an execution record and dispatches to all enabled targets. */
  testTrigger?: Maybe<TestTriggerResult>;
  /** Uninstall MCP server instance */
  uninstallMcpCatalogServer?: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing agent */
  updateAgent?: Maybe<Agent>;
  /** Update agent's tool configuration */
  updateAgentTools?: Maybe<Agent>;
  /** Update the system prompt for an agent in a specific conversation */
  updateConversationSystemPrompt?: Maybe<Conversation>;
  /** Update the title of a conversation */
  updateConversationTitle?: Maybe<Conversation>;
  /** Update an existing folder (any user in the tenant can update) */
  updateFolder?: Maybe<Folder>;
  /** Update a job configuration */
  updateJobConfig?: Maybe<JobConfig>;
  /** Update an existing knowledge base */
  updateKnowledgeBase?: Maybe<KnowledgeBase>;
  /** Update the status of a knowledge base */
  updateKnowledgeBaseStatus?: Maybe<KnowledgeBase>;
  /** Update MCP instance configuration */
  updateMcpCatalogInstance?: Maybe<McpCatalogInstance>;
  /** Update an MCP server configuration */
  updateMcpServer?: Maybe<McpServerResult>;
  /** Update per-tool configurations for an MCP server instance */
  updateMcpToolConfigs?: Maybe<McpCatalogInstance>;
  /** Update an existing secret */
  updateSecret?: Maybe<Secret>;
  /** Update a trigger */
  updateTrigger?: Maybe<TriggerMutationResult>;
  /** Update a trigger target */
  updateTriggerTarget?: Maybe<TriggerTargetMutationResult>;
  /** Update a team member's role */
  updateUserRole?: Maybe<TeamMember>;
  /** Update an existing webhook endpoint */
  updateWebhookEndpoint?: Maybe<WebhookEndpointResult>;
  /** Update an existing workflow definition */
  updateWorkflow?: Maybe<WorkflowDefinition>;
  /** Upload a document to a knowledge base */
  uploadDocument?: Maybe<KnowledgeBaseDocument>;
};


export type RootMutationTypeAddTriggerTargetArgs = {
  input: AddTriggerTargetInput;
  triggerId: Scalars['ID']['input'];
};


export type RootMutationTypeApproveSignalArgs = {
  executionId: Scalars['ID']['input'];
  signalId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Json']['input']>;
};


export type RootMutationTypeAskArgs = {
  input: ConversationInput;
};


export type RootMutationTypeAttachKnowledgeBaseToAgentArgs = {
  input: AttachKnowledgeBaseInput;
};


export type RootMutationTypeBuildWorkflowSpecArgs = {
  input: BuildWorkflowSpecInput;
};


export type RootMutationTypeCancelExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCreateAgentArgs = {
  input?: InputMaybe<AgentInput>;
};


export type RootMutationTypeCreateConversationArgs = {
  input: CreateConversationInput;
};


export type RootMutationTypeCreateFolderArgs = {
  input: CreateFolderInput;
};


export type RootMutationTypeCreateJobConfigArgs = {
  input: JobConfigInput;
};


export type RootMutationTypeCreateKnowledgeBaseArgs = {
  input: CreateKnowledgeBaseInput;
};


export type RootMutationTypeCreateSecretArgs = {
  input: CreateSecretInput;
};


export type RootMutationTypeCreateTriggerArgs = {
  input: CreateTriggerInput;
};


export type RootMutationTypeCreateWebhookEndpointArgs = {
  input: CreateWebhookEndpointInput;
};


export type RootMutationTypeCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};


export type RootMutationTypeCreateWorkflowFromTemplateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeCreateWorkflowVersionArgs = {
  version: Scalars['String']['input'];
  workflowId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteConversationArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteFolderArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteJobConfigArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteSecretArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteUserLimitConfigArgs = {
  userId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDetachKnowledgeBaseFromAgentArgs = {
  agentId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
};


export type RootMutationTypeDisableMcpCatalogInstanceArgs = {
  instanceId: Scalars['ID']['input'];
};


export type RootMutationTypeDisableMcpServerArgs = {
  templateId: Scalars['String']['input'];
};


export type RootMutationTypeDisableTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeEnableMcpCatalogInstanceArgs = {
  instanceId: Scalars['ID']['input'];
};


export type RootMutationTypeEnableMcpServerArgs = {
  input: EnableMcpServerInput;
};


export type RootMutationTypeEnableTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeExecuteTaskArgs = {
  input: ExecuteTaskInput;
};


export type RootMutationTypeExecuteWorkflowArgs = {
  input: ExecuteWorkflowInput;
};


export type RootMutationTypeExportWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeGenerateFileUploadUrlArgs = {
  filename: Scalars['String']['input'];
};


export type RootMutationTypeGrantAgentSecretAccessArgs = {
  input: GrantAgentAccessInput;
};


export type RootMutationTypeGrantMultipleAgentsSecretAccessArgs = {
  input: GrantMultipleAgentsAccessInput;
};


export type RootMutationTypeImportAgentArgs = {
  exportData: Scalars['Json']['input'];
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  workflowIdMapping?: InputMaybe<Scalars['Json']['input']>;
};


export type RootMutationTypeImportPersonaBundleArgs = {
  bundle: Scalars['Json']['input'];
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeImportWorkflowArgs = {
  input: ImportWorkflowInput;
};


export type RootMutationTypeInstallMcpCatalogServerArgs = {
  input: InstallMcpServerInput;
};


export type RootMutationTypeMarkJobInstanceAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeMarkJobInstanceAsUnreadArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypePermanentlyDeleteDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type RootMutationTypePublishWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRegisterClientToolsArgs = {
  input: RegisterClientToolsInput;
};


export type RootMutationTypeRejectSignalArgs = {
  executionId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  signalId: Scalars['String']['input'];
};


export type RootMutationTypeRemoveDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveTriggerTargetArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeResolveConsentArgs = {
  input: ResolveConsentInput;
};


export type RootMutationTypeResumeExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRetryExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeRevokeAgentSecretAccessArgs = {
  input: RevokeAgentAccessInput;
};


export type RootMutationTypeSetSignalArgs = {
  executionId: Scalars['ID']['input'];
  signalId: Scalars['String']['input'];
  value: Scalars['Json']['input'];
};


export type RootMutationTypeSetTenantLimitConfigArgs = {
  config: TenantLimitConfigInput;
};


export type RootMutationTypeSetToolCallPolicyArgs = {
  input: ToolCallPolicyInput;
};


export type RootMutationTypeSetToolResultArgs = {
  input: SetToolResultInput;
};


export type RootMutationTypeSetUserLimitConfigArgs = {
  config: UserLimitConfigInput;
};


export type RootMutationTypeStopAgentStreamArgs = {
  agentId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};


export type RootMutationTypeSummarizeConversationArgs = {
  conversationId: Scalars['ID']['input'];
};


export type RootMutationTypeTestTriggerArgs = {
  id: Scalars['ID']['input'];
  payload?: InputMaybe<Scalars['Json']['input']>;
};


export type RootMutationTypeUninstallMcpCatalogServerArgs = {
  instanceId: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateAgentArgs = {
  input: UpdateAgentInput;
};


export type RootMutationTypeUpdateAgentToolsArgs = {
  agentId: Scalars['ID']['input'];
  tools: Scalars['Json']['input'];
};


export type RootMutationTypeUpdateConversationSystemPromptArgs = {
  agentId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  systemPrompt: Scalars['String']['input'];
};


export type RootMutationTypeUpdateConversationTitleArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type RootMutationTypeUpdateFolderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFolderInput;
};


export type RootMutationTypeUpdateJobConfigArgs = {
  id: Scalars['ID']['input'];
  input: JobConfigUpdateInput;
};


export type RootMutationTypeUpdateKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseInput;
};


export type RootMutationTypeUpdateKnowledgeBaseStatusArgs = {
  id: Scalars['ID']['input'];
  status: KnowledgeBaseStatus;
};


export type RootMutationTypeUpdateMcpCatalogInstanceArgs = {
  input: UpdateMcpInstanceInput;
};


export type RootMutationTypeUpdateMcpServerArgs = {
  input: UpdateMcpServerInput;
  templateId: Scalars['String']['input'];
};


export type RootMutationTypeUpdateMcpToolConfigsArgs = {
  input: UpdateMcpToolConfigsInput;
};


export type RootMutationTypeUpdateSecretArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSecretInput;
};


export type RootMutationTypeUpdateTriggerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTriggerInput;
};


export type RootMutationTypeUpdateTriggerTargetArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTriggerTargetInput;
};


export type RootMutationTypeUpdateUserRoleArgs = {
  id: Scalars['ID']['input'];
  role: UserRole;
};


export type RootMutationTypeUpdateWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWebhookEndpointInput;
};


export type RootMutationTypeUpdateWorkflowArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkflowInput;
};


export type RootMutationTypeUploadDocumentArgs = {
  input: UploadDocumentInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Get a specific agent */
  agent?: Maybe<Agent>;
  /** List all secrets an agent has access to */
  agentSecrets: Array<Secret>;
  /** Get agent's tool configuration */
  agentTools?: Maybe<Scalars['Json']['output']>;
  /** List user's agents */
  agents: Array<Agent>;
  /** List all agents that have access to a secret */
  agentsWithSecretAccess: Array<Agent>;
  /** Get a specific connector app by address */
  connectorApp?: Maybe<ConnectorApp>;
  /** List all apps from external connectors */
  connectorApps?: Maybe<Array<Maybe<ConnectorApp>>>;
  /** List all tools from a specific connector */
  connectorTools?: Maybe<Array<Maybe<ConnectorTool>>>;
  /** List all tools from external connectors, grouped by connector */
  connectorToolsGroups?: Maybe<Array<Maybe<ConnectorToolsGroup>>>;
  /** Get a conversation by ID */
  conversation?: Maybe<Conversation>;
  /** Get the filesystem state for a conversation */
  conversationFilesystem?: Maybe<FilesystemState>;
  /** Get the task tracking state for a conversation */
  conversationTasks?: Maybe<TaskTrackingState>;
  /** Get all conversations */
  conversations: Array<Conversation>;
  /** Get count of job configurations grouped by agent */
  countJobConfigsByAgent?: Maybe<Array<JobConfigCountByAgent>>;
  /** Get count of job instances grouped by agent with filters */
  countJobInstancesByAgent?: Maybe<Array<JobInstanceCountByAgent>>;
  /** Get a specific document from a conversation */
  document?: Maybe<Document>;
  /** Get a single workflow execution by ID */
  execution?: Maybe<WorkflowExecution>;
  /** Get a workflow execution by external execution ID (for child workflow lookups) */
  executionByExternalId?: Maybe<WorkflowExecution>;
  /** Get execution events for a specific execution */
  executionEvents?: Maybe<Array<Maybe<ExecutionEvent>>>;
  /** Get execution outputs for a completed execution */
  executionOutputs?: Maybe<Scalars['Json']['output']>;
  /** List workflow executions with pagination and filtering */
  executions?: Maybe<WorkflowExecutionConnection>;
  /** Export an agent to JSON format (standalone, no workflow embedding) */
  exportAgent?: Maybe<Scalars['Json']['output']>;
  /** Export a persona with all dependent workflows as a single bundle for cross-tenant migration */
  exportPersonaBundle?: Maybe<Scalars['Json']['output']>;
  /** Get a specific folder by ID within the tenant */
  folder?: Maybe<Folder>;
  /** List all folders in the tenant (accessible to all users in the tenant) */
  folders: Array<Folder>;
  /** Get a specific job configuration */
  getJobConfig?: Maybe<JobConfig>;
  /** Get a specific job instance by ID */
  getJobInstance?: Maybe<JobInstance>;
  /** Get a specific knowledge base */
  knowledgeBase?: Maybe<KnowledgeBase>;
  /** List documents in a specific knowledge base (requires knowledge_base_id in filter) */
  knowledgeBaseDocuments: Array<KnowledgeBaseDocument>;
  /** List all knowledge bases */
  knowledgeBases: Array<KnowledgeBase>;
  /** Get paginated list of agents with Relay connections */
  listAgents?: Maybe<AgentConnection>;
  /** List all job instances for the tenant with optional job config or agent filter (legacy) */
  listAllJobInstances?: Maybe<Array<JobInstance>>;
  /** Get paginated list of conversations with Relay connections */
  listConversations?: Maybe<ConversationConnection>;
  /** Get paginated list of documents with Relay connections */
  listDocuments?: Maybe<DocumentConnection>;
  /** List all job configurations with pagination */
  listJobConfigs?: Maybe<JobConfigConnection>;
  /** List job instances with pagination */
  listJobInstances?: Maybe<JobInstanceConnection>;
  /** List all MCP servers configured for the tenant */
  listMcpServers: Array<McpServer>;
  /** List all tools available from a specific MCP server */
  listMcpTools: Array<McpTool>;
  /** Get paginated list of secrets with Relay connections */
  listSecrets?: Maybe<SecretConnection>;
  /** List all triggers for the tenant with pagination */
  listTriggers?: Maybe<TriggerConnection>;
  /** List all webhook endpoints for the tenant */
  listWebhookEndpoints: Array<WebhookEndpoint>;
  /** Get MCP instance by ID */
  mcpCatalogInstance?: Maybe<McpCatalogInstance>;
  /** List tenant's installed MCP server instances */
  mcpCatalogInstances?: Maybe<Array<Maybe<McpCatalogInstance>>>;
  /** Get MCP server by ID or slug */
  mcpCatalogServer?: Maybe<McpCatalogServer>;
  /** List available MCP servers in the catalog */
  mcpCatalogServers?: Maybe<Array<Maybe<McpCatalogServer>>>;
  /** List available tools from an MCP server */
  mcpCatalogTools?: Maybe<Array<Maybe<McpTool>>>;
  /** Get my workflow executions */
  myExecutions?: Maybe<WorkflowExecutionConnection>;
  /** Get my workflow definitions */
  myWorkflows?: Maybe<WorkflowDefinitionConnection>;
  node?: Maybe<Node>;
  /** Fetch logs for a specific node execution */
  nodeExecutionLogs?: Maybe<ExecutionLogs>;
  /** Get public configuration (no authentication required) */
  publicConfig: PublicConfig;
  /** Query knowledge bases attached to an agent */
  queryAgentKnowledgeBases?: Maybe<KnowledgeBaseQueryResult>;
  /** Query a specific knowledge base */
  queryKnowledgeBase?: Maybe<KnowledgeBaseQueryResult>;
  /** Get a specific secret by ID */
  secret?: Maybe<Secret>;
  /** List system tools catalog grouped by category with tool details and consent modes */
  systemToolsCatalog?: Maybe<Scalars['Json']['output']>;
  /** Fetch logs for a specific task execution (ArrayNode sub-task) */
  taskExecutionLogs?: Maybe<ExecutionLogs>;
  /** Get all team members in the tenant */
  teamMembers?: Maybe<Array<TeamMember>>;
  /** Get current tenant token limit configuration (admin only) */
  tenantLimitConfig?: Maybe<TenantLimitConfig>;
  /** Get tenant-wide token usage statistics (aggregated across all users) */
  tenantUsageStats?: Maybe<TenantUsageStats>;
  /** List all users for the tenant from strike48 tenant */
  tenantUsers: Array<User>;
  /** Get current user's token usage statistics */
  tokenUsageStats?: Maybe<TokenUsageStats>;
  /** List all available system tools */
  tools: Array<Tool>;
  /** Get a specific trigger by ID */
  trigger?: Maybe<Trigger>;
  /** List executions for a specific trigger */
  triggerExecutions: Array<TriggerExecution>;
  /** List targets for a specific trigger */
  triggerTargets: Array<TriggerTarget>;
  /** List all triggers that target a specific job or workflow */
  triggersForTarget: Array<Trigger>;
  /** Get detailed token usage records for the current user */
  usageRecords?: Maybe<Array<Maybe<TokenUsageRecord>>>;
  /** Get the current user's details from session cache using Authorization Bearer JWT header */
  userDetails?: Maybe<UserDetails>;
  /** Get user-specific token limit configuration (admin only) */
  userLimitConfig?: Maybe<UserLimitConfig>;
  /** Get a specific webhook endpoint by ID */
  webhookEndpoint?: Maybe<WebhookEndpoint>;
  /** Get a single workflow definition by ID */
  workflow?: Maybe<WorkflowDefinition>;
  /** Get a single workflow template by ID */
  workflowTemplate?: Maybe<WorkflowTemplate>;
  /** Get workflow templates for creating new workflows */
  workflowTemplates?: Maybe<Array<WorkflowTemplate>>;
  /** Get lightweight workflow template summaries for list views */
  workflowTemplatesSummary?: Maybe<Array<WorkflowTemplateSummary>>;
  /** Get published workflows formatted as tools for use in LLM nodes and personas */
  workflowTools?: Maybe<Array<WorkflowTool>>;
  /** List workflow definitions with pagination and filtering */
  workflows?: Maybe<WorkflowDefinitionConnection>;
};


export type RootQueryTypeAgentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAgentSecretsArgs = {
  agentId: Scalars['ID']['input'];
};


export type RootQueryTypeAgentToolsArgs = {
  agentId: Scalars['ID']['input'];
};


export type RootQueryTypeAgentsArgs = {
  filter?: InputMaybe<AgentFilterInput>;
};


export type RootQueryTypeAgentsWithSecretAccessArgs = {
  secretId: Scalars['ID']['input'];
};


export type RootQueryTypeConnectorAppArgs = {
  address: Scalars['String']['input'];
};


export type RootQueryTypeConnectorToolsArgs = {
  connectorAddress: Scalars['String']['input'];
};


export type RootQueryTypeConversationArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeConversationFilesystemArgs = {
  conversationId: Scalars['ID']['input'];
};


export type RootQueryTypeConversationTasksArgs = {
  conversationId: Scalars['ID']['input'];
};


export type RootQueryTypeConversationsArgs = {
  filter?: InputMaybe<ConversationFilterInput>;
};


export type RootQueryTypeCountJobInstancesByAgentArgs = {
  filter?: InputMaybe<JobInstanceCountFilter>;
};


export type RootQueryTypeDocumentArgs = {
  conversationId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
};


export type RootQueryTypeExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeExecutionByExternalIdArgs = {
  externalId: Scalars['String']['input'];
};


export type RootQueryTypeExecutionEventsArgs = {
  executionId: Scalars['ID']['input'];
};


export type RootQueryTypeExecutionOutputsArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExecutionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeExportAgentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeExportPersonaBundleArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeFolderArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGetJobConfigArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeGetJobInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeKnowledgeBaseDocumentsArgs = {
  filter: DocumentFilterInput;
};


export type RootQueryTypeKnowledgeBasesArgs = {
  filter?: InputMaybe<KnowledgeBaseFilterInput>;
};


export type RootQueryTypeListAgentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListAgentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListAllJobInstancesArgs = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  jobConfigId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeListConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListConversationsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListDocumentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListJobConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<JobConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListJobInstancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<JobInstanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListMcpToolsArgs = {
  templateId: Scalars['String']['input'];
};


export type RootQueryTypeListSecretsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SecretFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TriggerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeListWebhookEndpointsArgs = {
  webhookType?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeMcpCatalogInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeMcpCatalogInstancesArgs = {
  filter?: InputMaybe<McpInstanceFilterInput>;
};


export type RootQueryTypeMcpCatalogServerArgs = {
  idOrSlug: Scalars['String']['input'];
};


export type RootQueryTypeMcpCatalogServersArgs = {
  filter?: InputMaybe<McpCatalogFilterInput>;
};


export type RootQueryTypeMcpCatalogToolsArgs = {
  serverIdOrSlug: Scalars['String']['input'];
};


export type RootQueryTypeMyExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeMyWorkflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeNodeArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeNodeExecutionLogsArgs = {
  executionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
  sinceSeconds?: InputMaybe<Scalars['Int']['input']>;
  tailLines?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeQueryAgentKnowledgeBasesArgs = {
  agentId: Scalars['ID']['input'];
  knowledgeBaseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query: Scalars['String']['input'];
};


export type RootQueryTypeQueryKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeSecretArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTaskExecutionLogsArgs = {
  executionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
  retryAttempt: Scalars['Int']['input'];
  sinceSeconds?: InputMaybe<Scalars['Int']['input']>;
  tailLines?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeTenantUsersArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeToolsArgs = {
  filter?: InputMaybe<ToolFilterInput>;
};


export type RootQueryTypeTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTriggerExecutionsArgs = {
  filter?: InputMaybe<TriggerExecutionFilter>;
  triggerId: Scalars['ID']['input'];
};


export type RootQueryTypeTriggerTargetsArgs = {
  triggerId: Scalars['ID']['input'];
};


export type RootQueryTypeTriggersForTargetArgs = {
  targetId: Scalars['ID']['input'];
  targetType: TriggerTargetType;
};


export type RootQueryTypeUsageRecordsArgs = {
  filter?: InputMaybe<UsageRecordsFilter>;
};


export type RootQueryTypeUserLimitConfigArgs = {
  userId: Scalars['ID']['input'];
};


export type RootQueryTypeWebhookEndpointArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeWorkflowTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeWorkflowTemplatesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeWorkflowTemplatesSummaryArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeWorkflowToolsArgs = {
  engine?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeWorkflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WorkflowFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Subscribe to all conversation events (messages, agent status, tool calls, approvals) */
  conversationEvents?: Maybe<ConversationEvent>;
  /** Subscribe to document processing updates */
  documentProcessingUpdates?: Maybe<DocumentProcessingEvent>;
  /** Stream execution events in real-time with historical data */
  executionEventsStream?: Maybe<ExecutionEvent>;
  /** Stream logs for a specific node execution in real-time */
  executionLogsStream?: Maybe<LogLine>;
  /** Subscribe to execution status changes */
  executionStatusChanged?: Maybe<ExecutionStatusEvent>;
  /** Subscribe to updates for a specific workflow execution */
  executionUpdated?: Maybe<WorkflowExecution>;
  /** Stream execution and node status updates in real-time */
  executionUpdates?: Maybe<ExecutionUpdate>;
  /** Stream EventRegistry PubSub events for Handoff executions (daemon/reactive workflows) */
  handoffExecutionEvents?: Maybe<HandoffEvent>;
  /** Subscribe to knowledge base updates (documents added/removed, status changes) */
  knowledgeBaseUpdates?: Maybe<KnowledgeBaseUpdateEvent>;
  /** Subscribe to new executions for the current user */
  myExecutions?: Maybe<WorkflowExecution>;
  /** Subscribe to all executions for a specific workflow definition */
  workflowExecutions?: Maybe<WorkflowExecution>;
  /** Subscribe to workflow definition changes */
  workflowUpdated?: Maybe<WorkflowDefinition>;
};


export type RootSubscriptionTypeConversationEventsArgs = {
  conversationId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeDocumentProcessingUpdatesArgs = {
  documentId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeExecutionEventsStreamArgs = {
  executionId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeExecutionLogsStreamArgs = {
  executionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
};


export type RootSubscriptionTypeExecutionStatusChangedArgs = {
  id: Scalars['ID']['input'];
};


export type RootSubscriptionTypeExecutionUpdatedArgs = {
  id: Scalars['ID']['input'];
};


export type RootSubscriptionTypeExecutionUpdatesArgs = {
  executionId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeHandoffExecutionEventsArgs = {
  executionId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeKnowledgeBaseUpdatesArgs = {
  knowledgeBaseId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkflowExecutionsArgs = {
  workflowId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeWorkflowUpdatedArgs = {
  id: Scalars['ID']['input'];
};

/** A secret for storing sensitive information */
export type Secret = Node & {
  __typename?: 'Secret';
  agents?: Maybe<Array<Agent>>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  name: Scalars['String']['output'];
  type: SecretType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Connection type for paginated Secret */
export type SecretConnection = {
  __typename?: 'SecretConnection';
  edges?: Maybe<Array<Maybe<SecretEdge>>>;
  pageInfo: PageInfo;
};

export type SecretEdge = {
  __typename?: 'SecretEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Secret>;
};

/** Filter for listing secrets */
export type SecretFilterInput = {
  type?: InputMaybe<SecretType>;
};

/** Secret type enumeration */
export enum SecretType {
  /** HTTP Basic Authentication (username:password) */
  BasicAuth = 'BASIC_AUTH',
  /** Generic API token with Bearer or custom authentication */
  Token = 'TOKEN'
}

/** Result of setting a signal value */
export type SetSignalResult = {
  __typename?: 'SetSignalResult';
  /** Optional message about the operation */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the signal was successfully set */
  success: Scalars['Boolean']['output'];
};

/** Input for injecting a tool response from a client-handled tool */
export type SetToolResultInput = {
  conversationId: Scalars['ID']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['Json']['input']>;
  toolCallId: Scalars['String']['input'];
};

/** Result of inject tool response mutation */
export type SetToolResultResult = {
  __typename?: 'SetToolResultResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Result of approving or rejecting a signal */
export type SignalActionResult = {
  __typename?: 'SignalActionResult';
  /** The updated workflow execution */
  execution?: Maybe<WorkflowExecution>;
  /** Optional message about the operation */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the action was successful */
  success: Scalars['Boolean']['output'];
};

/** Subworkflow execution information for inline branch subworkflows */
export type SubworkflowExecutionInfo = {
  __typename?: 'SubworkflowExecutionInfo';
  /** Aggregate status from all child nodes */
  aggregateStatus: Scalars['String']['output'];
  /** External ID of the child execution for navigation */
  childExecutionId?: Maybe<Scalars['String']['output']>;
  /** Number of child nodes in the subworkflow */
  childNodeCount: Scalars['Int']['output'];
  /** Individual child node phases */
  childPhases?: Maybe<Array<Maybe<ChildNodePhase>>>;
  /** Whether this node is a subworkflow */
  isSubworkflow: Scalars['Boolean']['output'];
};

/** System prompt configuration for an agent in a conversation */
export type SystemPrompt = {
  __typename?: 'SystemPrompt';
  agentId: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
};

/** Task execution (sub-task within an ArrayNode) */
export type TaskExecution = {
  __typename?: 'TaskExecution';
  /** Task execution duration */
  duration?: Maybe<Scalars['String']['output']>;
  /** Error message if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** URI to task logs */
  logsUri?: Maybe<Scalars['String']['output']>;
  /** Execution phase */
  phase: Scalars['String']['output'];
  /** Retry attempt number */
  retryAttempt: Scalars['Int']['output'];
  /** When the task started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Result of executing a single task */
export type TaskExecutionResult = {
  __typename?: 'TaskExecutionResult';
  /** Error message (if failed) */
  error?: Maybe<Scalars['String']['output']>;
  /** Error type (if failed) */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Task outputs (if successful) */
  outputs?: Maybe<Scalars['Json']['output']>;
  /** Execution status (success, failed) */
  status: Scalars['String']['output'];
};

/** Input for task resource requirements */
export type TaskResourcesInput = {
  /** CPU requirement */
  cpu?: InputMaybe<Scalars['String']['input']>;
  /** GPU requirement */
  gpu?: InputMaybe<Scalars['String']['input']>;
  /** Memory requirement */
  memory?: InputMaybe<Scalars['String']['input']>;
};

/** Task tracking state for a conversation */
export type TaskTrackingState = {
  __typename?: 'TaskTrackingState';
  blockedCount?: Maybe<Scalars['Int']['output']>;
  completedCount?: Maybe<Scalars['Int']['output']>;
  failedCount?: Maybe<Scalars['Int']['output']>;
  runningCount?: Maybe<Scalars['Int']['output']>;
  tasks: Array<AgentTask>;
  totalTasks?: Maybe<Scalars['Int']['output']>;
};

/** A team member with role information */
export type TeamMember = {
  __typename?: 'TeamMember';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role: UserRole;
};

/** A tenant in the system */
export type Tenant = {
  __typename?: 'Tenant';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Current tenant limit configuration */
export type TenantLimitConfig = {
  __typename?: 'TenantLimitConfig';
  /** Daily limit per user */
  dailyLimitPerUser?: Maybe<Scalars['Int']['output']>;
  /** Tenant daily limit */
  dailyLimitTenant?: Maybe<Scalars['Int']['output']>;
  /** Whether rate limiting is enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether tenant limits are enforced */
  enforceTenantLimits?: Maybe<Scalars['Boolean']['output']>;
  /** Monthly limit multiplier */
  monthlyLimitMultiplier?: Maybe<Scalars['Int']['output']>;
  /** Tenant monthly limit */
  monthlyLimitTenant?: Maybe<Scalars['Int']['output']>;
  /** Configuration reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** Tenant ID */
  tenantId: Scalars['ID']['output'];
  /** Warning threshold percentage */
  warningThresholdPercent?: Maybe<Scalars['Int']['output']>;
  /** Weekly limit multiplier */
  weeklyLimitMultiplier?: Maybe<Scalars['Int']['output']>;
  /** Tenant weekly limit */
  weeklyLimitTenant?: Maybe<Scalars['Int']['output']>;
};

/** Input for setting tenant token limit configuration */
export type TenantLimitConfigInput = {
  /** Daily token limit per user */
  dailyLimitPerUser?: InputMaybe<Scalars['Int']['input']>;
  /** Tenant-level daily limit (tracked, not enforced) */
  dailyLimitTenant?: InputMaybe<Scalars['Int']['input']>;
  /** Whether rate limiting is enabled for this tenant */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to enforce tenant-level limits (future use) */
  enforceTenantLimits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monthly limit multiplier (percentage of daily, e.g., 2000 = 20x daily) */
  monthlyLimitMultiplier?: InputMaybe<Scalars['Int']['input']>;
  /** Tenant-level monthly limit (tracked, not enforced) */
  monthlyLimitTenant?: InputMaybe<Scalars['Int']['input']>;
  /** Reason for this configuration */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Warning threshold percentage (default 80) */
  warningThresholdPercent?: InputMaybe<Scalars['Int']['input']>;
  /** Weekly limit multiplier (percentage of daily, e.g., 500 = 5x daily) */
  weeklyLimitMultiplier?: InputMaybe<Scalars['Int']['input']>;
  /** Tenant-level weekly limit (tracked, not enforced) */
  weeklyLimitTenant?: InputMaybe<Scalars['Int']['input']>;
};

/** Tenant-level usage for a specific period (admin view) */
export type TenantUsagePeriod = {
  __typename?: 'TenantUsagePeriod';
  /** Whether tenant limits are enforced */
  enforced?: Maybe<Scalars['Boolean']['output']>;
  /** Tenant limit for this period (nil if not configured) */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Total usage across all users in tokens */
  usage: Scalars['Int']['output'];
};

/** Tenant-wide token usage statistics (admin view) */
export type TenantUsageStats = {
  __typename?: 'TenantUsageStats';
  /** Daily tenant-wide usage */
  daily: TenantUsagePeriod;
  /** Monthly tenant-wide usage */
  monthly: TenantUsagePeriod;
  /** Weekly tenant-wide usage */
  weekly: TenantUsagePeriod;
};

/** Result of testing a trigger */
export type TestTriggerResult = {
  __typename?: 'TestTriggerResult';
  /** The execution record created */
  execution?: Maybe<TriggerExecution>;
  /** The trigger that was fired */
  trigger?: Maybe<Trigger>;
};

/** A text message part */
export type TextPart = {
  __typename?: 'TextPart';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** AI reasoning/thinking content */
export type Thinking = {
  __typename?: 'Thinking';
  content: Scalars['String']['output'];
  signature?: Maybe<Scalars['String']['output']>;
};

/** A thinking message part */
export type ThinkingPart = {
  __typename?: 'ThinkingPart';
  id: Scalars['ID']['output'];
  thinking: Thinking;
};

/** Thinking streaming event for real-time AI reasoning updates */
export type ThinkingStreamingEvent = {
  __typename?: 'ThinkingStreamingEvent';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageId: Scalars['ID']['output'];
  signature?: Maybe<Scalars['String']['output']>;
  thinkingPartId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
};

/** Result of a token limit configuration operation */
export type TokenLimitConfigResult = {
  __typename?: 'TokenLimitConfigResult';
  /** Message describing the result */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Token usage statistics for a specific time period */
export type TokenUsagePeriod = {
  __typename?: 'TokenUsagePeriod';
  /** Limit for this period (nil if no limit configured) */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Percentage of limit used (nil if no limit) */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Status: ok, warning, exceeded, disabled, or no_limit */
  status: Scalars['String']['output'];
  /** Current usage in tokens */
  usage: Scalars['Int']['output'];
  /** Warning threshold percentage (default 80) */
  warningThreshold?: Maybe<Scalars['Int']['output']>;
};

/** A single token usage record */
export type TokenUsageRecord = {
  __typename?: 'TokenUsageRecord';
  /** Associated agent ID (if any) */
  agentId?: Maybe<Scalars['ID']['output']>;
  /** Number of completion tokens */
  completionTokens: Scalars['Int']['output'];
  /** Associated conversation ID (if any) */
  conversationId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** When the usage was recorded */
  insertedAt: Scalars['DateTime']['output'];
  /** LLM model used */
  model: Scalars['String']['output'];
  /** Number of prompt tokens */
  promptTokens: Scalars['Int']['output'];
  /** Source of the usage (chat, workflow, tool, etc.) */
  source: Scalars['String']['output'];
  /** Total tokens used */
  totalTokens: Scalars['Int']['output'];
  /** Associated workflow execution ID (if any) */
  workflowExecutionId?: Maybe<Scalars['ID']['output']>;
};

/** Complete token usage statistics for current user */
export type TokenUsageStats = {
  __typename?: 'TokenUsageStats';
  /** Daily usage and limits */
  daily: TokenUsagePeriod;
  /** Whether rate limiting is enabled for this user */
  isLimited: Scalars['Boolean']['output'];
  /** Monthly usage and limits */
  monthly: TokenUsagePeriod;
  /** User's current date (for display purposes) */
  userDate: Scalars['Date']['output'];
  /** Weekly usage and limits */
  weekly: TokenUsagePeriod;
};

/** A system tool available for agents */
export type Tool = {
  __typename?: 'Tool';
  category: Scalars['String']['output'];
  /** Consent mode: auto, manual, per_request */
  consentMode?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** A tool call within a message part */
export type ToolCall = {
  __typename?: 'ToolCall';
  arguments?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Tool call approval event for approval subscriptions */
export type ToolCallApprovalEvent = {
  __typename?: 'ToolCallApprovalEvent';
  agentId: Scalars['ID']['output'];
  approvalMode: ToolCallApprovalState;
  conversationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
};

/** Tool call approval state for confirmation mutation */
export enum ToolCallApprovalState {
  /** Always approve this tool call type for this agent/session */
  ApproveAlways = 'APPROVE_ALWAYS',
  /** Approve this tool call (one time) */
  ApproveOnce = 'APPROVE_ONCE',
  /** Always deny this tool call type for this agent/session */
  DenyAlways = 'DENY_ALWAYS',
  /** Deny this tool call (one time) */
  DenyOnce = 'DENY_ONCE'
}

/** Tool call message event for tool call subscriptions */
export type ToolCallMessageEvent = {
  __typename?: 'ToolCallMessageEvent';
  agentId: Scalars['ID']['output'];
  arguments?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
  toolName?: Maybe<Scalars['String']['output']>;
};

/** A tool call message part */
export type ToolCallPart = {
  __typename?: 'ToolCallPart';
  id: Scalars['ID']['output'];
  toolCall: ToolCall;
};

/** Input for setting a tool call policy (approval/denial) */
export type ToolCallPolicyInput = {
  conversationId: Scalars['ID']['input'];
  toolCallApprovalState: ToolCallApprovalState;
  toolCallId: Scalars['String']['input'];
};

/** Result of tool call policy mutation */
export type ToolCallPolicyResult = {
  __typename?: 'ToolCallPolicyResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Tool category enumeration for system tools (MCP servers have their own categories) */
export enum ToolCategory {
  /** Demo database query tools */
  Demo = 'DEMO',
  /** Document management tools */
  Documents = 'DOCUMENTS',
  /** Web search and URL fetching tools */
  Internet = 'INTERNET',
  /** RAG and knowledge base tools */
  KnowledgeBase = 'KNOWLEDGE_BASE',
  /** Miscellaneous tools */
  Misc = 'MISC',
  /** Chart creation and diagram tools */
  Visualization = 'VISUALIZATION',
  /** Workflow operations tools */
  Workflow = 'WORKFLOW'
}

/** Filter for available tools */
export type ToolFilterInput = {
  category?: InputMaybe<ToolCategory>;
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Tool result compaction completion event for UI updates */
export type ToolResultCompactedEvent = {
  __typename?: 'ToolResultCompactedEvent';
  conversationId: Scalars['ID']['output'];
  encodedSizeBytes: Scalars['Int']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  originalSizeBytes?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['String']['output'];
  tokenSavingsPct?: Maybe<Scalars['Float']['output']>;
  toolCallId: Scalars['String']['output'];
  toolName?: Maybe<Scalars['String']['output']>;
};

/** Tool result compaction start event for UI loading indicators */
export type ToolResultCompactingEvent = {
  __typename?: 'ToolResultCompactingEvent';
  conversationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  originalSizeBytes?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
  toolName?: Maybe<Scalars['String']['output']>;
};

/** A trigger that can initiate workflow or job executions */
export type Trigger = Node & {
  __typename?: 'Trigger';
  /** ID of user who created the trigger */
  createdById?: Maybe<Scalars['ID']['output']>;
  /** Cron expression for scheduling (cron triggers only) */
  cronExpression?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the trigger */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the trigger is active */
  enabled: Scalars['Boolean']['output'];
  /** Recent executions of this trigger */
  executions?: Maybe<Array<Maybe<TriggerExecution>>>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** When the trigger was created */
  insertedAt: Scalars['DateTime']['output'];
  /** Additional trigger metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Unique name for the trigger within the tenant */
  name: Scalars['String']['output'];
  /** Payload to send when cron trigger fires (workflow inputs or job prompts) */
  payload?: Maybe<Scalars['Json']['output']>;
  /** Targets that execute when trigger fires */
  targets?: Maybe<Array<Maybe<TriggerTarget>>>;
  /** Timezone for cron evaluation (default: UTC) */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Whether this is a cron or webhook trigger */
  triggerType: TriggerType;
  /** When the trigger was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Linked webhook endpoint (webhook triggers only) */
  webhookEndpoint?: Maybe<WebhookEndpoint>;
  /** ID of linked webhook endpoint (webhook triggers only) */
  webhookEndpointId?: Maybe<Scalars['ID']['output']>;
};


/** A trigger that can initiate workflow or job executions */
export type TriggerExecutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection for paginated triggers */
export type TriggerConnection = {
  __typename?: 'TriggerConnection';
  edges?: Maybe<Array<Maybe<TriggerEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Result of a trigger deletion */
export type TriggerDeleteResult = {
  __typename?: 'TriggerDeleteResult';
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
  /** The deleted trigger */
  trigger?: Maybe<Trigger>;
};

export type TriggerEdge = {
  __typename?: 'TriggerEdge';
  cursor: Scalars['String']['output'];
  node: Trigger;
};

/** A record of a trigger firing and its results */
export type TriggerExecution = {
  __typename?: 'TriggerExecution';
  /** When execution completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Execution duration in milliseconds */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Error message if execution failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** When the record was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When execution started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current execution status */
  status: TriggerExecutionStatus;
  /** Results from each target execution */
  targetResults?: Maybe<Scalars['Json']['output']>;
  /** Event data that caused the trigger */
  triggerEvent?: Maybe<Scalars['Json']['output']>;
  /** ID of the trigger that fired */
  triggerId: Scalars['ID']['output'];
  /** When the trigger fired */
  triggeredAt: Scalars['DateTime']['output'];
};

/** Filter for listing trigger executions */
export type TriggerExecutionFilter = {
  /** Maximum number of results (default: 50) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by status */
  status?: InputMaybe<TriggerExecutionStatus>;
};

/** Status of a trigger execution */
export enum TriggerExecutionStatus {
  /** Finished successfully */
  Completed = 'COMPLETED',
  /** Execution failed */
  Failed = 'FAILED',
  /** Waiting to start */
  Pending = 'PENDING',
  /** Currently executing */
  Running = 'RUNNING',
  /** Execution was skipped */
  Skipped = 'SKIPPED'
}

/** Filter for listing triggers */
export type TriggerFilter = {
  /** Filter by enabled status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by name containing string */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Filter by trigger type */
  triggerType?: InputMaybe<TriggerType>;
};

/** Result of a trigger mutation */
export type TriggerMutationResult = {
  __typename?: 'TriggerMutationResult';
  /** The created or updated trigger */
  trigger?: Maybe<Trigger>;
};

/** A target that receives events when a trigger fires */
export type TriggerTarget = {
  __typename?: 'TriggerTarget';
  /** Whether this target is active */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Map to transform trigger event data to target inputs */
  inputMapping?: Maybe<Scalars['Json']['output']>;
  /** When the target was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The job this target executes (only for job targets) */
  job?: Maybe<JobConfig>;
  /** Execution order (lower = higher priority) */
  priority: Scalars['Int']['output'];
  /** ID of the workflow or job */
  targetId: Scalars['ID']['output'];
  /** Type of target (workflow or job) */
  targetType: TriggerTargetType;
  /** ID of parent trigger */
  triggerId: Scalars['ID']['output'];
  /** When the target was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The workflow this target executes (only for workflow targets) */
  workflow?: Maybe<WorkflowDefinition>;
};

/** Result of a trigger target deletion */
export type TriggerTargetDeleteResult = {
  __typename?: 'TriggerTargetDeleteResult';
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
  /** The deleted target */
  target?: Maybe<TriggerTarget>;
};

/** Result of a trigger target mutation */
export type TriggerTargetMutationResult = {
  __typename?: 'TriggerTargetMutationResult';
  /** The created or updated target */
  target?: Maybe<TriggerTarget>;
};

/** Type of target that a trigger dispatches to */
export enum TriggerTargetType {
  /** Execute a job */
  Job = 'JOB',
  /** Execute a workflow */
  Workflow = 'WORKFLOW'
}

/** Type of trigger */
export enum TriggerType {
  /** Trigger fires on a cron schedule */
  Cron = 'CRON',
  /** Trigger fires when webhook endpoint receives request */
  Webhook = 'WEBHOOK'
}

/** Input for updating an existing agent */
export type UpdateAgentInput = {
  agentGreeting?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeBaseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Model code name (fast, balanced, smart, powerful, premium) */
  model?: InputMaybe<ModelCode>;
  name?: InputMaybe<Scalars['String']['input']>;
  systemMessage?: InputMaybe<Scalars['String']['input']>;
  /** Tools configuration (can be JSONB object with mcp_servers or array of strings) */
  tools?: InputMaybe<Scalars['Json']['input']>;
};

/** Type of update event */
export enum UpdateEventType {
  /** A document was added to the knowledge base */
  DocumentAdded = 'DOCUMENT_ADDED',
  /** A document was removed from the knowledge base */
  DocumentRemoved = 'DOCUMENT_REMOVED',
  /** A document was updated */
  DocumentUpdated = 'DOCUMENT_UPDATED',
  /** Document processing completed */
  ProcessingCompleted = 'PROCESSING_COMPLETED',
  /** Document processing failed */
  ProcessingFailed = 'PROCESSING_FAILED',
  /** Document processing started */
  ProcessingStarted = 'PROCESSING_STARTED',
  /** Knowledge base status changed */
  StatusChanged = 'STATUS_CHANGED'
}

/** Input for updating a folder */
export type UpdateFolderInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a knowledge base */
export type UpdateKnowledgeBaseInput = {
  config?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<KnowledgeBaseStatus>;
};

/** Input for updating an MCP instance */
export type UpdateMcpInstanceInput = {
  /** Update consent mode */
  consentMode?: InputMaybe<Scalars['String']['input']>;
  /** Instance ID to update */
  instanceId: Scalars['ID']['input'];
  /** Update instance metadata */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** Update authentication secrets */
  secrets?: InputMaybe<Scalars['Json']['input']>;
  /** Update request timeout */
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating an MCP server configuration */
export type UpdateMcpServerInput = {
  /** Consent mode: manual, approve_always, deny_always */
  consentMode?: InputMaybe<Scalars['String']['input']>;
  /** Map of header names to template strings */
  headers?: InputMaybe<Scalars['Json']['input']>;
  /** Map of secret names to secret IDs */
  secrets?: InputMaybe<Scalars['Json']['input']>;
  /** Request timeout in milliseconds */
  timeout?: InputMaybe<Scalars['Int']['input']>;
  /** Custom URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating MCP tool configurations */
export type UpdateMcpToolConfigsInput = {
  /** Platform server ID or slug */
  serverIdOrSlug: Scalars['String']['input'];
  /** Map of tool_name => {enabled: bool, consent_mode: string} */
  toolConfigs: Scalars['Json']['input'];
};

/** Input for updating a secret */
export type UpdateSecretInput = {
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a trigger */
export type UpdateTriggerInput = {
  /** Updated cron expression */
  cronExpression?: InputMaybe<Scalars['String']['input']>;
  /** Updated description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated enabled status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated metadata */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** Updated name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated payload for cron triggers */
  payload?: InputMaybe<Scalars['Json']['input']>;
  /** Updated timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Updated webhook endpoint ID */
  webhookEndpointId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for updating a trigger target */
export type UpdateTriggerTargetInput = {
  /** Updated enabled status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated input mapping */
  inputMapping?: InputMaybe<Scalars['Json']['input']>;
  /** Updated priority */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating a webhook endpoint */
export type UpdateWebhookEndpointInput = {
  /** Description of the webhook endpoint */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the webhook endpoint */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Endpoint status: active, disabled */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a workflow definition */
export type UpdateWorkflowInput = {
  /** Updated description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated metadata */
  metadata?: InputMaybe<Scalars['Json']['input']>;
  /** Updated name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated version */
  version?: InputMaybe<Scalars['String']['input']>;
  /** Updated workflow specification */
  workflowSpec?: InputMaybe<Scalars['Json']['input']>;
};

/** Input for uploading a document */
export type UploadDocumentInput = {
  file: Scalars['Upload']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['Json']['input']>;
};

/** Filter options for usage records */
export type UsageRecordsFilter = {
  /** Maximum number of records to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by source (chat, workflow, tool, etc.) */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** A user in the system */
export type User = {
  __typename?: 'User';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

/** User details including context and features */
export type UserDetails = {
  __typename?: 'UserDetails';
  details?: Maybe<Scalars['Json']['output']>;
  features?: Maybe<UserFeatures>;
  isAdmin: Scalars['Boolean']['output'];
  isPlg: Scalars['Boolean']['output'];
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** User context features configuration */
export type UserFeatures = {
  __typename?: 'UserFeatures';
  asocV2Enabled: Scalars['Boolean']['output'];
  automationsToolsEnabled?: Maybe<Scalars['Boolean']['output']>;
  caseManagementToolsEnabled?: Maybe<Scalars['Boolean']['output']>;
  constructIntegration: Scalars['Boolean']['output'];
  customAgents: Scalars['Boolean']['output'];
  devoAssistantEnabled: Scalars['Boolean']['output'];
  devoToolsEnabled: Scalars['Boolean']['output'];
  externalConnectors: Scalars['Boolean']['output'];
  gitlabToolsEnabled: Scalars['Boolean']['output'];
  knowledgebasesEdit: Scalars['Boolean']['output'];
  knowledgebasesViewOnly: Scalars['Boolean']['output'];
  mcpManagement: Scalars['Boolean']['output'];
  mcpToolSelection: Scalars['Boolean']['output'];
  rbacEnabled: Scalars['Boolean']['output'];
  secOpsToolsEnabled?: Maybe<Scalars['Boolean']['output']>;
  secretsManagementEnabled: Scalars['Boolean']['output'];
  sentryUnmaskData: Scalars['Boolean']['output'];
  tokenUsageTracking?: Maybe<Scalars['Boolean']['output']>;
  webhooksEnabled: Scalars['Boolean']['output'];
  workflowBuilderEnabled: Scalars['Boolean']['output'];
  workflowsManage: Scalars['Boolean']['output'];
};

/** Current user limit configuration */
export type UserLimitConfig = {
  __typename?: 'UserLimitConfig';
  /** Custom daily limit */
  dailyLimit?: Maybe<Scalars['Int']['output']>;
  /** Whether rate limiting is enabled for this user */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Custom monthly limit */
  monthlyLimit?: Maybe<Scalars['Int']['output']>;
  /** Override reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** User ID */
  userId: Scalars['ID']['output'];
  /** Custom weekly limit */
  weeklyLimit?: Maybe<Scalars['Int']['output']>;
};

/** Input for setting user-specific token limit override */
export type UserLimitConfigInput = {
  /** Custom daily limit for this user */
  dailyLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this user is enabled for rate limiting */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom monthly limit for this user (nil = use multiplier) */
  monthlyLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Reason for this override */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** User ID to configure */
  userId: Scalars['ID']['input'];
  /** Custom weekly limit for this user (nil = use multiplier) */
  weeklyLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** User role enumeration */
export enum UserRole {
  /** Administrator with full access */
  Admin = 'ADMIN',
  /** Regular team member */
  Member = 'MEMBER'
}

/** A webhook endpoint for receiving or sending webhooks */
export type WebhookEndpoint = {
  __typename?: 'WebhookEndpoint';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Endpoint status: active, disabled, failing */
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for incoming webhooks */
  webhookGuid?: Maybe<Scalars['String']['output']>;
  /** Either 'incoming' or 'outgoing' */
  webhookType: Scalars['String']['output'];
};

/** Result of creating or updating a webhook endpoint */
export type WebhookEndpointResult = {
  __typename?: 'WebhookEndpointResult';
  webhookEndpoint?: Maybe<WebhookEndpoint>;
};

/** A workflow definition that can be executed */
export type WorkflowDefinition = Node & {
  __typename?: 'WorkflowDefinition';
  /** All versions of this workflow */
  allVersions?: Maybe<Array<Maybe<WorkflowDefinition>>>;
  /** When the workflow was created */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created this workflow */
  createdBy?: Maybe<User>;
  /** The ID of the user who created this workflow */
  createdById?: Maybe<Scalars['ID']['output']>;
  /** A description of what this workflow does */
  description?: Maybe<Scalars['String']['output']>;
  /** The workflow execution engine (handoff) */
  engine?: Maybe<Scalars['String']['output']>;
  /** Executions of this workflow */
  executions?: Maybe<Array<Maybe<WorkflowExecution>>>;
  /** The ID of this workflow in the execution engine */
  externalWorkflowId?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** JSON schema for workflow inputs */
  inputSchema?: Maybe<Scalars['Json']['output']>;
  /** Whether this is the latest version of the workflow */
  isLatest: Scalars['Boolean']['output'];
  /** Whether this is a root workflow */
  isRoot: Scalars['Boolean']['output'];
  /** Whether this is a shared subworkflow */
  isShared: Scalars['Boolean']['output'];
  /** Whether this is a subworkflow */
  isSubworkflow: Scalars['Boolean']['output'];
  /** The most recent execution of this workflow */
  latestExecution?: Maybe<WorkflowExecution>;
  /** Additional metadata about the workflow */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** The unique name of the workflow */
  name: Scalars['String']['output'];
  /** @deprecated Use 'outputs' field instead for explicit output wiring */
  outputSchema?: Maybe<Scalars['Json']['output']>;
  /** Explicit workflow outputs with source task mappings */
  outputs?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  /** The status of the workflow definition */
  status: WorkflowStatus;
  /** When the workflow was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The version of this workflow */
  version: Scalars['String']['output'];
  /** The workflow specification in JSON format */
  workflowSpec?: Maybe<Scalars['Json']['output']>;
  /** The type of workflow: root, subworkflow, or shared */
  workflowType: Scalars['String']['output'];
};

/** Connection for paginated workflow definitions */
export type WorkflowDefinitionConnection = {
  __typename?: 'WorkflowDefinitionConnection';
  edges?: Maybe<Array<Maybe<WorkflowDefinitionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkflowDefinitionEdge = {
  __typename?: 'WorkflowDefinitionEdge';
  cursor: Scalars['String']['output'];
  node: WorkflowDefinition;
};

/** Input for defining an edge */
export type WorkflowEdgeInput = {
  /** Conditional execution */
  condition?: InputMaybe<Scalars['Json']['input']>;
  /** Source task ID */
  from: Scalars['String']['input'];
  /** Target task ID */
  to: Scalars['String']['input'];
};

/** An execution of a workflow */
export type WorkflowExecution = Node & {
  __typename?: 'WorkflowExecution';
  /** Artifacts produced by this workflow execution */
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  /** When the execution completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When the execution record was created */
  createdAt: Scalars['DateTime']['output'];
  /** The current status with real-time updates */
  currentStatus?: Maybe<ExecutionStatusDetail>;
  /** The workflow execution engine (handoff) */
  engine?: Maybe<Scalars['String']['output']>;
  /** Error message if the execution failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Events from this workflow execution */
  events?: Maybe<Array<Maybe<ExecutionEvent>>>;
  /** Complete execution state snapshot including task outputs and branch decisions */
  executionStateSnapshot?: Maybe<Scalars['Json']['output']>;
  /** The ID of this execution in the workflow engine */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** The inputs provided to this execution */
  inputs?: Maybe<Scalars['Json']['output']>;
  /** Additional metadata about the execution */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Node executions within this workflow execution */
  nodeExecutions?: Maybe<Array<Maybe<NodeExecution>>>;
  /** The outputs from this execution (if completed) */
  outputs?: Maybe<Scalars['Json']['output']>;
  /** Signals waiting for input in this execution */
  signals?: Maybe<Array<Maybe<ExecutionSignal>>>;
  /** When the execution started */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the execution */
  status: ExecutionStatus;
  /** The user who triggered this execution */
  triggeredBy?: Maybe<User>;
  /** The ID of the user who triggered this execution */
  triggeredById?: Maybe<Scalars['ID']['output']>;
  /** When the execution was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The workflow definition being executed */
  workflowDefinition?: Maybe<WorkflowDefinition>;
  /** The ID of the workflow definition */
  workflowDefinitionId: Scalars['ID']['output'];
  /** The version of the workflow that was executed */
  workflowVersion?: Maybe<Scalars['String']['output']>;
};


/** An execution of a workflow */
export type WorkflowExecutionNodeExecutionsArgs = {
  nodeId?: InputMaybe<Scalars['String']['input']>;
};

/** Connection for paginated workflow executions */
export type WorkflowExecutionConnection = {
  __typename?: 'WorkflowExecutionConnection';
  edges?: Maybe<Array<Maybe<WorkflowExecutionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkflowExecutionEdge = {
  __typename?: 'WorkflowExecutionEdge';
  cursor: Scalars['String']['output'];
  node: WorkflowExecution;
};

/** Workflow execution identifier */
export type WorkflowExecutionIdentifier = {
  __typename?: 'WorkflowExecutionIdentifier';
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Execution name */
  name: Scalars['String']['output'];
  /** Project name */
  project: Scalars['String']['output'];
};

/** Result of exporting a workflow */
export type WorkflowExportResult = {
  __typename?: 'WorkflowExportResult';
  /** Complete workflow definition as JSON */
  workflowData: Scalars['Json']['output'];
};

/** Filter for listing workflows */
export type WorkflowFilter = {
  /** Filter by creator */
  createdById?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by name containing string */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Sort by recent activity (execution time or creation time) instead of updated_at. Default: false */
  sortByActivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by status */
  status?: InputMaybe<WorkflowStatus>;
};

/** Metadata for workflow node (subworkflow) executions */
export type WorkflowNodeMetadata = {
  __typename?: 'WorkflowNodeMetadata';
  /** The child workflow execution ID */
  executionId: WorkflowExecutionIdentifier;
};

/** Result of building a workflow specification */
export type WorkflowSpecResult = {
  __typename?: 'WorkflowSpecResult';
  /** Workflow description */
  description?: Maybe<Scalars['String']['output']>;
  /** Edges connecting tasks */
  edges?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  /** Workflow inputs */
  inputs?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  /** Additional metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Workflow name */
  name: Scalars['String']['output'];
  /** Workflow outputs */
  outputs?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  /** Tasks in the workflow */
  tasks?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  /** Workflow version */
  version: Scalars['String']['output'];
};

/** Workflow definition status */
export enum WorkflowStatus {
  /** Workflow is deprecated and should not be used */
  Deprecated = 'DEPRECATED',
  /** Workflow is being edited and not yet ready */
  Draft = 'DRAFT',
  /** Workflow is published and can be executed */
  Published = 'PUBLISHED'
}

/** Input for defining a task */
export type WorkflowTaskInput = {
  /** Command arguments */
  args?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Branch configuration (for type: 'branch') */
  branch?: InputMaybe<BranchConfigInput>;
  /** Enable caching */
  cache?: InputMaybe<Scalars['Boolean']['input']>;
  /** Command to execute */
  command?: InputMaybe<Scalars['String']['input']>;
  /** Environment variables */
  env?: InputMaybe<Scalars['Json']['input']>;
  /** Task ID */
  id: Scalars['String']['input'];
  /** Container image */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Resource requirements */
  resources?: InputMaybe<TaskResourcesInput>;
  /** Number of retries */
  retries?: InputMaybe<Scalars['Int']['input']>;
  /** Script content */
  script?: InputMaybe<Scalars['String']['input']>;
  /** Signal configuration (for type: 'gate') */
  signal?: InputMaybe<Scalars['Json']['input']>;
  /** Timeout in seconds */
  timeout?: InputMaybe<Scalars['Int']['input']>;
  /** Task type (container, python, shell, sql, branch, gate) */
  type: Scalars['String']['input'];
};

/** A workflow template that can be used to create new workflows */
export type WorkflowTemplate = {
  __typename?: 'WorkflowTemplate';
  /** Template category */
  category: Scalars['String']['output'];
  /** What this template does */
  description: Scalars['String']['output'];
  /** Icon identifier */
  icon: Scalars['String']['output'];
  /** Template ID */
  id: Scalars['String']['output'];
  /** Template name */
  name: Scalars['String']['output'];
  /** The actual template data */
  template: WorkflowTemplateData;
};

/** Template data for creating a workflow */
export type WorkflowTemplateData = {
  __typename?: 'WorkflowTemplateData';
  /** Default workflow description */
  description: Scalars['String']['output'];
  /** JSON schema for workflow inputs */
  inputSchema?: Maybe<Scalars['Json']['output']>;
  /** Default workflow name */
  name: Scalars['String']['output'];
  /** @deprecated Use 'outputs' field in workflow_spec instead for explicit output wiring */
  outputSchema?: Maybe<Scalars['Json']['output']>;
  /** Template type: dag or steps */
  templateType?: Maybe<Scalars['String']['output']>;
  /** Default version */
  version: Scalars['String']['output'];
  /** Workflow specification */
  workflowSpec: Scalars['Json']['output'];
};

/** Lightweight workflow template summary for list views (no heavy template data) */
export type WorkflowTemplateSummary = {
  __typename?: 'WorkflowTemplateSummary';
  /** Template category */
  category: Scalars['String']['output'];
  /** What this template does */
  description: Scalars['String']['output'];
  /** Icon identifier */
  icon: Scalars['String']['output'];
  /** Template ID */
  id: Scalars['String']['output'];
  /** Template name */
  name: Scalars['String']['output'];
};

/** A workflow exposed as a tool that can be called by LLM nodes */
export type WorkflowTool = {
  __typename?: 'WorkflowTool';
  /** Whether tool calls are auto-approved */
  autoApprove: Scalars['Boolean']['output'];
  /** Tool description */
  description: Scalars['String']['output'];
  /** Workflow metadata */
  metadata: WorkflowToolMetadata;
  /** Tool name (workflow_{id}) */
  name: Scalars['String']['output'];
  /** Input parameters schema */
  parameters: WorkflowToolParameters;
};

/** Metadata about a workflow tool */
export type WorkflowToolMetadata = {
  __typename?: 'WorkflowToolMetadata';
  /** Type of tool (always 'workflow') */
  toolType: Scalars['String']['output'];
  /** ID of the workflow */
  workflowId: Scalars['String']['output'];
  /** Name of the workflow */
  workflowName: Scalars['String']['output'];
  /** Version of the workflow */
  workflowVersion: Scalars['String']['output'];
};

/** Parameters schema for a workflow tool */
export type WorkflowToolParameters = {
  __typename?: 'WorkflowToolParameters';
  /** Properties definition (JSON Schema) */
  properties?: Maybe<Scalars['Json']['output']>;
  /** Required parameter names */
  required?: Maybe<Array<Scalars['String']['output']>>;
  /** Parameter type (e.g., 'object') */
  type: Scalars['String']['output'];
};

export type RegisterClientToolsMutationVariables = Exact<{
  input: RegisterClientToolsInput;
}>;


export type RegisterClientToolsMutation = { __typename?: 'RootMutationType', registerClientTools?: { __typename?: 'RegisterClientToolsResult', success: boolean, message?: string | null, registeredCount?: number | null } | null };

export type SetToolResultMutationVariables = Exact<{
  input: SetToolResultInput;
}>;


export type SetToolResultMutation = { __typename?: 'RootMutationType', setToolResult?: { __typename?: 'SetToolResultResult', success: boolean, message?: string | null } | null };

export type ConnectorAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectorAppsQuery = { __typename?: 'RootQueryType', connectorApps?: Array<{ __typename?: 'ConnectorApp', address: string, name: string, description?: string | null, icon: string, entryPath: string, routes?: Array<string | null> | null, connectorType?: string | null, navigation?: { __typename?: 'AppNavigationConfig', placement: string, path?: Array<string | null> | null, icon?: string | null, order?: number | null, label?: string | null } | null } | null> | null };

export type ConnectorAppQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type ConnectorAppQuery = { __typename?: 'RootQueryType', connectorApp?: { __typename?: 'ConnectorApp', address: string, name: string, description?: string | null, icon: string, entryPath: string, routes?: Array<string | null> | null, connectorType?: string | null, sandboxToken?: string | null, navigation?: { __typename?: 'AppNavigationConfig', placement: string, path?: Array<string | null> | null, icon?: string | null, order?: number | null, label?: string | null } | null } | null };

export type ConnectorToolsGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectorToolsGroupsQuery = { __typename?: 'RootQueryType', connectorToolsGroups?: Array<{ __typename?: 'ConnectorToolsGroup', address: string, name?: string | null, description?: string | null, vendor?: string | null, icon?: string | null, connectorType?: string | null, tools: Array<{ __typename?: 'ConnectorTool', name: string, description?: string | null, parameters?: any | null, connectorAddress: string }> } | null> | null };

export type ConnectorToolsQueryVariables = Exact<{
  connectorAddress: Scalars['String']['input'];
}>;


export type ConnectorToolsQuery = { __typename?: 'RootQueryType', connectorTools?: Array<{ __typename?: 'ConnectorTool', name: string, description?: string | null, parameters?: any | null, connectorAddress: string } | null> | null };

export type CreateAgentMutationVariables = Exact<{
  input: AgentInput;
}>;


export type CreateAgentMutation = { __typename?: 'RootMutationType', createAgent?: { __typename?: 'Agent', id: string, model?: ModelCode | null, systemMessage?: string | null, agentGreeting?: string | null, context?: any | null } | null };

export type UpdateAgentMutationVariables = Exact<{
  input: UpdateAgentInput;
}>;


export type UpdateAgentMutation = { __typename?: 'RootMutationType', updateAgent?: { __typename?: 'Agent', id: string, model?: ModelCode | null, systemMessage?: string | null, agentGreeting?: string | null, context?: any | null } | null };

export type CreateConversationMutationVariables = Exact<{
  input: CreateConversationInput;
}>;


export type CreateConversationMutation = { __typename?: 'RootMutationType', createConversation?: { __typename?: 'Conversation', id: string, title: string, summary?: string | null, metadata: any } | null };

export type GetConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConversationQuery = { __typename?: 'RootQueryType', conversation?: { __typename?: 'Conversation', id: string, title: string, summary?: string | null, metadata: any, insertedAt: any, type: ConversationType, agentStatus: AgentStatus, systemPrompts: Array<{ __typename?: 'SystemPrompt', agentId: string, prompt: string }>, messages: Array<{ __typename?: 'Message', id: string, timestamp: string, conversationId: string, parentId?: string | null, metadata: any, parts: Array<{ __typename?: 'ImageUrlPart', id: string, imageUrl: { __typename?: 'ImageUrl', url: string, detail?: string | null } } | { __typename?: 'TextPart', id: string, text: string } | { __typename?: 'ThinkingPart', id: string, thinking: { __typename?: 'Thinking', content: string, signature?: string | null } } | { __typename?: 'ToolCallPart', id: string, toolCall: { __typename?: 'ToolCall', id: string, name: string, arguments?: string | null, result?: string | null, error?: string | null, status: string } }>, profile?: { __typename?: 'Profile', id: string, type: ProfileType, name: string, avatarUrl?: string | null } | null }> } | null };

export type GetConversationsQueryVariables = Exact<{
  filter?: InputMaybe<ConversationFilterInput>;
}>;


export type GetConversationsQuery = { __typename?: 'RootQueryType', conversations: Array<{ __typename?: 'Conversation', id: string, title: string, summary?: string | null, metadata: any }> };

export type ListConversationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListConversationsFilter>;
}>;


export type ListConversationsQuery = { __typename?: 'RootQueryType', listConversations?: { __typename?: 'ConversationConnection', edges?: Array<{ __typename?: 'ConversationEdge', cursor?: string | null, node?: { __typename?: 'Conversation', id: string, title: string, type: ConversationType, summary?: string | null, metadata: any, insertedAt: any, updatedAt: any } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ConversationEventsSubscriptionVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type ConversationEventsSubscription = { __typename?: 'RootSubscriptionType', conversationEvents?: { __typename?: 'AgentStatusEvent', id: string, conversationId: string, agentId: string, agentStatus: AgentStatus, message?: string | null, error?: string | null, toolName?: string | null, timestamp: string } | { __typename?: 'ChildMessageEvent', id: string, type: string, messageType: string, sourceConversationId: string, sourceConversationTitle?: string | null, timestamp: string, data?: any | null } | { __typename?: 'ConversationCompactedEvent', id: string, conversationId: string, snapshotId: string, messagesSummarized: number, lastMessageId: string, snapshotTokens: number, snapshotSizeBytes: number, timestamp: string } | { __typename?: 'ConversationCompactingEvent', id: string, conversationId: string, timestamp: string, messageCount: number } | { __typename?: 'ConversationUpdateEvent', id: string, title: string, summary?: string | null, metadata: any, timestamp: string } | { __typename?: 'Message', id: string, timestamp: string, conversationId: string, parentId?: string | null, metadata: any, parts: Array<{ __typename?: 'ImageUrlPart', id: string, imageUrl: { __typename?: 'ImageUrl', url: string, detail?: string | null } } | { __typename?: 'TextPart', id: string, text: string } | { __typename?: 'ThinkingPart', id: string, thinking: { __typename?: 'Thinking', content: string, signature?: string | null } } | { __typename?: 'ToolCallPart', id: string, toolCall: { __typename?: 'ToolCall', id: string, name: string, arguments?: string | null, result?: string | null, error?: string | null, status: string } }>, profile?: { __typename?: 'Profile', id: string, type: ProfileType, name: string, avatarUrl?: string | null } | null } | { __typename?: 'MessagePartStreamingEvent', id: string, messageId: string, content?: string | null, timestamp: string } | { __typename?: 'ThinkingStreamingEvent', id: string, messageId: string, thinkingPartId: string, content?: string | null, signature?: string | null, timestamp: string } | { __typename?: 'ToolCallApprovalEvent', id: string, conversationId: string, agentId: string, toolCallId: string, approvalMode: ToolCallApprovalState, status: string, timestamp: string } | { __typename?: 'ToolCallMessageEvent', id: string, conversationId: string, agentId: string, toolCallId: string, toolName?: string | null, arguments?: string | null, result?: string | null, error?: string | null, status: string, timestamp: string } | { __typename?: 'ToolResultCompactedEvent', id: string, conversationId: string, timestamp: string, toolCallId: string, toolName?: string | null, format: string, originalSizeBytes?: number | null, encodedSizeBytes: number, tokenSavingsPct?: number | null } | { __typename?: 'ToolResultCompactingEvent', id: string, conversationId: string, timestamp: string, toolCallId: string, toolName?: string | null, originalSizeBytes?: number | null } | null };

export type AskMutationVariables = Exact<{
  input: ConversationInput;
}>;


export type AskMutation = { __typename?: 'RootMutationType', ask?: { __typename?: 'ConversationResponse', userMessage?: { __typename?: 'Message', id: string } | null } | null };

export type GetConversationSystemPromptsQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type GetConversationSystemPromptsQuery = { __typename?: 'RootQueryType', conversation?: { __typename?: 'Conversation', id: string, systemPrompts: Array<{ __typename?: 'SystemPrompt', agentId: string, prompt: string }> } | null };

export type UpdateConversationSystemPromptMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  agentId: Scalars['ID']['input'];
  systemPrompt: Scalars['String']['input'];
}>;


export type UpdateConversationSystemPromptMutation = { __typename?: 'RootMutationType', updateConversationSystemPrompt?: { __typename?: 'Conversation', id: string, systemPrompts: Array<{ __typename?: 'SystemPrompt', agentId: string, prompt: string }> } | null };

export type UpdateConversationTitleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type UpdateConversationTitleMutation = { __typename?: 'RootMutationType', updateConversationTitle?: { __typename?: 'Conversation', id: string, title: string } | null };

export type SummarizeConversationMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type SummarizeConversationMutation = { __typename?: 'RootMutationType', summarizeConversation?: { __typename?: 'ConversationSummaryResult', success: boolean, summary?: string | null, error?: string | null } | null };

export type SetToolCallPolicyMutationVariables = Exact<{
  input: ToolCallPolicyInput;
}>;


export type SetToolCallPolicyMutation = { __typename?: 'RootMutationType', setToolCallPolicy?: { __typename?: 'ToolCallPolicyResult', success: boolean, message?: string | null } | null };

export type ResolveConsentMutationVariables = Exact<{
  input: ResolveConsentInput;
}>;


export type ResolveConsentMutation = { __typename?: 'RootMutationType', resolveConsent?: { __typename?: 'ResolveConsentResult', success: boolean, message?: string | null } | null };

export type StopAgentStreamMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  agentId: Scalars['ID']['input'];
}>;


export type StopAgentStreamMutation = { __typename?: 'RootMutationType', stopAgentStream?: boolean | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'RootMutationType', logout?: { __typename?: 'LogoutResult', success: boolean, message?: string | null } | null };

export type DevAutoLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type DevAutoLoginMutation = { __typename?: 'RootMutationType', devAutoLogin?: { __typename?: 'UserDetails', details?: any | null, isAdmin: boolean, isPlg: boolean, features?: { __typename?: 'UserFeatures', customAgents: boolean, secretsManagementEnabled: boolean, devoAssistantEnabled: boolean, externalConnectors: boolean, sentryUnmaskData: boolean } | null } | null };

export type GetPublicConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicConfigQuery = { __typename?: 'RootQueryType', publicConfig: { __typename?: 'PublicConfig', bypassKeycloakAuth: boolean, keycloak: { __typename?: 'KeycloakConfig', clientId?: string | null, realm?: string | null, url?: string | null, redirectUrl?: string | null } } };

export type GetUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDetailsQuery = { __typename?: 'RootQueryType', userDetails?: { __typename?: 'UserDetails', details?: any | null, isAdmin: boolean, isPlg: boolean, features?: { __typename?: 'UserFeatures', automationsToolsEnabled?: boolean | null, caseManagementToolsEnabled?: boolean | null, customAgents: boolean, externalConnectors: boolean, devoAssistantEnabled: boolean, devoToolsEnabled: boolean, gitlabToolsEnabled: boolean, knowledgebasesEdit: boolean, knowledgebasesViewOnly: boolean, mcpManagement: boolean, secOpsToolsEnabled?: boolean | null, secretsManagementEnabled: boolean, webhooksEnabled: boolean, workflowBuilderEnabled: boolean, workflowsManage: boolean, sentryUnmaskData: boolean, asocV2Enabled: boolean } | null } | null };

export type ListDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListDocumentsFilter>;
}>;


export type ListDocumentsQuery = { __typename?: 'RootQueryType', listDocuments?: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', cursor?: string | null, node?: { __typename?: 'Document', id: string, title: string, type: string, timestamp?: string | null, conversation?: { __typename?: 'Conversation', id: string, title: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetDocumentQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
}>;


export type GetDocumentQuery = { __typename?: 'RootQueryType', document?: { __typename?: 'Document', id: string, title: string, type: string, content?: string | null, timestamp?: string | null } | null };

export type GetAgentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAgentQuery = { __typename?: 'RootQueryType', agent?: { __typename?: 'Agent', id: string, name: string, description?: string | null, isPublic: boolean, isTemplate: boolean, isEnabled: boolean, systemMessage?: string | null, agentGreeting?: string | null, context?: any | null, tools?: any | null, knowledgeBases?: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, documentCount?: number | null }> | null } | null };

export type ListAllAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAllAgentsQuery = { __typename?: 'RootQueryType', templateAgents?: { __typename?: 'AgentConnection', edges?: Array<{ __typename?: 'AgentEdge', cursor?: string | null, node?: { __typename?: 'Agent', id: string, name: string, description?: string | null, displayOrder?: number | null, isPublic: boolean, isTemplate: boolean, isEnabled: boolean, systemMessage?: string | null, agentGreeting?: string | null, context?: any | null, tools?: any | null, knowledgeBases?: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, documentCount?: number | null }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null, customAgents?: { __typename?: 'AgentConnection', edges?: Array<{ __typename?: 'AgentEdge', cursor?: string | null, node?: { __typename?: 'Agent', id: string, name: string, description?: string | null, displayOrder?: number | null, isPublic: boolean, isTemplate: boolean, isEnabled: boolean, systemMessage?: string | null, agentGreeting?: string | null, context?: any | null, tools?: any | null, knowledgeBases?: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, documentCount?: number | null }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ListFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFoldersQuery = { __typename?: 'RootQueryType', folders: Array<{ __typename?: 'Folder', id: string, name: string, config?: any | null }> };

export type CreateFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;


export type CreateFolderMutation = { __typename?: 'RootMutationType', createFolder?: { __typename?: 'Folder', id: string, name: string, config?: any | null } | null };

export type UpdateFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateFolderInput;
}>;


export type UpdateFolderMutation = { __typename?: 'RootMutationType', updateFolder?: { __typename?: 'Folder', id: string, name: string, config?: any | null } | null };

export type DeleteFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFolderMutation = { __typename?: 'RootMutationType', deleteFolder?: { __typename?: 'Folder', id: string } | null };

export type GetKnowledgeBasesQueryVariables = Exact<{
  filter?: InputMaybe<KnowledgeBaseFilterInput>;
}>;


export type GetKnowledgeBasesQuery = { __typename?: 'RootQueryType', knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, config?: any | null, metadata?: any | null, insertedAt?: string | null, updatedAt?: string | null, documents?: Array<{ __typename?: 'KnowledgeBaseDocument', filename: string, fileSize: number }> | null }> };

export type GetKnowledgeBaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKnowledgeBaseQuery = { __typename?: 'RootQueryType', knowledgeBase?: { __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, config?: any | null, metadata?: any | null, documentCount?: number | null, insertedAt?: string | null, updatedAt?: string | null, documents?: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, filename: string, originalFilename: string, contentType: string, fileSize: number, fileHash: string, knowledgeBaseId: string, status: DocumentStatus, processedAt?: string | null, processingError?: string | null, metadata?: any | null, insertedAt?: string | null, updatedAt?: string | null }> | null } | null };

export type GetKnowledgeBaseDocumentsQueryVariables = Exact<{
  filter: DocumentFilterInput;
}>;


export type GetKnowledgeBaseDocumentsQuery = { __typename?: 'RootQueryType', knowledgeBaseDocuments: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, knowledgeBaseId: string, filename: string, originalFilename: string, contentType: string, fileSize: number, status: DocumentStatus, processedAt?: string | null, processingError?: string | null, metadata?: any | null, insertedAt?: string | null, updatedAt?: string | null }> };

export type CreateKnowledgeBaseMutationVariables = Exact<{
  input: CreateKnowledgeBaseInput;
}>;


export type CreateKnowledgeBaseMutation = { __typename?: 'RootMutationType', createKnowledgeBase?: { __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, config?: any | null, metadata?: any | null, documentCount?: number | null, insertedAt?: string | null, updatedAt?: string | null } | null };

export type UpdateKnowledgeBaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseInput;
}>;


export type UpdateKnowledgeBaseMutation = { __typename?: 'RootMutationType', updateKnowledgeBase?: { __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, config?: any | null, metadata?: any | null, documentCount?: number | null, insertedAt?: string | null, updatedAt?: string | null } | null };

export type UpdateKnowledgeBaseStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: KnowledgeBaseStatus;
}>;


export type UpdateKnowledgeBaseStatusMutation = { __typename?: 'RootMutationType', updateKnowledgeBaseStatus?: { __typename?: 'KnowledgeBase', id: string, name: string, description?: string | null, status: KnowledgeBaseStatus, config?: any | null, metadata?: any | null, documentCount?: number | null, insertedAt?: string | null, updatedAt?: string | null } | null };

export type DeleteKnowledgeBaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKnowledgeBaseMutation = { __typename?: 'RootMutationType', deleteKnowledgeBase?: boolean | null };

export type UploadDocumentMutationVariables = Exact<{
  input: UploadDocumentInput;
}>;


export type UploadDocumentMutation = { __typename?: 'RootMutationType', uploadDocument?: { __typename?: 'KnowledgeBaseDocument', id: string, knowledgeBaseId: string, filename: string, originalFilename: string, contentType: string, fileSize: number, status: DocumentStatus, processedAt?: string | null, processingError?: string | null, metadata?: any | null, insertedAt?: string | null, updatedAt?: string | null } | null };

export type RemoveDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type RemoveDocumentMutation = { __typename?: 'RootMutationType', removeDocument?: { __typename?: 'KnowledgeBaseDocument', id: string, knowledgeBaseId: string, filename: string, status: DocumentStatus, processedAt?: string | null, updatedAt?: string | null } | null };

export type PermanentlyDeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type PermanentlyDeleteDocumentMutation = { __typename?: 'RootMutationType', permanentlyDeleteDocument?: boolean | null };

export type AttachKnowledgeBaseToAgentMutationVariables = Exact<{
  input: AttachKnowledgeBaseInput;
}>;


export type AttachKnowledgeBaseToAgentMutation = { __typename?: 'RootMutationType', attachKnowledgeBaseToAgent?: { __typename?: 'AgentKnowledgeBase', id: string, agentId: string, knowledgeBaseId: string, metadata?: any | null, insertedAt?: string | null } | null };

export type DetachKnowledgeBaseFromAgentMutationVariables = Exact<{
  agentId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
}>;


export type DetachKnowledgeBaseFromAgentMutation = { __typename?: 'RootMutationType', detachKnowledgeBaseFromAgent?: boolean | null };

export type QueryAgentKnowledgeBasesQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  knowledgeBaseIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type QueryAgentKnowledgeBasesQuery = { __typename?: 'RootQueryType', queryAgentKnowledgeBases?: { __typename?: 'KnowledgeBaseQueryResult', content: string, sourceDocuments?: Array<string | null> | null, metadata?: any | null } | null };

export type KnowledgeBaseUpdatesSubscriptionVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
}>;


export type KnowledgeBaseUpdatesSubscription = { __typename?: 'RootSubscriptionType', knowledgeBaseUpdates?: { __typename?: 'KnowledgeBaseUpdateEvent', type: UpdateEventType, message?: string | null, timestamp: string, knowledgeBase?: { __typename?: 'KnowledgeBase', id: string, name: string, status: KnowledgeBaseStatus, documentCount?: number | null } | null, document?: { __typename?: 'KnowledgeBaseDocument', id: string, filename: string, status: DocumentStatus, processedAt?: string | null } | null } | null };

export type DocumentProcessingUpdatesSubscriptionVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type DocumentProcessingUpdatesSubscription = { __typename?: 'RootSubscriptionType', documentProcessingUpdates?: { __typename?: 'DocumentProcessingEvent', documentId: string, event: string, timestamp: string, processingResponse?: { __typename?: 'ProcessingTrackResponse', trackId: string, totalCount: number, statusSummary?: any | null, documents?: Array<{ __typename?: 'DocumentProcessingStatus', id: string, status: string, contentSummary?: string | null, contentLength?: number | null, chunksCount?: number | null, errorMsg?: string | null, filePath: string, createdAt: string, updatedAt: string, metadata?: any | null } | null> | null } | null } | null };

export type QueryKnowledgeBaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryKnowledgeBaseQuery = { __typename?: 'RootQueryType', queryKnowledgeBase?: { __typename?: 'KnowledgeBaseQueryResult', content: string, sourceDocuments?: Array<string | null> | null, metadata?: any | null } | null };

export type GetToolsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToolsQuery = { __typename?: 'RootQueryType', tools: Array<{ __typename?: 'Tool', name: string, description: string, enabled: boolean, category: string }> };

export type ListJobConfigsQueryVariables = Exact<{
  filter?: InputMaybe<JobConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListJobConfigsQuery = { __typename?: 'RootQueryType', listJobConfigs?: { __typename?: 'JobConfigConnection', edges?: Array<{ __typename?: 'JobConfigEdge', cursor?: string | null, node?: { __typename?: 'JobConfig', id: string, name: string, description?: string | null, enabled: boolean, cronExpr?: string | null, toolsApproved: Array<string>, agent?: { __typename?: 'Agent', id: string, name: string } | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, displayName?: string | null } | null, triggers?: Array<{ __typename?: 'Trigger', id: string, name: string, triggerType: TriggerType, enabled: boolean, cronExpression?: string | null, webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetJobConfigQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobConfigQuery = { __typename?: 'RootQueryType', getJobConfig?: { __typename?: 'JobConfig', id: string, name: string, description?: string | null, enabled: boolean, cronExpr?: string | null, prompt: string, toolsApproved: Array<string>, agent?: { __typename?: 'Agent', id: string } | null } | null };

export type CreateJobConfigMutationVariables = Exact<{
  input: JobConfigInput;
}>;


export type CreateJobConfigMutation = { __typename?: 'RootMutationType', createJobConfig?: { __typename?: 'JobConfig', id: string } | null };

export type UpdateJobConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: JobConfigUpdateInput;
}>;


export type UpdateJobConfigMutation = { __typename?: 'RootMutationType', updateJobConfig?: { __typename?: 'JobConfig', id: string } | null };

export type DeleteJobConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobConfigMutation = { __typename?: 'RootMutationType', deleteJobConfig?: { __typename?: 'JobConfig', id: string } | null };

export type MarkJobInstanceAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkJobInstanceAsReadMutation = { __typename?: 'RootMutationType', markJobInstanceAsRead?: { __typename?: 'JobInstance', id: string, updatedAt: any } | null };

export type GetJobInstanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobInstanceQuery = { __typename?: 'RootQueryType', getJobInstance?: { __typename?: 'JobInstance', id: string, startedAt?: string | null, updatedAt: any, status: JobInstanceStatus, errorMessage?: string | null, isRead: boolean, jobConfig: { __typename?: 'JobConfig', id: string, name: string, description?: string | null, enabled: boolean, cronExpr?: string | null, toolsApproved: Array<string>, agent?: { __typename?: 'Agent', id: string } | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, displayName?: string | null } | null }, agent?: { __typename?: 'Agent', id: string, name: string } | null, conversation?: { __typename?: 'Conversation', id: string } | null } | null };

export type ListJobInstancesQueryVariables = Exact<{
  filter?: InputMaybe<JobInstanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListJobInstancesQuery = { __typename?: 'RootQueryType', listJobInstances?: { __typename?: 'JobInstanceConnection', edges?: Array<{ __typename?: 'JobInstanceEdge', cursor?: string | null, node?: { __typename?: 'JobInstance', id: string, startedAt?: string | null, updatedAt: any, status: JobInstanceStatus, errorMessage?: string | null, isRead: boolean, agent?: { __typename?: 'Agent', id: string, name: string } | null, conversation?: { __typename?: 'Conversation', id: string } | null, jobConfig: { __typename?: 'JobConfig', id: string, name: string, description?: string | null, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, displayName?: string | null } | null } } | null } | null> | null } | null };

export type GetNotableJobInstanceCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotableJobInstanceCountsQuery = { __typename?: 'RootQueryType', unread?: Array<{ __typename?: 'JobInstanceCountByAgent', agentId: string, count: number }> | null, awaitingConsent?: Array<{ __typename?: 'JobInstanceCountByAgent', agentId: string, count: number }> | null };

export type GetJobConfigCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobConfigCountsQuery = { __typename?: 'RootQueryType', countJobConfigsByAgent?: Array<{ __typename?: 'JobConfigCountByAgent', agentId: string, count: number }> | null };

export type ListSecretsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SecretFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListSecretsQuery = { __typename?: 'RootQueryType', listSecrets?: { __typename?: 'SecretConnection', edges?: Array<{ __typename?: 'SecretEdge', cursor?: string | null, node?: { __typename?: 'Secret', id: string, name: string, type: SecretType, updatedAt?: string | null, url?: string | null, metadata?: any | null, agents?: Array<{ __typename?: 'Agent', id: string, name: string }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type DeleteSecretMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSecretMutation = { __typename?: 'RootMutationType', deleteSecret?: { __typename?: 'Secret', id: string } | null };

export type CreateSecretMutationVariables = Exact<{
  input: CreateSecretInput;
}>;


export type CreateSecretMutation = { __typename?: 'RootMutationType', createSecret?: { __typename?: 'Secret', id: string, name: string, type: SecretType, updatedAt?: string | null } | null };

export type UpdateSecretMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSecretInput;
}>;


export type UpdateSecretMutation = { __typename?: 'RootMutationType', updateSecret?: { __typename?: 'Secret', id: string, name: string, updatedAt?: string | null } | null };

export type ListAgentSecretsQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type ListAgentSecretsQuery = { __typename?: 'RootQueryType', agentSecrets: Array<{ __typename?: 'Secret', id: string, name: string, type: SecretType, updatedAt?: string | null }> };

export type GrantAgentSecretAccessMutationVariables = Exact<{
  input: GrantAgentAccessInput;
}>;


export type GrantAgentSecretAccessMutation = { __typename?: 'RootMutationType', grantAgentSecretAccess?: { __typename?: 'Secret', id: string, name: string, type: SecretType, updatedAt?: string | null } | null };

export type RevokeAgentSecretAccessMutationVariables = Exact<{
  input: RevokeAgentAccessInput;
}>;


export type RevokeAgentSecretAccessMutation = { __typename?: 'RootMutationType', revokeAgentSecretAccess?: { __typename?: 'Secret', id: string, name: string, type: SecretType, updatedAt?: string | null } | null };

export type ConversationFilesystemQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type ConversationFilesystemQuery = { __typename?: 'RootQueryType', conversationFilesystem?: { __typename?: 'FilesystemState', currentDirectory?: string | null, files: Array<{ __typename?: 'FilesystemFile', path: string, type: string, content?: string | null, createdAt?: string | null, modifiedAt?: string | null }> } | null };

export type ListWorkflowsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WorkflowFilter>;
}>;


export type ListWorkflowsQuery = { __typename?: 'RootQueryType', workflows?: { __typename?: 'WorkflowDefinitionConnection', totalCount: number, edges?: Array<{ __typename?: 'WorkflowDefinitionEdge', cursor: string, node: { __typename?: 'WorkflowDefinition', id: string, name: string, description?: string | null, version: string, status: WorkflowStatus, isLatest: boolean, externalWorkflowId?: string | null, workflowSpec?: any | null, inputSchema?: any | null, outputSchema?: any | null, outputs?: Array<any | null> | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', id: string, email?: string | null, insertedAt: string, updatedAt: string } | null, latestExecution?: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, outputs?: any | null, startedAt?: any | null, completedAt?: any | null, createdAt: any, updatedAt: any, workflowDefinitionId: string } | null } } | null> | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetWorkflowCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowCountsQuery = { __typename?: 'RootQueryType', publishedCount?: { __typename?: 'WorkflowDefinitionConnection', totalCount: number } | null, draftCount?: { __typename?: 'WorkflowDefinitionConnection', totalCount: number } | null, deprecatedCount?: { __typename?: 'WorkflowDefinitionConnection', totalCount: number } | null };

export type GetWorkflowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkflowQuery = { __typename?: 'RootQueryType', workflow?: { __typename?: 'WorkflowDefinition', id: string, name: string, description?: string | null, version: string, status: WorkflowStatus, isLatest: boolean, engine?: string | null, externalWorkflowId?: string | null, workflowSpec?: any | null, inputSchema?: any | null, outputSchema?: any | null, outputs?: Array<any | null> | null, metadata?: any | null, createdAt: any, updatedAt: any, createdById?: string | null, workflowType: string, isRoot: boolean, isSubworkflow: boolean, isShared: boolean, createdBy?: { __typename?: 'User', id: string, email?: string | null, insertedAt: string, updatedAt: string } | null } | null };

export type ListExecutionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExecutionFilter>;
}>;


export type ListExecutionsQuery = { __typename?: 'RootQueryType', executions?: { __typename?: 'WorkflowExecutionConnection', edges?: Array<{ __typename?: 'WorkflowExecutionEdge', cursor: string, node: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, inputs?: any | null, outputs?: any | null, errorMessage?: string | null, startedAt?: any | null, completedAt?: any | null, workflowDefinition?: { __typename?: 'WorkflowDefinition', id: string, name: string, version: string } | null, triggeredBy?: { __typename?: 'User', id: string, email?: string | null, insertedAt: string, updatedAt: string } | null } } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetExecutionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExecutionQuery = { __typename?: 'RootQueryType', execution?: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, inputs?: any | null, outputs?: any | null, errorMessage?: string | null, startedAt?: any | null, completedAt?: any | null, workflowDefinitionId: string, triggeredById?: string | null, executionStateSnapshot?: any | null, artifacts?: Array<{ __typename?: 'Artifact', artifactId: string, name?: string | null, uri: string, size?: number | null, hash?: string | null, contentType?: string | null, storageBackend?: string | null, metadata?: any | null, createdAt?: any | null } | null> | null, workflowDefinition?: { __typename?: 'WorkflowDefinition', id: string, name: string, version: string, engine?: string | null, workflowSpec?: any | null } | null, triggeredBy?: { __typename?: 'User', id: string, email?: string | null, insertedAt: string, updatedAt: string } | null, currentStatus?: { __typename?: 'ExecutionStatusDetail', status: ExecutionStatus, phase: string, message?: string | null, updatedAt: any } | null, nodeExecutions?: Array<{ __typename?: 'NodeExecution', nodeId: string, displayName: string, phase: string, startedAt?: any | null, updatedAt?: any | null, duration?: string | null, attempt?: number | null, inputs?: any | null, outputs?: any | null, errorMessage?: string | null, logsUri?: string | null, inputUri?: string | null, outputUri?: string | null, cacheStatus?: string | null, artifacts?: Array<{ __typename?: 'Artifact', artifactId: string, name?: string | null, uri: string, size?: number | null, hash?: string | null, contentType?: string | null, storageBackend?: string | null, metadata?: any | null, createdAt?: any | null } | null> | null, metadata?: { __typename?: 'NodeExecutionMetadata', specNodeId?: string | null, isParentNode?: boolean | null, isDynamic?: boolean | null, isArray?: boolean | null } | null, subworkflowExecutionInfo?: { __typename?: 'SubworkflowExecutionInfo', isSubworkflow: boolean, childNodeCount: number, aggregateStatus: string, childExecutionId?: string | null, childPhases?: Array<{ __typename?: 'ChildNodePhase', nodeId: string, phase: string } | null> | null } | null, workflowNodeMetadata?: { __typename?: 'WorkflowNodeMetadata', executionId: { __typename?: 'WorkflowExecutionIdentifier', project: string, domain: string, name: string } } | null, arrayTaskStatuses?: { __typename?: 'ArrayTaskStatusSummary', total: number, succeeded: number, running: number, failed: number, queued: number, pending: number } | null, taskExecutions?: Array<{ __typename?: 'TaskExecution', retryAttempt: number, phase: string, startedAt?: any | null, duration?: string | null, errorMessage?: string | null, logsUri?: string | null } | null> | null } | null> | null, signals?: Array<{ __typename?: 'ExecutionSignal', signalId: string, type: string, value?: any | null, hasValue: boolean, schema?: any | null } | null> | null } | null };

export type GetExecutionByExternalIdQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetExecutionByExternalIdQuery = { __typename?: 'RootQueryType', executionByExternalId?: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, inputs?: any | null, outputs?: any | null, errorMessage?: string | null, startedAt?: any | null, completedAt?: any | null, workflowDefinitionId: string, triggeredById?: string | null, executionStateSnapshot?: any | null, artifacts?: Array<{ __typename?: 'Artifact', artifactId: string, name?: string | null, uri: string, size?: number | null, hash?: string | null, contentType?: string | null, storageBackend?: string | null, metadata?: any | null, createdAt?: any | null } | null> | null, workflowDefinition?: { __typename?: 'WorkflowDefinition', id: string, name: string, version: string, engine?: string | null, workflowSpec?: any | null } | null, triggeredBy?: { __typename?: 'User', id: string, email?: string | null, insertedAt: string, updatedAt: string } | null, currentStatus?: { __typename?: 'ExecutionStatusDetail', status: ExecutionStatus, phase: string, message?: string | null, updatedAt: any } | null, nodeExecutions?: Array<{ __typename?: 'NodeExecution', nodeId: string, displayName: string, phase: string, startedAt?: any | null, updatedAt?: any | null, duration?: string | null, attempt?: number | null, inputs?: any | null, outputs?: any | null, errorMessage?: string | null, logsUri?: string | null, inputUri?: string | null, outputUri?: string | null, cacheStatus?: string | null, artifacts?: Array<{ __typename?: 'Artifact', artifactId: string, name?: string | null, uri: string, size?: number | null, hash?: string | null, contentType?: string | null, storageBackend?: string | null, metadata?: any | null, createdAt?: any | null } | null> | null, metadata?: { __typename?: 'NodeExecutionMetadata', specNodeId?: string | null, isParentNode?: boolean | null, isDynamic?: boolean | null, isArray?: boolean | null } | null, subworkflowExecutionInfo?: { __typename?: 'SubworkflowExecutionInfo', isSubworkflow: boolean, childNodeCount: number, aggregateStatus: string, childExecutionId?: string | null, childPhases?: Array<{ __typename?: 'ChildNodePhase', nodeId: string, phase: string } | null> | null } | null, workflowNodeMetadata?: { __typename?: 'WorkflowNodeMetadata', executionId: { __typename?: 'WorkflowExecutionIdentifier', project: string, domain: string, name: string } } | null, arrayTaskStatuses?: { __typename?: 'ArrayTaskStatusSummary', total: number, succeeded: number, running: number, failed: number, queued: number, pending: number } | null, taskExecutions?: Array<{ __typename?: 'TaskExecution', retryAttempt: number, phase: string, startedAt?: any | null, duration?: string | null, errorMessage?: string | null, logsUri?: string | null } | null> | null } | null> | null, signals?: Array<{ __typename?: 'ExecutionSignal', signalId: string, type: string, value?: any | null, hasValue: boolean, schema?: any | null } | null> | null } | null };

export type GetExecutionEventsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExecutionEventsQuery = { __typename?: 'RootQueryType', executionEvents?: Array<{ __typename?: 'ExecutionEvent', id: string, occurredAt?: string | null, phase?: string | null, producerId?: string | null, message?: string | null, eventType?: string | null } | null> | null };

export type GetMyWorkflowsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyWorkflowsQuery = { __typename?: 'RootQueryType', myWorkflows?: { __typename?: 'WorkflowDefinitionConnection', edges?: Array<{ __typename?: 'WorkflowDefinitionEdge', node: { __typename?: 'WorkflowDefinition', id: string, name: string, description?: string | null, version: string, status: WorkflowStatus, isLatest: boolean, createdAt: any } } | null> | null } | null };

export type CreateWorkflowMutationVariables = Exact<{
  input: CreateWorkflowInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'RootMutationType', createWorkflow?: { __typename?: 'WorkflowDefinition', id: string, name: string, description?: string | null, version: string, status: WorkflowStatus, workflowSpec?: any | null, metadata?: any | null, createdById?: string | null, createdAt: any } | null };

export type CreateWorkflowFromTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
}>;


export type CreateWorkflowFromTemplateMutation = { __typename?: 'RootMutationType', createWorkflowFromTemplate?: { __typename?: 'WorkflowDefinition', id: string, name: string, description?: string | null, version: string, status: WorkflowStatus, workflowSpec?: any | null, metadata?: any | null, createdById?: string | null, createdAt: any } | null };

export type UpdateWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'RootMutationType', updateWorkflow?: { __typename?: 'WorkflowDefinition', id: string, name: string, description?: string | null, version: string, status: WorkflowStatus, workflowSpec?: any | null, metadata?: any | null, updatedAt: any } | null };

export type PublishWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PublishWorkflowMutation = { __typename?: 'RootMutationType', publishWorkflow?: { __typename?: 'WorkflowDefinition', id: string, status: WorkflowStatus, externalWorkflowId?: string | null } | null };

export type CreateWorkflowVersionMutationVariables = Exact<{
  workflowId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
}>;


export type CreateWorkflowVersionMutation = { __typename?: 'RootMutationType', createWorkflowVersion?: { __typename?: 'WorkflowDefinition', id: string, name: string, version: string, status: WorkflowStatus, description?: string | null, workflowSpec?: any | null } | null };

export type DeleteWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWorkflowMutation = { __typename?: 'RootMutationType', deleteWorkflow?: { __typename?: 'WorkflowDefinition', id: string, status: WorkflowStatus } | null };

export type ExecuteWorkflowMutationVariables = Exact<{
  input: ExecuteWorkflowInput;
}>;


export type ExecuteWorkflowMutation = { __typename?: 'RootMutationType', executeWorkflow?: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, inputs?: any | null, startedAt?: any | null, workflowDefinitionId: string, triggeredById?: string | null } | null };

export type CancelExecutionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelExecutionMutation = { __typename?: 'RootMutationType', cancelExecution?: { __typename?: 'WorkflowExecution', id: string, status: ExecutionStatus } | null };

export type RetryExecutionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetryExecutionMutation = { __typename?: 'RootMutationType', retryExecution?: { __typename?: 'WorkflowExecution', id: string, status: ExecutionStatus, externalId?: string | null, startedAt?: any | null, metadata?: any | null } | null };

export type ExecuteTaskMutationVariables = Exact<{
  input: ExecuteTaskInput;
}>;


export type ExecuteTaskMutation = { __typename?: 'RootMutationType', executeTask?: { __typename?: 'TaskExecutionResult', status: string, outputs?: any | null, error?: string | null, errorType?: string | null } | null };

export type SetSignalMutationVariables = Exact<{
  executionId: Scalars['ID']['input'];
  signalId: Scalars['String']['input'];
  value: Scalars['Json']['input'];
}>;


export type SetSignalMutation = { __typename?: 'RootMutationType', setSignal?: { __typename?: 'SetSignalResult', success: boolean, message?: string | null } | null };

export type ExecutionUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExecutionUpdatedSubscription = { __typename?: 'RootSubscriptionType', executionUpdated?: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, outputs?: any | null, errorMessage?: string | null, completedAt?: any | null, currentStatus?: { __typename?: 'ExecutionStatusDetail', status: ExecutionStatus, phase: string, message?: string | null, updatedAt: any } | null } | null };

export type WorkflowExecutionsSubscriptionVariables = Exact<{
  workflowId: Scalars['ID']['input'];
}>;


export type WorkflowExecutionsSubscription = { __typename?: 'RootSubscriptionType', workflowExecutions?: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, startedAt?: any | null, triggeredBy?: { __typename?: 'User', id: string, email?: string | null } | null } | null };

export type GetWorkflowTemplatesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkflowTemplatesQuery = { __typename?: 'RootQueryType', workflowTemplates?: Array<{ __typename?: 'WorkflowTemplate', id: string, name: string, description: string, category: string, icon: string, template: { __typename?: 'WorkflowTemplateData', name: string, description: string, version: string, templateType?: string | null, workflowSpec: any } }> | null };

export type GetWorkflowTemplatesListQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkflowTemplatesListQuery = { __typename?: 'RootQueryType', workflowTemplatesSummary?: Array<{ __typename?: 'WorkflowTemplateSummary', id: string, name: string, description: string, category: string, icon: string }> | null };

export type GetWorkflowTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkflowTemplateQuery = { __typename?: 'RootQueryType', workflowTemplate?: { __typename?: 'WorkflowTemplate', id: string, name: string, description: string, category: string, icon: string, template: { __typename?: 'WorkflowTemplateData', name: string, description: string, version: string, templateType?: string | null, workflowSpec: any } } | null };

export type GetNodeExecutionLogsQueryVariables = Exact<{
  executionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
  tailLines?: InputMaybe<Scalars['Int']['input']>;
  sinceSeconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNodeExecutionLogsQuery = { __typename?: 'RootQueryType', nodeExecutionLogs?: { __typename?: 'ExecutionLogs', source: LogSource, hasMore: boolean, continuationToken?: string | null, metadata?: any | null, lines: Array<{ __typename?: 'LogLine', timestamp?: any | null, message: string, level?: LogLevel | null, source?: LogStreamSource | null, metadata?: any | null }> } | null };

export type GetTaskExecutionLogsQueryVariables = Exact<{
  executionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
  retryAttempt: Scalars['Int']['input'];
  tailLines?: InputMaybe<Scalars['Int']['input']>;
  sinceSeconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTaskExecutionLogsQuery = { __typename?: 'RootQueryType', taskExecutionLogs?: { __typename?: 'ExecutionLogs', source: LogSource, hasMore: boolean, continuationToken?: string | null, metadata?: any | null, lines: Array<{ __typename?: 'LogLine', timestamp?: any | null, message: string, level?: LogLevel | null, source?: LogStreamSource | null, metadata?: any | null }> } | null };

export type ExecutionLogsStreamSubscriptionVariables = Exact<{
  executionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
}>;


export type ExecutionLogsStreamSubscription = { __typename?: 'RootSubscriptionType', executionLogsStream?: { __typename?: 'LogLine', timestamp?: any | null, message: string, level?: LogLevel | null, source?: LogStreamSource | null, metadata?: any | null } | null };

export type ExecutionUpdatesSubscriptionVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;


export type ExecutionUpdatesSubscription = { __typename?: 'RootSubscriptionType', executionUpdates?: { __typename?: 'ExecutionUpdate', type: ExecutionUpdateType, changeType: string, timestamp: any, execution?: { __typename?: 'WorkflowExecution', id: string, externalId?: string | null, status: ExecutionStatus, outputs?: any | null, errorMessage?: string | null, startedAt?: any | null, completedAt?: any | null, signals?: Array<{ __typename?: 'ExecutionSignal', signalId: string, type: string, value?: any | null, hasValue: boolean, schema?: any | null } | null> | null } | null, nodeExecution?: { __typename?: 'NodeExecution', nodeId: string, displayName: string, phase: string, startedAt?: any | null, updatedAt?: any | null, duration?: string | null, errorMessage?: string | null, metadata?: { __typename?: 'NodeExecutionMetadata', specNodeId?: string | null, isParentNode?: boolean | null, isDynamic?: boolean | null, isArray?: boolean | null } | null, subworkflowExecutionInfo?: { __typename?: 'SubworkflowExecutionInfo', isSubworkflow: boolean, childNodeCount: number, aggregateStatus: string, childPhases?: Array<{ __typename?: 'ChildNodePhase', nodeId: string, phase: string } | null> | null } | null, taskExecutions?: Array<{ __typename?: 'TaskExecution', retryAttempt: number, phase: string, startedAt?: any | null, duration?: string | null, errorMessage?: string | null } | null> | null, workflowNodeMetadata?: { __typename?: 'WorkflowNodeMetadata', executionId: { __typename?: 'WorkflowExecutionIdentifier', project: string, domain: string, name: string } } | null } | null } | null };

export type HandoffExecutionEventsSubscriptionVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;


export type HandoffExecutionEventsSubscription = { __typename?: 'RootSubscriptionType', handoffExecutionEvents?: { __typename?: 'HandoffEvent', eventType: string, data?: any | null, timestamp: any, executionId?: string | null, taskId?: string | null } | null };

export type ExecutionEventsStreamSubscriptionVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;


export type ExecutionEventsStreamSubscription = { __typename?: 'RootSubscriptionType', executionEventsStream?: { __typename?: 'ExecutionEvent', id: string, occurredAt?: string | null, phase?: string | null, producerId?: string | null, message?: string | null, eventType?: string | null } | null };

export type WorkflowToolsQueryVariables = Exact<{
  engine?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkflowToolsQuery = { __typename?: 'RootQueryType', workflowTools?: Array<{ __typename?: 'WorkflowTool', name: string, description: string, autoApprove: boolean, parameters: { __typename?: 'WorkflowToolParameters', type: string, properties?: any | null, required?: Array<string> | null }, metadata: { __typename?: 'WorkflowToolMetadata', workflowId: string, workflowName: string, workflowVersion: string, toolType: string } }> | null };

export type ListMcpServersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListMcpServersQuery = { __typename?: 'RootQueryType', listMcpServers: Array<{ __typename?: 'McpServer', templateId: string, templateName: string, templateDescription?: string | null, url?: string | null, enabled: boolean, capabilities?: Array<string | null> | null, authRequired: boolean, supportedAuthTypes?: Array<string | null> | null }> };

export type ListMcpToolsQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type ListMcpToolsQuery = { __typename?: 'RootQueryType', listMcpTools: Array<{ __typename?: 'McpTool', name: string, description: string, title?: string | null, inputSchema: any }> };

export type EnableMcpServerMutationVariables = Exact<{
  input: EnableMcpServerInput;
}>;


export type EnableMcpServerMutation = { __typename?: 'RootMutationType', enableMcpServer?: { __typename?: 'McpServerResult', success: boolean, message?: string | null, validationStatus?: string | null, validationMessage?: string | null, toolCount?: number | null } | null };

export type UpdateMcpServerMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  input: UpdateMcpServerInput;
}>;


export type UpdateMcpServerMutation = { __typename?: 'RootMutationType', updateMcpServer?: { __typename?: 'McpServerResult', success: boolean, message?: string | null } | null };

export type DisableMcpServerMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type DisableMcpServerMutation = { __typename?: 'RootMutationType', disableMcpServer?: { __typename?: 'McpServerResult', success: boolean, message?: string | null } | null };

export type GetCaseAlertsQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseAlertsQuery = { __typename?: 'RootQueryType' };

export type GetCaseAlertsGroupedQueryVariables = Exact<{
  caseId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  xDevoDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCaseAlertsGroupedQuery = { __typename?: 'RootQueryType' };

export type ListWebhookEndpointsQueryVariables = Exact<{
  webhookType?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListWebhookEndpointsQuery = { __typename?: 'RootQueryType', listWebhookEndpoints: Array<{ __typename?: 'WebhookEndpoint', id: string, name?: string | null, description?: string | null, webhookType: string, webhookGuid?: string | null, status: string, insertedAt?: string | null, updatedAt?: string | null }> };

export type GetWebhookEndpointQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWebhookEndpointQuery = { __typename?: 'RootQueryType', webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null, description?: string | null, webhookType: string, webhookGuid?: string | null, status: string, insertedAt?: string | null, updatedAt?: string | null } | null };

export type CreateWebhookEndpointMutationVariables = Exact<{
  input: CreateWebhookEndpointInput;
}>;


export type CreateWebhookEndpointMutation = { __typename?: 'RootMutationType', createWebhookEndpoint?: { __typename?: 'WebhookEndpointResult', webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null, description?: string | null, webhookType: string, webhookGuid?: string | null, status: string } | null } | null };

export type GetTriggerExecutionsQueryVariables = Exact<{
  triggerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTriggerExecutionsQuery = { __typename?: 'RootQueryType', node?: { __typename?: 'Agent' } | { __typename?: 'Conversation' } | { __typename?: 'Document' } | { __typename?: 'JobConfig' } | { __typename?: 'JobInstance' } | { __typename?: 'Message' } | { __typename?: 'Secret' } | { __typename?: 'Trigger', id: string, name: string, triggerType: TriggerType, targets?: Array<{ __typename?: 'TriggerTarget', id: string, targetType: TriggerTargetType, targetId: string, workflow?: { __typename?: 'WorkflowDefinition', id: string, name: string, version: string } | null, job?: { __typename?: 'JobConfig', id: string, name: string } | null } | null> | null, executions?: Array<{ __typename?: 'TriggerExecution', id: string, status: TriggerExecutionStatus, triggeredAt: any, startedAt?: any | null, completedAt?: any | null, triggerEvent?: any | null, targetResults?: any | null, errorMessage?: string | null, durationMs?: number | null, insertedAt?: any | null } | null> | null } | { __typename?: 'WorkflowDefinition' } | { __typename?: 'WorkflowExecution' } | null };

export type TestTriggerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  payload?: InputMaybe<Scalars['Json']['input']>;
}>;


export type TestTriggerMutation = { __typename?: 'RootMutationType', testTrigger?: { __typename?: 'TestTriggerResult', trigger?: { __typename?: 'Trigger', id: string, name: string } | null, execution?: { __typename?: 'TriggerExecution', id: string, status: TriggerExecutionStatus, triggeredAt: any, triggerEvent?: any | null, targetResults?: any | null, durationMs?: number | null, errorMessage?: string | null } | null } | null };

export type UpdateTriggerTargetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTriggerTargetInput;
}>;


export type UpdateTriggerTargetMutation = { __typename?: 'RootMutationType', updateTriggerTarget?: { __typename?: 'TriggerTargetMutationResult', target?: { __typename?: 'TriggerTarget', id: string, inputMapping?: any | null } | null } | null };

export type ListTriggersForTargetQueryVariables = Exact<{
  targetType: TriggerTargetType;
  targetId: Scalars['ID']['input'];
}>;


export type ListTriggersForTargetQuery = { __typename?: 'RootQueryType', triggersForTarget: Array<{ __typename?: 'Trigger', id: string, name: string, triggerType: TriggerType, enabled: boolean, cronExpression?: string | null, timezone?: string | null, webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null } | null, targets?: Array<{ __typename?: 'TriggerTarget', id: string, targetType: TriggerTargetType, targetId: string, inputMapping?: any | null } | null> | null }> };

export type ListTriggersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListTriggersQuery = { __typename?: 'RootQueryType', listTriggers?: { __typename?: 'TriggerConnection', edges?: Array<{ __typename?: 'TriggerEdge', node: { __typename?: 'Trigger', id: string, name: string, description?: string | null, triggerType: TriggerType, enabled: boolean, cronExpression?: string | null, timezone?: string | null, payload?: any | null, webhookEndpointId?: string | null, insertedAt: any, updatedAt: any, webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null, webhookGuid?: string | null, status: string } | null, targets?: Array<{ __typename?: 'TriggerTarget', id: string, targetType: TriggerTargetType, targetId: string, enabled: boolean, priority: number, inputMapping?: any | null } | null> | null } } | null> | null } | null };

export type ListWorkflowsForTriggerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListWorkflowsForTriggerQuery = { __typename?: 'RootQueryType', workflows?: { __typename?: 'WorkflowDefinitionConnection', edges?: Array<{ __typename?: 'WorkflowDefinitionEdge', node: { __typename?: 'WorkflowDefinition', id: string, name: string, status: WorkflowStatus, inputSchema?: any | null } } | null> | null } | null };

export type ListJobsForTriggerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListJobsForTriggerQuery = { __typename?: 'RootQueryType', listJobConfigs?: { __typename?: 'JobConfigConnection', edges?: Array<{ __typename?: 'JobConfigEdge', node?: { __typename?: 'JobConfig', id: string, name: string } | null } | null> | null } | null };

export type CreateTriggerMutationVariables = Exact<{
  input: CreateTriggerInput;
}>;


export type CreateTriggerMutation = { __typename?: 'RootMutationType', createTrigger?: { __typename?: 'TriggerMutationResult', trigger?: { __typename?: 'Trigger', id: string, name: string, triggerType: TriggerType, enabled: boolean, cronExpression?: string | null, timezone?: string | null } | null } | null };

export type UpdateTriggerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTriggerInput;
}>;


export type UpdateTriggerMutation = { __typename?: 'RootMutationType', updateTrigger?: { __typename?: 'TriggerMutationResult', trigger?: { __typename?: 'Trigger', id: string, name: string, triggerType: TriggerType, enabled: boolean, cronExpression?: string | null, timezone?: string | null } | null } | null };

export type DeleteTriggerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTriggerMutation = { __typename?: 'RootMutationType', deleteTrigger?: { __typename?: 'TriggerDeleteResult', success: boolean, trigger?: { __typename?: 'Trigger', id: string } | null } | null };

export type EnableTriggerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableTriggerMutation = { __typename?: 'RootMutationType', enableTrigger?: { __typename?: 'TriggerMutationResult', trigger?: { __typename?: 'Trigger', id: string, enabled: boolean } | null } | null };

export type DisableTriggerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableTriggerMutation = { __typename?: 'RootMutationType', disableTrigger?: { __typename?: 'TriggerMutationResult', trigger?: { __typename?: 'Trigger', id: string, enabled: boolean } | null } | null };

export type AddTriggerTargetMutationVariables = Exact<{
  triggerId: Scalars['ID']['input'];
  input: AddTriggerTargetInput;
}>;


export type AddTriggerTargetMutation = { __typename?: 'RootMutationType', addTriggerTarget?: { __typename?: 'TriggerTargetMutationResult', target?: { __typename?: 'TriggerTarget', id: string, targetType: TriggerTargetType, targetId: string, enabled: boolean, priority: number } | null } | null };

export type RemoveTriggerTargetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveTriggerTargetMutation = { __typename?: 'RootMutationType', removeTriggerTarget?: { __typename?: 'TriggerTargetDeleteResult', success: boolean, target?: { __typename?: 'TriggerTarget', id: string } | null } | null };

export type TeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamMembersQuery = { __typename?: 'RootQueryType', teamMembers?: Array<{ __typename?: 'TeamMember', id: string, name?: string | null, email: string, role: UserRole }> | null };

export type UpdateUserRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  role: UserRole;
}>;


export type UpdateUserRoleMutation = { __typename?: 'RootMutationType', updateUserRole?: { __typename?: 'TeamMember', id: string, name?: string | null, email: string, role: UserRole } | null };

export type GetTokenUsageStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTokenUsageStatsQuery = { __typename?: 'RootQueryType', tokenUsageStats?: { __typename?: 'TokenUsageStats', isLimited: boolean, userDate: any, daily: { __typename?: 'TokenUsagePeriod', usage: number, limit?: number | null, percentage?: number | null, warningThreshold?: number | null, status: string }, weekly: { __typename?: 'TokenUsagePeriod', usage: number, limit?: number | null, percentage?: number | null, warningThreshold?: number | null, status: string }, monthly: { __typename?: 'TokenUsagePeriod', usage: number, limit?: number | null, percentage?: number | null, warningThreshold?: number | null, status: string } } | null };

export type GetTenantUsageStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantUsageStatsQuery = { __typename?: 'RootQueryType', tenantUsageStats?: { __typename?: 'TenantUsageStats', daily: { __typename?: 'TenantUsagePeriod', usage: number, limit?: number | null, enforced?: boolean | null }, weekly: { __typename?: 'TenantUsagePeriod', usage: number, limit?: number | null, enforced?: boolean | null }, monthly: { __typename?: 'TenantUsagePeriod', usage: number, limit?: number | null, enforced?: boolean | null } } | null };

export type DeleteMyWorkspaceMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMyWorkspaceMutation = { __typename?: 'RootMutationType', deleteMyWorkspace?: { __typename?: 'DeleteWorkspaceResult', success: boolean, message?: string | null } | null };

export type McpCatalogServersQueryVariables = Exact<{
  filter?: InputMaybe<McpCatalogFilterInput>;
}>;


export type McpCatalogServersQuery = { __typename?: 'RootQueryType', mcpCatalogServers?: Array<{ __typename?: 'McpCatalogServer', id: string, slug: string, name: string, description?: string | null, url?: string | null, category?: string | null, vendor?: string | null, authRequired: boolean, supportedAuthTypes?: Array<string | null> | null, capabilities?: any | null, metadata?: any | null, publishedAt?: any | null, deprecatedAt?: any | null, insertedAt: any, updatedAt: any } | null> | null };

export type McpCatalogServerQueryVariables = Exact<{
  idOrSlug: Scalars['String']['input'];
}>;


export type McpCatalogServerQuery = { __typename?: 'RootQueryType', mcpCatalogServer?: { __typename?: 'McpCatalogServer', id: string, slug: string, name: string, description?: string | null, url?: string | null, category?: string | null, vendor?: string | null, authRequired: boolean, supportedAuthTypes?: Array<string | null> | null, capabilities?: any | null, metadata?: any | null, publishedAt?: any | null, deprecatedAt?: any | null, insertedAt: any, updatedAt: any } | null };

export type McpCatalogInstancesQueryVariables = Exact<{
  filter?: InputMaybe<McpInstanceFilterInput>;
}>;


export type McpCatalogInstancesQuery = { __typename?: 'RootQueryType', mcpCatalogInstances?: Array<{ __typename?: 'McpCatalogInstance', id: string, tenantId: string, serverId: string, enabled: boolean, url?: string | null, consentMode?: string | null, timeout?: number | null, installedAt?: any | null, installedById?: string | null, metadata?: any | null, toolConfigs?: any | null, insertedAt: any, updatedAt: any, server?: { __typename?: 'McpCatalogServer', id: string, slug: string, name: string, description?: string | null, category?: string | null, vendor?: string | null, authRequired: boolean, capabilities?: any | null } | null } | null> | null };

export type McpCatalogInstanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type McpCatalogInstanceQuery = { __typename?: 'RootQueryType', mcpCatalogInstance?: { __typename?: 'McpCatalogInstance', id: string, tenantId: string, serverId: string, enabled: boolean, url?: string | null, consentMode?: string | null, timeout?: number | null, installedAt?: any | null, installedById?: string | null, metadata?: any | null, insertedAt: any, updatedAt: any, server?: { __typename?: 'McpCatalogServer', id: string, slug: string, name: string, description?: string | null, category?: string | null, vendor?: string | null, authRequired: boolean, capabilities?: any | null } | null } | null };

export type AgentToolsQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type AgentToolsQuery = { __typename?: 'RootQueryType', agentTools?: any | null };

export type SystemToolsCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemToolsCatalogQuery = { __typename?: 'RootQueryType', systemToolsCatalog?: any | null };

export type InstallMcpCatalogServerMutationVariables = Exact<{
  input: InstallMcpServerInput;
}>;


export type InstallMcpCatalogServerMutation = { __typename?: 'RootMutationType', installMcpCatalogServer?: { __typename?: 'McpCatalogInstance', id: string, enabled: boolean, consentMode?: string | null, server?: { __typename?: 'McpCatalogServer', id: string, slug: string, name: string, description?: string | null, category?: string | null } | null } | null };

export type UninstallMcpCatalogServerMutationVariables = Exact<{
  instanceId: Scalars['ID']['input'];
}>;


export type UninstallMcpCatalogServerMutation = { __typename?: 'RootMutationType', uninstallMcpCatalogServer?: boolean | null };

export type EnableMcpCatalogInstanceMutationVariables = Exact<{
  instanceId: Scalars['ID']['input'];
}>;


export type EnableMcpCatalogInstanceMutation = { __typename?: 'RootMutationType', enableMcpCatalogInstance?: { __typename?: 'McpCatalogInstance', id: string, enabled: boolean } | null };

export type DisableMcpCatalogInstanceMutationVariables = Exact<{
  instanceId: Scalars['ID']['input'];
}>;


export type DisableMcpCatalogInstanceMutation = { __typename?: 'RootMutationType', disableMcpCatalogInstance?: { __typename?: 'McpCatalogInstance', id: string, enabled: boolean } | null };

export type UpdateMcpCatalogInstanceMutationVariables = Exact<{
  input: UpdateMcpInstanceInput;
}>;


export type UpdateMcpCatalogInstanceMutation = { __typename?: 'RootMutationType', updateMcpCatalogInstance?: { __typename?: 'McpCatalogInstance', id: string, consentMode?: string | null, timeout?: number | null, metadata?: any | null } | null };

export type UpdateAgentToolsMutationVariables = Exact<{
  agentId: Scalars['ID']['input'];
  tools: Scalars['Json']['input'];
}>;


export type UpdateAgentToolsMutation = { __typename?: 'RootMutationType', updateAgentTools?: { __typename?: 'Agent', id: string, tools?: any | null } | null };

export type McpCatalogToolsQueryVariables = Exact<{
  serverIdOrSlug: Scalars['String']['input'];
}>;


export type McpCatalogToolsQuery = { __typename?: 'RootQueryType', mcpCatalogTools?: Array<{ __typename?: 'McpTool', name: string, description: string, inputSchema: any } | null> | null };

export type UpdateMcpToolConfigsMutationVariables = Exact<{
  input: UpdateMcpToolConfigsInput;
}>;


export type UpdateMcpToolConfigsMutation = { __typename?: 'RootMutationType', updateMcpToolConfigs?: { __typename?: 'McpCatalogInstance', id: string, toolConfigs?: any | null } | null };


export const RegisterClientToolsDocument = gql`
    mutation RegisterClientTools($input: RegisterClientToolsInput!) {
  registerClientTools(input: $input) {
    success
    message
    registeredCount
  }
}
    `;
export type RegisterClientToolsMutationFn = Apollo.MutationFunction<RegisterClientToolsMutation, RegisterClientToolsMutationVariables>;

/**
 * __useRegisterClientToolsMutation__
 *
 * To run a mutation, you first call `useRegisterClientToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterClientToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerClientToolsMutation, { data, loading, error }] = useRegisterClientToolsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterClientToolsMutation(baseOptions?: Apollo.MutationHookOptions<RegisterClientToolsMutation, RegisterClientToolsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterClientToolsMutation, RegisterClientToolsMutationVariables>(RegisterClientToolsDocument, options);
      }
export type RegisterClientToolsMutationHookResult = ReturnType<typeof useRegisterClientToolsMutation>;
export type RegisterClientToolsMutationResult = Apollo.MutationResult<RegisterClientToolsMutation>;
export type RegisterClientToolsMutationOptions = Apollo.BaseMutationOptions<RegisterClientToolsMutation, RegisterClientToolsMutationVariables>;
export const SetToolResultDocument = gql`
    mutation SetToolResult($input: SetToolResultInput!) {
  setToolResult(input: $input) {
    success
    message
  }
}
    `;
export type SetToolResultMutationFn = Apollo.MutationFunction<SetToolResultMutation, SetToolResultMutationVariables>;

/**
 * __useSetToolResultMutation__
 *
 * To run a mutation, you first call `useSetToolResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetToolResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setToolResultMutation, { data, loading, error }] = useSetToolResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetToolResultMutation(baseOptions?: Apollo.MutationHookOptions<SetToolResultMutation, SetToolResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetToolResultMutation, SetToolResultMutationVariables>(SetToolResultDocument, options);
      }
export type SetToolResultMutationHookResult = ReturnType<typeof useSetToolResultMutation>;
export type SetToolResultMutationResult = Apollo.MutationResult<SetToolResultMutation>;
export type SetToolResultMutationOptions = Apollo.BaseMutationOptions<SetToolResultMutation, SetToolResultMutationVariables>;
export const ConnectorAppsDocument = gql`
    query ConnectorApps {
  connectorApps {
    address
    name
    description
    icon
    entryPath
    routes
    connectorType
    navigation {
      placement
      path
      icon
      order
      label
    }
  }
}
    `;

/**
 * __useConnectorAppsQuery__
 *
 * To run a query within a React component, call `useConnectorAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorAppsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectorAppsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectorAppsQuery, ConnectorAppsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorAppsQuery, ConnectorAppsQueryVariables>(ConnectorAppsDocument, options);
      }
export function useConnectorAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorAppsQuery, ConnectorAppsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorAppsQuery, ConnectorAppsQueryVariables>(ConnectorAppsDocument, options);
        }
// @ts-ignore
export function useConnectorAppsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorAppsQuery, ConnectorAppsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorAppsQuery, ConnectorAppsQueryVariables>;
export function useConnectorAppsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorAppsQuery, ConnectorAppsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorAppsQuery | undefined, ConnectorAppsQueryVariables>;
export function useConnectorAppsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorAppsQuery, ConnectorAppsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorAppsQuery, ConnectorAppsQueryVariables>(ConnectorAppsDocument, options);
        }
export type ConnectorAppsQueryHookResult = ReturnType<typeof useConnectorAppsQuery>;
export type ConnectorAppsLazyQueryHookResult = ReturnType<typeof useConnectorAppsLazyQuery>;
export type ConnectorAppsSuspenseQueryHookResult = ReturnType<typeof useConnectorAppsSuspenseQuery>;
export type ConnectorAppsQueryResult = Apollo.QueryResult<ConnectorAppsQuery, ConnectorAppsQueryVariables>;
export const ConnectorAppDocument = gql`
    query ConnectorApp($address: String!) {
  connectorApp(address: $address) {
    address
    name
    description
    icon
    entryPath
    routes
    connectorType
    sandboxToken
    navigation {
      placement
      path
      icon
      order
      label
    }
  }
}
    `;

/**
 * __useConnectorAppQuery__
 *
 * To run a query within a React component, call `useConnectorAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorAppQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useConnectorAppQuery(baseOptions: Apollo.QueryHookOptions<ConnectorAppQuery, ConnectorAppQueryVariables> & ({ variables: ConnectorAppQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorAppQuery, ConnectorAppQueryVariables>(ConnectorAppDocument, options);
      }
export function useConnectorAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorAppQuery, ConnectorAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorAppQuery, ConnectorAppQueryVariables>(ConnectorAppDocument, options);
        }
// @ts-ignore
export function useConnectorAppSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorAppQuery, ConnectorAppQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorAppQuery, ConnectorAppQueryVariables>;
export function useConnectorAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorAppQuery, ConnectorAppQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorAppQuery | undefined, ConnectorAppQueryVariables>;
export function useConnectorAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorAppQuery, ConnectorAppQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorAppQuery, ConnectorAppQueryVariables>(ConnectorAppDocument, options);
        }
export type ConnectorAppQueryHookResult = ReturnType<typeof useConnectorAppQuery>;
export type ConnectorAppLazyQueryHookResult = ReturnType<typeof useConnectorAppLazyQuery>;
export type ConnectorAppSuspenseQueryHookResult = ReturnType<typeof useConnectorAppSuspenseQuery>;
export type ConnectorAppQueryResult = Apollo.QueryResult<ConnectorAppQuery, ConnectorAppQueryVariables>;
export const ConnectorToolsGroupsDocument = gql`
    query ConnectorToolsGroups {
  connectorToolsGroups {
    address
    name
    description
    vendor
    icon
    connectorType
    tools {
      name
      description
      parameters
      connectorAddress
    }
  }
}
    `;

/**
 * __useConnectorToolsGroupsQuery__
 *
 * To run a query within a React component, call `useConnectorToolsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorToolsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorToolsGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectorToolsGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>(ConnectorToolsGroupsDocument, options);
      }
export function useConnectorToolsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>(ConnectorToolsGroupsDocument, options);
        }
// @ts-ignore
export function useConnectorToolsGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>;
export function useConnectorToolsGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorToolsGroupsQuery | undefined, ConnectorToolsGroupsQueryVariables>;
export function useConnectorToolsGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>(ConnectorToolsGroupsDocument, options);
        }
export type ConnectorToolsGroupsQueryHookResult = ReturnType<typeof useConnectorToolsGroupsQuery>;
export type ConnectorToolsGroupsLazyQueryHookResult = ReturnType<typeof useConnectorToolsGroupsLazyQuery>;
export type ConnectorToolsGroupsSuspenseQueryHookResult = ReturnType<typeof useConnectorToolsGroupsSuspenseQuery>;
export type ConnectorToolsGroupsQueryResult = Apollo.QueryResult<ConnectorToolsGroupsQuery, ConnectorToolsGroupsQueryVariables>;
export const ConnectorToolsDocument = gql`
    query ConnectorTools($connectorAddress: String!) {
  connectorTools(connectorAddress: $connectorAddress) {
    name
    description
    parameters
    connectorAddress
  }
}
    `;

/**
 * __useConnectorToolsQuery__
 *
 * To run a query within a React component, call `useConnectorToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorToolsQuery({
 *   variables: {
 *      connectorAddress: // value for 'connectorAddress'
 *   },
 * });
 */
export function useConnectorToolsQuery(baseOptions: Apollo.QueryHookOptions<ConnectorToolsQuery, ConnectorToolsQueryVariables> & ({ variables: ConnectorToolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorToolsQuery, ConnectorToolsQueryVariables>(ConnectorToolsDocument, options);
      }
export function useConnectorToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorToolsQuery, ConnectorToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorToolsQuery, ConnectorToolsQueryVariables>(ConnectorToolsDocument, options);
        }
// @ts-ignore
export function useConnectorToolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorToolsQuery, ConnectorToolsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorToolsQuery, ConnectorToolsQueryVariables>;
export function useConnectorToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorToolsQuery, ConnectorToolsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorToolsQuery | undefined, ConnectorToolsQueryVariables>;
export function useConnectorToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorToolsQuery, ConnectorToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorToolsQuery, ConnectorToolsQueryVariables>(ConnectorToolsDocument, options);
        }
export type ConnectorToolsQueryHookResult = ReturnType<typeof useConnectorToolsQuery>;
export type ConnectorToolsLazyQueryHookResult = ReturnType<typeof useConnectorToolsLazyQuery>;
export type ConnectorToolsSuspenseQueryHookResult = ReturnType<typeof useConnectorToolsSuspenseQuery>;
export type ConnectorToolsQueryResult = Apollo.QueryResult<ConnectorToolsQuery, ConnectorToolsQueryVariables>;
export const CreateAgentDocument = gql`
    mutation CreateAgent($input: AgentInput!) {
  createAgent(input: $input) {
    id
    model
    systemMessage
    agentGreeting
    context
  }
}
    `;
export type CreateAgentMutationFn = Apollo.MutationFunction<CreateAgentMutation, CreateAgentMutationVariables>;

/**
 * __useCreateAgentMutation__
 *
 * To run a mutation, you first call `useCreateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentMutation, { data, loading, error }] = useCreateAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentMutation, CreateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(CreateAgentDocument, options);
      }
export type CreateAgentMutationHookResult = ReturnType<typeof useCreateAgentMutation>;
export type CreateAgentMutationResult = Apollo.MutationResult<CreateAgentMutation>;
export type CreateAgentMutationOptions = Apollo.BaseMutationOptions<CreateAgentMutation, CreateAgentMutationVariables>;
export const UpdateAgentDocument = gql`
    mutation UpdateAgent($input: UpdateAgentInput!) {
  updateAgent(input: $input) {
    id
    model
    systemMessage
    agentGreeting
    context
  }
}
    `;
export type UpdateAgentMutationFn = Apollo.MutationFunction<UpdateAgentMutation, UpdateAgentMutationVariables>;

/**
 * __useUpdateAgentMutation__
 *
 * To run a mutation, you first call `useUpdateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentMutation, { data, loading, error }] = useUpdateAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentMutation, UpdateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentMutation, UpdateAgentMutationVariables>(UpdateAgentDocument, options);
      }
export type UpdateAgentMutationHookResult = ReturnType<typeof useUpdateAgentMutation>;
export type UpdateAgentMutationResult = Apollo.MutationResult<UpdateAgentMutation>;
export type UpdateAgentMutationOptions = Apollo.BaseMutationOptions<UpdateAgentMutation, UpdateAgentMutationVariables>;
export const CreateConversationDocument = gql`
    mutation CreateConversation($input: CreateConversationInput!) {
  createConversation(input: $input) {
    id
    title
    summary
    metadata
  }
}
    `;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const GetConversationDocument = gql`
    query GetConversation($id: ID!) {
  conversation(id: $id) {
    id
    title
    summary
    metadata
    insertedAt
    type
    agentStatus
    systemPrompts {
      agentId
      prompt
    }
    messages {
      id
      parts {
        ... on TextPart {
          id
          text
        }
        ... on ToolCallPart {
          id
          toolCall {
            id
            name
            arguments
            result
            error
            status
          }
        }
        ... on ImageUrlPart {
          id
          imageUrl {
            url
            detail
          }
        }
        ... on ThinkingPart {
          id
          thinking {
            content
            signature
          }
        }
      }
      profile {
        id
        type
        name
        avatarUrl
      }
      timestamp
      conversationId
      parentId
      metadata
    }
  }
}
    `;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions: Apollo.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables> & ({ variables: GetConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
      }
export function useGetConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
// @ts-ignore
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationQuery, GetConversationQueryVariables>;
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationQuery | undefined, GetConversationQueryVariables>;
export function useGetConversationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationSuspenseQueryHookResult = ReturnType<typeof useGetConversationSuspenseQuery>;
export type GetConversationQueryResult = Apollo.QueryResult<GetConversationQuery, GetConversationQueryVariables>;
export const GetConversationsDocument = gql`
    query GetConversations($filter: ConversationFilterInput) {
  conversations(filter: $filter) {
    id
    title
    summary
    metadata
  }
}
    `;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
      }
export function useGetConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
// @ts-ignore
export function useGetConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export function useGetConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationsQuery | undefined, GetConversationsQueryVariables>;
export function useGetConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsSuspenseQueryHookResult = ReturnType<typeof useGetConversationsSuspenseQuery>;
export type GetConversationsQueryResult = Apollo.QueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export const ListConversationsDocument = gql`
    query ListConversations($first: Int, $after: String, $last: Int, $before: String, $filter: ListConversationsFilter) {
  listConversations(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    edges {
      cursor
      node {
        id
        title
        type
        summary
        metadata
        insertedAt
        updatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useListConversationsQuery__
 *
 * To run a query within a React component, call `useListConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConversationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConversationsQuery, ListConversationsQueryVariables>(ListConversationsDocument, options);
      }
export function useListConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConversationsQuery, ListConversationsQueryVariables>(ListConversationsDocument, options);
        }
// @ts-ignore
export function useListConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListConversationsQuery, ListConversationsQueryVariables>;
export function useListConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListConversationsQuery | undefined, ListConversationsQueryVariables>;
export function useListConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConversationsQuery, ListConversationsQueryVariables>(ListConversationsDocument, options);
        }
export type ListConversationsQueryHookResult = ReturnType<typeof useListConversationsQuery>;
export type ListConversationsLazyQueryHookResult = ReturnType<typeof useListConversationsLazyQuery>;
export type ListConversationsSuspenseQueryHookResult = ReturnType<typeof useListConversationsSuspenseQuery>;
export type ListConversationsQueryResult = Apollo.QueryResult<ListConversationsQuery, ListConversationsQueryVariables>;
export const ConversationEventsDocument = gql`
    subscription ConversationEvents($conversationId: ID!) {
  conversationEvents(conversationId: $conversationId) {
    ... on Message {
      id
      parts {
        ... on TextPart {
          id
          text
        }
        ... on ToolCallPart {
          id
          toolCall {
            id
            name
            arguments
            result
            error
            status
          }
        }
        ... on ImageUrlPart {
          id
          imageUrl {
            url
            detail
          }
        }
        ... on ThinkingPart {
          id
          thinking {
            content
            signature
          }
        }
      }
      profile {
        id
        type
        name
        avatarUrl
      }
      timestamp
      conversationId
      parentId
      metadata
    }
    ... on AgentStatusEvent {
      id
      conversationId
      agentId
      agentStatus
      message
      error
      toolName
      timestamp
    }
    ... on ToolCallMessageEvent {
      id
      conversationId
      agentId
      toolCallId
      toolName
      arguments
      result
      error
      status
      timestamp
    }
    ... on ToolCallApprovalEvent {
      id
      conversationId
      agentId
      toolCallId
      approvalMode
      status
      timestamp
    }
    ... on MessagePartStreamingEvent {
      id
      messageId
      content
      timestamp
    }
    ... on ThinkingStreamingEvent {
      id
      messageId
      thinkingPartId
      content
      signature
      timestamp
    }
    ... on ConversationUpdateEvent {
      id
      title
      summary
      metadata
      timestamp
    }
    ... on ChildMessageEvent {
      id
      type
      messageType
      sourceConversationId
      sourceConversationTitle
      timestamp
      data
    }
    ... on ConversationCompactedEvent {
      id
      conversationId
      snapshotId
      messagesSummarized
      lastMessageId
      snapshotTokens
      snapshotSizeBytes
      timestamp
    }
    ... on ConversationCompactingEvent {
      id
      conversationId
      timestamp
      messageCount
    }
    ... on ToolResultCompactedEvent {
      id
      conversationId
      timestamp
      toolCallId
      toolName
      format
      originalSizeBytes
      encodedSizeBytes
      tokenSavingsPct
    }
    ... on ToolResultCompactingEvent {
      id
      conversationId
      timestamp
      toolCallId
      toolName
      originalSizeBytes
    }
  }
}
    `;

/**
 * __useConversationEventsSubscription__
 *
 * To run a query within a React component, call `useConversationEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConversationEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationEventsSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationEventsSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConversationEventsSubscription, ConversationEventsSubscriptionVariables> & ({ variables: ConversationEventsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConversationEventsSubscription, ConversationEventsSubscriptionVariables>(ConversationEventsDocument, options);
      }
export type ConversationEventsSubscriptionHookResult = ReturnType<typeof useConversationEventsSubscription>;
export type ConversationEventsSubscriptionResult = Apollo.SubscriptionResult<ConversationEventsSubscription>;
export const AskDocument = gql`
    mutation Ask($input: ConversationInput!) {
  ask(input: $input) {
    userMessage {
      id
    }
  }
}
    `;
export type AskMutationFn = Apollo.MutationFunction<AskMutation, AskMutationVariables>;

/**
 * __useAskMutation__
 *
 * To run a mutation, you first call `useAskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askMutation, { data, loading, error }] = useAskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAskMutation(baseOptions?: Apollo.MutationHookOptions<AskMutation, AskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AskMutation, AskMutationVariables>(AskDocument, options);
      }
export type AskMutationHookResult = ReturnType<typeof useAskMutation>;
export type AskMutationResult = Apollo.MutationResult<AskMutation>;
export type AskMutationOptions = Apollo.BaseMutationOptions<AskMutation, AskMutationVariables>;
export const GetConversationSystemPromptsDocument = gql`
    query GetConversationSystemPrompts($conversationId: ID!) {
  conversation(id: $conversationId) {
    id
    systemPrompts {
      agentId
      prompt
    }
  }
}
    `;

/**
 * __useGetConversationSystemPromptsQuery__
 *
 * To run a query within a React component, call `useGetConversationSystemPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationSystemPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationSystemPromptsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetConversationSystemPromptsQuery(baseOptions: Apollo.QueryHookOptions<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables> & ({ variables: GetConversationSystemPromptsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>(GetConversationSystemPromptsDocument, options);
      }
export function useGetConversationSystemPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>(GetConversationSystemPromptsDocument, options);
        }
// @ts-ignore
export function useGetConversationSystemPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>;
export function useGetConversationSystemPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConversationSystemPromptsQuery | undefined, GetConversationSystemPromptsQueryVariables>;
export function useGetConversationSystemPromptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>(GetConversationSystemPromptsDocument, options);
        }
export type GetConversationSystemPromptsQueryHookResult = ReturnType<typeof useGetConversationSystemPromptsQuery>;
export type GetConversationSystemPromptsLazyQueryHookResult = ReturnType<typeof useGetConversationSystemPromptsLazyQuery>;
export type GetConversationSystemPromptsSuspenseQueryHookResult = ReturnType<typeof useGetConversationSystemPromptsSuspenseQuery>;
export type GetConversationSystemPromptsQueryResult = Apollo.QueryResult<GetConversationSystemPromptsQuery, GetConversationSystemPromptsQueryVariables>;
export const UpdateConversationSystemPromptDocument = gql`
    mutation UpdateConversationSystemPrompt($conversationId: ID!, $agentId: ID!, $systemPrompt: String!) {
  updateConversationSystemPrompt(
    conversationId: $conversationId
    agentId: $agentId
    systemPrompt: $systemPrompt
  ) {
    id
    systemPrompts {
      agentId
      prompt
    }
  }
}
    `;
export type UpdateConversationSystemPromptMutationFn = Apollo.MutationFunction<UpdateConversationSystemPromptMutation, UpdateConversationSystemPromptMutationVariables>;

/**
 * __useUpdateConversationSystemPromptMutation__
 *
 * To run a mutation, you first call `useUpdateConversationSystemPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationSystemPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationSystemPromptMutation, { data, loading, error }] = useUpdateConversationSystemPromptMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      agentId: // value for 'agentId'
 *      systemPrompt: // value for 'systemPrompt'
 *   },
 * });
 */
export function useUpdateConversationSystemPromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationSystemPromptMutation, UpdateConversationSystemPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationSystemPromptMutation, UpdateConversationSystemPromptMutationVariables>(UpdateConversationSystemPromptDocument, options);
      }
export type UpdateConversationSystemPromptMutationHookResult = ReturnType<typeof useUpdateConversationSystemPromptMutation>;
export type UpdateConversationSystemPromptMutationResult = Apollo.MutationResult<UpdateConversationSystemPromptMutation>;
export type UpdateConversationSystemPromptMutationOptions = Apollo.BaseMutationOptions<UpdateConversationSystemPromptMutation, UpdateConversationSystemPromptMutationVariables>;
export const UpdateConversationTitleDocument = gql`
    mutation UpdateConversationTitle($id: ID!, $title: String!) {
  updateConversationTitle(id: $id, title: $title) {
    id
    title
  }
}
    `;
export type UpdateConversationTitleMutationFn = Apollo.MutationFunction<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>;

/**
 * __useUpdateConversationTitleMutation__
 *
 * To run a mutation, you first call `useUpdateConversationTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationTitleMutation, { data, loading, error }] = useUpdateConversationTitleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateConversationTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>(UpdateConversationTitleDocument, options);
      }
export type UpdateConversationTitleMutationHookResult = ReturnType<typeof useUpdateConversationTitleMutation>;
export type UpdateConversationTitleMutationResult = Apollo.MutationResult<UpdateConversationTitleMutation>;
export type UpdateConversationTitleMutationOptions = Apollo.BaseMutationOptions<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>;
export const SummarizeConversationDocument = gql`
    mutation SummarizeConversation($conversationId: ID!) {
  summarizeConversation(conversationId: $conversationId) {
    success
    summary
    error
  }
}
    `;
export type SummarizeConversationMutationFn = Apollo.MutationFunction<SummarizeConversationMutation, SummarizeConversationMutationVariables>;

/**
 * __useSummarizeConversationMutation__
 *
 * To run a mutation, you first call `useSummarizeConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSummarizeConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [summarizeConversationMutation, { data, loading, error }] = useSummarizeConversationMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useSummarizeConversationMutation(baseOptions?: Apollo.MutationHookOptions<SummarizeConversationMutation, SummarizeConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SummarizeConversationMutation, SummarizeConversationMutationVariables>(SummarizeConversationDocument, options);
      }
export type SummarizeConversationMutationHookResult = ReturnType<typeof useSummarizeConversationMutation>;
export type SummarizeConversationMutationResult = Apollo.MutationResult<SummarizeConversationMutation>;
export type SummarizeConversationMutationOptions = Apollo.BaseMutationOptions<SummarizeConversationMutation, SummarizeConversationMutationVariables>;
export const SetToolCallPolicyDocument = gql`
    mutation SetToolCallPolicy($input: ToolCallPolicyInput!) {
  setToolCallPolicy(input: $input) {
    success
    message
  }
}
    `;
export type SetToolCallPolicyMutationFn = Apollo.MutationFunction<SetToolCallPolicyMutation, SetToolCallPolicyMutationVariables>;

/**
 * __useSetToolCallPolicyMutation__
 *
 * To run a mutation, you first call `useSetToolCallPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetToolCallPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setToolCallPolicyMutation, { data, loading, error }] = useSetToolCallPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetToolCallPolicyMutation(baseOptions?: Apollo.MutationHookOptions<SetToolCallPolicyMutation, SetToolCallPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetToolCallPolicyMutation, SetToolCallPolicyMutationVariables>(SetToolCallPolicyDocument, options);
      }
export type SetToolCallPolicyMutationHookResult = ReturnType<typeof useSetToolCallPolicyMutation>;
export type SetToolCallPolicyMutationResult = Apollo.MutationResult<SetToolCallPolicyMutation>;
export type SetToolCallPolicyMutationOptions = Apollo.BaseMutationOptions<SetToolCallPolicyMutation, SetToolCallPolicyMutationVariables>;
export const ResolveConsentDocument = gql`
    mutation ResolveConsent($input: ResolveConsentInput!) {
  resolveConsent(input: $input) {
    success
    message
  }
}
    `;
export type ResolveConsentMutationFn = Apollo.MutationFunction<ResolveConsentMutation, ResolveConsentMutationVariables>;

/**
 * __useResolveConsentMutation__
 *
 * To run a mutation, you first call `useResolveConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveConsentMutation, { data, loading, error }] = useResolveConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveConsentMutation(baseOptions?: Apollo.MutationHookOptions<ResolveConsentMutation, ResolveConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveConsentMutation, ResolveConsentMutationVariables>(ResolveConsentDocument, options);
      }
export type ResolveConsentMutationHookResult = ReturnType<typeof useResolveConsentMutation>;
export type ResolveConsentMutationResult = Apollo.MutationResult<ResolveConsentMutation>;
export type ResolveConsentMutationOptions = Apollo.BaseMutationOptions<ResolveConsentMutation, ResolveConsentMutationVariables>;
export const StopAgentStreamDocument = gql`
    mutation StopAgentStream($conversationId: ID!, $agentId: ID!) {
  stopAgentStream(conversationId: $conversationId, agentId: $agentId)
}
    `;
export type StopAgentStreamMutationFn = Apollo.MutationFunction<StopAgentStreamMutation, StopAgentStreamMutationVariables>;

/**
 * __useStopAgentStreamMutation__
 *
 * To run a mutation, you first call `useStopAgentStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopAgentStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopAgentStreamMutation, { data, loading, error }] = useStopAgentStreamMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useStopAgentStreamMutation(baseOptions?: Apollo.MutationHookOptions<StopAgentStreamMutation, StopAgentStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopAgentStreamMutation, StopAgentStreamMutationVariables>(StopAgentStreamDocument, options);
      }
export type StopAgentStreamMutationHookResult = ReturnType<typeof useStopAgentStreamMutation>;
export type StopAgentStreamMutationResult = Apollo.MutationResult<StopAgentStreamMutation>;
export type StopAgentStreamMutationOptions = Apollo.BaseMutationOptions<StopAgentStreamMutation, StopAgentStreamMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    success
    message
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const DevAutoLoginDocument = gql`
    mutation DevAutoLogin {
  devAutoLogin {
    details
    isAdmin
    isPlg
    features {
      customAgents
      secretsManagementEnabled
      devoAssistantEnabled
      externalConnectors
      sentryUnmaskData
    }
  }
}
    `;
export type DevAutoLoginMutationFn = Apollo.MutationFunction<DevAutoLoginMutation, DevAutoLoginMutationVariables>;

/**
 * __useDevAutoLoginMutation__
 *
 * To run a mutation, you first call `useDevAutoLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevAutoLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devAutoLoginMutation, { data, loading, error }] = useDevAutoLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useDevAutoLoginMutation(baseOptions?: Apollo.MutationHookOptions<DevAutoLoginMutation, DevAutoLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevAutoLoginMutation, DevAutoLoginMutationVariables>(DevAutoLoginDocument, options);
      }
export type DevAutoLoginMutationHookResult = ReturnType<typeof useDevAutoLoginMutation>;
export type DevAutoLoginMutationResult = Apollo.MutationResult<DevAutoLoginMutation>;
export type DevAutoLoginMutationOptions = Apollo.BaseMutationOptions<DevAutoLoginMutation, DevAutoLoginMutationVariables>;
export const GetPublicConfigDocument = gql`
    query GetPublicConfig {
  publicConfig {
    keycloak {
      clientId
      realm
      url
      redirectUrl
    }
    bypassKeycloakAuth
  }
}
    `;

/**
 * __useGetPublicConfigQuery__
 *
 * To run a query within a React component, call `useGetPublicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicConfigQuery, GetPublicConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicConfigQuery, GetPublicConfigQueryVariables>(GetPublicConfigDocument, options);
      }
export function useGetPublicConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicConfigQuery, GetPublicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicConfigQuery, GetPublicConfigQueryVariables>(GetPublicConfigDocument, options);
        }
// @ts-ignore
export function useGetPublicConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPublicConfigQuery, GetPublicConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublicConfigQuery, GetPublicConfigQueryVariables>;
export function useGetPublicConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicConfigQuery, GetPublicConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetPublicConfigQuery | undefined, GetPublicConfigQueryVariables>;
export function useGetPublicConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicConfigQuery, GetPublicConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicConfigQuery, GetPublicConfigQueryVariables>(GetPublicConfigDocument, options);
        }
export type GetPublicConfigQueryHookResult = ReturnType<typeof useGetPublicConfigQuery>;
export type GetPublicConfigLazyQueryHookResult = ReturnType<typeof useGetPublicConfigLazyQuery>;
export type GetPublicConfigSuspenseQueryHookResult = ReturnType<typeof useGetPublicConfigSuspenseQuery>;
export type GetPublicConfigQueryResult = Apollo.QueryResult<GetPublicConfigQuery, GetPublicConfigQueryVariables>;
export const GetUserDetailsDocument = gql`
    query GetUserDetails {
  userDetails {
    details
    isAdmin
    isPlg
    features {
      automationsToolsEnabled
      caseManagementToolsEnabled
      customAgents
      externalConnectors
      devoAssistantEnabled
      devoToolsEnabled
      gitlabToolsEnabled
      knowledgebasesEdit
      knowledgebasesViewOnly
      mcpManagement
      secOpsToolsEnabled
      secretsManagementEnabled
      webhooksEnabled
      workflowBuilderEnabled
      workflowsManage
      sentryUnmaskData
      asocV2Enabled
    }
  }
}
    `;

/**
 * __useGetUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
      }
export function useGetUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
// @ts-ignore
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDetailsQuery | undefined, GetUserDetailsQueryVariables>;
export function useGetUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDetailsQuery, GetUserDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDetailsQuery, GetUserDetailsQueryVariables>(GetUserDetailsDocument, options);
        }
export type GetUserDetailsQueryHookResult = ReturnType<typeof useGetUserDetailsQuery>;
export type GetUserDetailsLazyQueryHookResult = ReturnType<typeof useGetUserDetailsLazyQuery>;
export type GetUserDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUserDetailsSuspenseQuery>;
export type GetUserDetailsQueryResult = Apollo.QueryResult<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const ListDocumentsDocument = gql`
    query ListDocuments($first: Int, $after: String, $last: Int, $before: String, $filter: ListDocumentsFilter) {
  listDocuments(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    edges {
      cursor
      node {
        id
        title
        type
        conversation {
          id
          title
        }
        timestamp
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useListDocumentsQuery__
 *
 * To run a query within a React component, call `useListDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
      }
export function useListDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
        }
// @ts-ignore
export function useListDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export function useListDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListDocumentsQuery | undefined, ListDocumentsQueryVariables>;
export function useListDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDocumentsQuery, ListDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDocumentsQuery, ListDocumentsQueryVariables>(ListDocumentsDocument, options);
        }
export type ListDocumentsQueryHookResult = ReturnType<typeof useListDocumentsQuery>;
export type ListDocumentsLazyQueryHookResult = ReturnType<typeof useListDocumentsLazyQuery>;
export type ListDocumentsSuspenseQueryHookResult = ReturnType<typeof useListDocumentsSuspenseQuery>;
export type ListDocumentsQueryResult = Apollo.QueryResult<ListDocumentsQuery, ListDocumentsQueryVariables>;
export const GetDocumentDocument = gql`
    query GetDocument($conversationId: ID!, $documentId: ID!) {
  document(conversationId: $conversationId, documentId: $documentId) {
    id
    title
    type
    content
    timestamp
  }
}
    `;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables> & ({ variables: GetDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
      }
export function useGetDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
// @ts-ignore
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentQuery | undefined, GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSuspenseQuery>;
export type GetDocumentQueryResult = Apollo.QueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export const GetAgentDocument = gql`
    query GetAgent($id: ID!) {
  agent(id: $id) {
    id
    name
    description
    isPublic
    isTemplate
    isEnabled
    systemMessage
    agentGreeting
    context
    tools
    knowledgeBases {
      id
      name
      description
      status
      documentCount
    }
  }
}
    `;

/**
 * __useGetAgentQuery__
 *
 * To run a query within a React component, call `useGetAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentQuery(baseOptions: Apollo.QueryHookOptions<GetAgentQuery, GetAgentQueryVariables> & ({ variables: GetAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
      }
export function useGetAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
        }
// @ts-ignore
export function useGetAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentQuery, GetAgentQueryVariables>;
export function useGetAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgentQuery | undefined, GetAgentQueryVariables>;
export function useGetAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgentQuery, GetAgentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgentQuery, GetAgentQueryVariables>(GetAgentDocument, options);
        }
export type GetAgentQueryHookResult = ReturnType<typeof useGetAgentQuery>;
export type GetAgentLazyQueryHookResult = ReturnType<typeof useGetAgentLazyQuery>;
export type GetAgentSuspenseQueryHookResult = ReturnType<typeof useGetAgentSuspenseQuery>;
export type GetAgentQueryResult = Apollo.QueryResult<GetAgentQuery, GetAgentQueryVariables>;
export const ListAllAgentsDocument = gql`
    query ListAllAgents {
  templateAgents: listAgents(first: 1000, filter: {isTemplate: true}) {
    edges {
      cursor
      node {
        id
        name
        description
        displayOrder
        isPublic
        isTemplate
        isEnabled
        systemMessage
        agentGreeting
        context
        tools
        knowledgeBases {
          id
          name
          description
          status
          documentCount
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
  customAgents: listAgents(first: 1000) {
    edges {
      cursor
      node {
        id
        name
        description
        displayOrder
        isPublic
        isTemplate
        isEnabled
        systemMessage
        agentGreeting
        context
        tools
        knowledgeBases {
          id
          name
          description
          status
          documentCount
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useListAllAgentsQuery__
 *
 * To run a query within a React component, call `useListAllAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAllAgentsQuery(baseOptions?: Apollo.QueryHookOptions<ListAllAgentsQuery, ListAllAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllAgentsQuery, ListAllAgentsQueryVariables>(ListAllAgentsDocument, options);
      }
export function useListAllAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllAgentsQuery, ListAllAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllAgentsQuery, ListAllAgentsQueryVariables>(ListAllAgentsDocument, options);
        }
// @ts-ignore
export function useListAllAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAllAgentsQuery, ListAllAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAllAgentsQuery, ListAllAgentsQueryVariables>;
export function useListAllAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllAgentsQuery, ListAllAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAllAgentsQuery | undefined, ListAllAgentsQueryVariables>;
export function useListAllAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllAgentsQuery, ListAllAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllAgentsQuery, ListAllAgentsQueryVariables>(ListAllAgentsDocument, options);
        }
export type ListAllAgentsQueryHookResult = ReturnType<typeof useListAllAgentsQuery>;
export type ListAllAgentsLazyQueryHookResult = ReturnType<typeof useListAllAgentsLazyQuery>;
export type ListAllAgentsSuspenseQueryHookResult = ReturnType<typeof useListAllAgentsSuspenseQuery>;
export type ListAllAgentsQueryResult = Apollo.QueryResult<ListAllAgentsQuery, ListAllAgentsQueryVariables>;
export const ListFoldersDocument = gql`
    query ListFolders {
  folders {
    id
    name
    config
  }
}
    `;

/**
 * __useListFoldersQuery__
 *
 * To run a query within a React component, call `useListFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFoldersQuery(baseOptions?: Apollo.QueryHookOptions<ListFoldersQuery, ListFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFoldersQuery, ListFoldersQueryVariables>(ListFoldersDocument, options);
      }
export function useListFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFoldersQuery, ListFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFoldersQuery, ListFoldersQueryVariables>(ListFoldersDocument, options);
        }
// @ts-ignore
export function useListFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFoldersQuery, ListFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<ListFoldersQuery, ListFoldersQueryVariables>;
export function useListFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFoldersQuery, ListFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<ListFoldersQuery | undefined, ListFoldersQueryVariables>;
export function useListFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFoldersQuery, ListFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFoldersQuery, ListFoldersQueryVariables>(ListFoldersDocument, options);
        }
export type ListFoldersQueryHookResult = ReturnType<typeof useListFoldersQuery>;
export type ListFoldersLazyQueryHookResult = ReturnType<typeof useListFoldersLazyQuery>;
export type ListFoldersSuspenseQueryHookResult = ReturnType<typeof useListFoldersSuspenseQuery>;
export type ListFoldersQueryResult = Apollo.QueryResult<ListFoldersQuery, ListFoldersQueryVariables>;
export const CreateFolderDocument = gql`
    mutation CreateFolder($input: CreateFolderInput!) {
  createFolder(input: $input) {
    id
    name
    config
  }
}
    `;
export type CreateFolderMutationFn = Apollo.MutationFunction<CreateFolderMutation, CreateFolderMutationVariables>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFolderMutation, CreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFolderMutation, CreateFolderMutationVariables>(CreateFolderDocument, options);
      }
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = Apollo.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<CreateFolderMutation, CreateFolderMutationVariables>;
export const UpdateFolderDocument = gql`
    mutation UpdateFolder($id: ID!, $input: UpdateFolderInput!) {
  updateFolder(id: $id, input: $input) {
    id
    name
    config
  }
}
    `;
export type UpdateFolderMutationFn = Apollo.MutationFunction<UpdateFolderMutation, UpdateFolderMutationVariables>;

/**
 * __useUpdateFolderMutation__
 *
 * To run a mutation, you first call `useUpdateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderMutation, { data, loading, error }] = useUpdateFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderMutation, UpdateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderMutation, UpdateFolderMutationVariables>(UpdateFolderDocument, options);
      }
export type UpdateFolderMutationHookResult = ReturnType<typeof useUpdateFolderMutation>;
export type UpdateFolderMutationResult = Apollo.MutationResult<UpdateFolderMutation>;
export type UpdateFolderMutationOptions = Apollo.BaseMutationOptions<UpdateFolderMutation, UpdateFolderMutationVariables>;
export const DeleteFolderDocument = gql`
    mutation DeleteFolder($id: ID!) {
  deleteFolder(id: $id) {
    id
  }
}
    `;
export type DeleteFolderMutationFn = Apollo.MutationFunction<DeleteFolderMutation, DeleteFolderMutationVariables>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderMutation, DeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderMutation, DeleteFolderMutationVariables>(DeleteFolderDocument, options);
      }
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = Apollo.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const GetKnowledgeBasesDocument = gql`
    query GetKnowledgeBases($filter: KnowledgeBaseFilterInput) {
  knowledgeBases(filter: $filter) {
    id
    name
    description
    status
    config
    metadata
    documents {
      filename
      fileSize
    }
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetKnowledgeBasesQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetKnowledgeBasesQuery(baseOptions?: Apollo.QueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(GetKnowledgeBasesDocument, options);
      }
export function useGetKnowledgeBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(GetKnowledgeBasesDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>;
export function useGetKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBasesQuery | undefined, GetKnowledgeBasesQueryVariables>;
export function useGetKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(GetKnowledgeBasesDocument, options);
        }
export type GetKnowledgeBasesQueryHookResult = ReturnType<typeof useGetKnowledgeBasesQuery>;
export type GetKnowledgeBasesLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBasesLazyQuery>;
export type GetKnowledgeBasesSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBasesSuspenseQuery>;
export type GetKnowledgeBasesQueryResult = Apollo.QueryResult<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>;
export const GetKnowledgeBaseDocument = gql`
    query GetKnowledgeBase($id: ID!) {
  knowledgeBase(id: $id) {
    id
    name
    description
    status
    config
    metadata
    documentCount
    insertedAt
    updatedAt
    documents {
      id
      filename
      originalFilename
      contentType
      fileSize
      fileHash
      knowledgeBaseId
      status
      processedAt
      processingError
      metadata
      insertedAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKnowledgeBaseQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables> & ({ variables: GetKnowledgeBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(GetKnowledgeBaseDocument, options);
      }
export function useGetKnowledgeBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(GetKnowledgeBaseDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>;
export function useGetKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseQuery | undefined, GetKnowledgeBaseQueryVariables>;
export function useGetKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(GetKnowledgeBaseDocument, options);
        }
export type GetKnowledgeBaseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseQuery>;
export type GetKnowledgeBaseLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBaseLazyQuery>;
export type GetKnowledgeBaseSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseSuspenseQuery>;
export type GetKnowledgeBaseQueryResult = Apollo.QueryResult<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>;
export const GetKnowledgeBaseDocumentsDocument = gql`
    query GetKnowledgeBaseDocuments($filter: DocumentFilterInput!) {
  knowledgeBaseDocuments(filter: $filter) {
    id
    knowledgeBaseId
    filename
    originalFilename
    contentType
    fileSize
    status
    processedAt
    processingError
    metadata
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetKnowledgeBaseDocumentsQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetKnowledgeBaseDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables> & ({ variables: GetKnowledgeBaseDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>(GetKnowledgeBaseDocumentsDocument, options);
      }
export function useGetKnowledgeBaseDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>(GetKnowledgeBaseDocumentsDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBaseDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>;
export function useGetKnowledgeBaseDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentsQuery | undefined, GetKnowledgeBaseDocumentsQueryVariables>;
export function useGetKnowledgeBaseDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>(GetKnowledgeBaseDocumentsDocument, options);
        }
export type GetKnowledgeBaseDocumentsQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsQuery>;
export type GetKnowledgeBaseDocumentsLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsLazyQuery>;
export type GetKnowledgeBaseDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsSuspenseQuery>;
export type GetKnowledgeBaseDocumentsQueryResult = Apollo.QueryResult<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>;
export const CreateKnowledgeBaseDocument = gql`
    mutation CreateKnowledgeBase($input: CreateKnowledgeBaseInput!) {
  createKnowledgeBase(input: $input) {
    id
    name
    description
    status
    config
    metadata
    documentCount
    insertedAt
    updatedAt
  }
}
    `;
export type CreateKnowledgeBaseMutationFn = Apollo.MutationFunction<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>;

/**
 * __useCreateKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseMutation, { data, loading, error }] = useCreateKnowledgeBaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>(CreateKnowledgeBaseDocument, options);
      }
export type CreateKnowledgeBaseMutationHookResult = ReturnType<typeof useCreateKnowledgeBaseMutation>;
export type CreateKnowledgeBaseMutationResult = Apollo.MutationResult<CreateKnowledgeBaseMutation>;
export type CreateKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>;
export const UpdateKnowledgeBaseDocument = gql`
    mutation UpdateKnowledgeBase($id: ID!, $input: UpdateKnowledgeBaseInput!) {
  updateKnowledgeBase(id: $id, input: $input) {
    id
    name
    description
    status
    config
    metadata
    documentCount
    insertedAt
    updatedAt
  }
}
    `;
export type UpdateKnowledgeBaseMutationFn = Apollo.MutationFunction<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>;

/**
 * __useUpdateKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseMutation, { data, loading, error }] = useUpdateKnowledgeBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>(UpdateKnowledgeBaseDocument, options);
      }
export type UpdateKnowledgeBaseMutationHookResult = ReturnType<typeof useUpdateKnowledgeBaseMutation>;
export type UpdateKnowledgeBaseMutationResult = Apollo.MutationResult<UpdateKnowledgeBaseMutation>;
export type UpdateKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>;
export const UpdateKnowledgeBaseStatusDocument = gql`
    mutation UpdateKnowledgeBaseStatus($id: ID!, $status: KnowledgeBaseStatus!) {
  updateKnowledgeBaseStatus(id: $id, status: $status) {
    id
    name
    description
    status
    config
    metadata
    documentCount
    insertedAt
    updatedAt
  }
}
    `;
export type UpdateKnowledgeBaseStatusMutationFn = Apollo.MutationFunction<UpdateKnowledgeBaseStatusMutation, UpdateKnowledgeBaseStatusMutationVariables>;

/**
 * __useUpdateKnowledgeBaseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseStatusMutation, { data, loading, error }] = useUpdateKnowledgeBaseStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKnowledgeBaseStatusMutation, UpdateKnowledgeBaseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKnowledgeBaseStatusMutation, UpdateKnowledgeBaseStatusMutationVariables>(UpdateKnowledgeBaseStatusDocument, options);
      }
export type UpdateKnowledgeBaseStatusMutationHookResult = ReturnType<typeof useUpdateKnowledgeBaseStatusMutation>;
export type UpdateKnowledgeBaseStatusMutationResult = Apollo.MutationResult<UpdateKnowledgeBaseStatusMutation>;
export type UpdateKnowledgeBaseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateKnowledgeBaseStatusMutation, UpdateKnowledgeBaseStatusMutationVariables>;
export const DeleteKnowledgeBaseDocument = gql`
    mutation DeleteKnowledgeBase($id: ID!) {
  deleteKnowledgeBase(id: $id)
}
    `;
export type DeleteKnowledgeBaseMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>;

/**
 * __useDeleteKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseMutation, { data, loading, error }] = useDeleteKnowledgeBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>(DeleteKnowledgeBaseDocument, options);
      }
export type DeleteKnowledgeBaseMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseMutation>;
export type DeleteKnowledgeBaseMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseMutation>;
export type DeleteKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>;
export const UploadDocumentDocument = gql`
    mutation UploadDocument($input: UploadDocumentInput!) {
  uploadDocument(input: $input) {
    id
    knowledgeBaseId
    filename
    originalFilename
    contentType
    fileSize
    status
    processedAt
    processingError
    metadata
    insertedAt
    updatedAt
  }
}
    `;
export type UploadDocumentMutationFn = Apollo.MutationFunction<UploadDocumentMutation, UploadDocumentMutationVariables>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const RemoveDocumentDocument = gql`
    mutation RemoveDocument($documentId: ID!) {
  removeDocument(documentId: $documentId) {
    id
    knowledgeBaseId
    filename
    status
    processedAt
    updatedAt
  }
}
    `;
export type RemoveDocumentMutationFn = Apollo.MutationFunction<RemoveDocumentMutation, RemoveDocumentMutationVariables>;

/**
 * __useRemoveDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentMutation, { data, loading, error }] = useRemoveDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDocumentMutation, RemoveDocumentMutationVariables>(RemoveDocumentDocument, options);
      }
export type RemoveDocumentMutationHookResult = ReturnType<typeof useRemoveDocumentMutation>;
export type RemoveDocumentMutationResult = Apollo.MutationResult<RemoveDocumentMutation>;
export type RemoveDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveDocumentMutation, RemoveDocumentMutationVariables>;
export const PermanentlyDeleteDocumentDocument = gql`
    mutation PermanentlyDeleteDocument($documentId: ID!) {
  permanentlyDeleteDocument(documentId: $documentId)
}
    `;
export type PermanentlyDeleteDocumentMutationFn = Apollo.MutationFunction<PermanentlyDeleteDocumentMutation, PermanentlyDeleteDocumentMutationVariables>;

/**
 * __usePermanentlyDeleteDocumentMutation__
 *
 * To run a mutation, you first call `usePermanentlyDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermanentlyDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permanentlyDeleteDocumentMutation, { data, loading, error }] = usePermanentlyDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function usePermanentlyDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<PermanentlyDeleteDocumentMutation, PermanentlyDeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PermanentlyDeleteDocumentMutation, PermanentlyDeleteDocumentMutationVariables>(PermanentlyDeleteDocumentDocument, options);
      }
export type PermanentlyDeleteDocumentMutationHookResult = ReturnType<typeof usePermanentlyDeleteDocumentMutation>;
export type PermanentlyDeleteDocumentMutationResult = Apollo.MutationResult<PermanentlyDeleteDocumentMutation>;
export type PermanentlyDeleteDocumentMutationOptions = Apollo.BaseMutationOptions<PermanentlyDeleteDocumentMutation, PermanentlyDeleteDocumentMutationVariables>;
export const AttachKnowledgeBaseToAgentDocument = gql`
    mutation AttachKnowledgeBaseToAgent($input: AttachKnowledgeBaseInput!) {
  attachKnowledgeBaseToAgent(input: $input) {
    id
    agentId
    knowledgeBaseId
    metadata
    insertedAt
  }
}
    `;
export type AttachKnowledgeBaseToAgentMutationFn = Apollo.MutationFunction<AttachKnowledgeBaseToAgentMutation, AttachKnowledgeBaseToAgentMutationVariables>;

/**
 * __useAttachKnowledgeBaseToAgentMutation__
 *
 * To run a mutation, you first call `useAttachKnowledgeBaseToAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachKnowledgeBaseToAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachKnowledgeBaseToAgentMutation, { data, loading, error }] = useAttachKnowledgeBaseToAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachKnowledgeBaseToAgentMutation(baseOptions?: Apollo.MutationHookOptions<AttachKnowledgeBaseToAgentMutation, AttachKnowledgeBaseToAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachKnowledgeBaseToAgentMutation, AttachKnowledgeBaseToAgentMutationVariables>(AttachKnowledgeBaseToAgentDocument, options);
      }
export type AttachKnowledgeBaseToAgentMutationHookResult = ReturnType<typeof useAttachKnowledgeBaseToAgentMutation>;
export type AttachKnowledgeBaseToAgentMutationResult = Apollo.MutationResult<AttachKnowledgeBaseToAgentMutation>;
export type AttachKnowledgeBaseToAgentMutationOptions = Apollo.BaseMutationOptions<AttachKnowledgeBaseToAgentMutation, AttachKnowledgeBaseToAgentMutationVariables>;
export const DetachKnowledgeBaseFromAgentDocument = gql`
    mutation DetachKnowledgeBaseFromAgent($agentId: ID!, $knowledgeBaseId: ID!) {
  detachKnowledgeBaseFromAgent(
    agentId: $agentId
    knowledgeBaseId: $knowledgeBaseId
  )
}
    `;
export type DetachKnowledgeBaseFromAgentMutationFn = Apollo.MutationFunction<DetachKnowledgeBaseFromAgentMutation, DetachKnowledgeBaseFromAgentMutationVariables>;

/**
 * __useDetachKnowledgeBaseFromAgentMutation__
 *
 * To run a mutation, you first call `useDetachKnowledgeBaseFromAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachKnowledgeBaseFromAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachKnowledgeBaseFromAgentMutation, { data, loading, error }] = useDetachKnowledgeBaseFromAgentMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *   },
 * });
 */
export function useDetachKnowledgeBaseFromAgentMutation(baseOptions?: Apollo.MutationHookOptions<DetachKnowledgeBaseFromAgentMutation, DetachKnowledgeBaseFromAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachKnowledgeBaseFromAgentMutation, DetachKnowledgeBaseFromAgentMutationVariables>(DetachKnowledgeBaseFromAgentDocument, options);
      }
export type DetachKnowledgeBaseFromAgentMutationHookResult = ReturnType<typeof useDetachKnowledgeBaseFromAgentMutation>;
export type DetachKnowledgeBaseFromAgentMutationResult = Apollo.MutationResult<DetachKnowledgeBaseFromAgentMutation>;
export type DetachKnowledgeBaseFromAgentMutationOptions = Apollo.BaseMutationOptions<DetachKnowledgeBaseFromAgentMutation, DetachKnowledgeBaseFromAgentMutationVariables>;
export const QueryAgentKnowledgeBasesDocument = gql`
    query QueryAgentKnowledgeBases($agentId: ID!, $query: String!, $knowledgeBaseIds: [ID!]) {
  queryAgentKnowledgeBases(
    agentId: $agentId
    query: $query
    knowledgeBaseIds: $knowledgeBaseIds
  ) {
    content
    sourceDocuments
    metadata
  }
}
    `;

/**
 * __useQueryAgentKnowledgeBasesQuery__
 *
 * To run a query within a React component, call `useQueryAgentKnowledgeBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAgentKnowledgeBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAgentKnowledgeBasesQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      query: // value for 'query'
 *      knowledgeBaseIds: // value for 'knowledgeBaseIds'
 *   },
 * });
 */
export function useQueryAgentKnowledgeBasesQuery(baseOptions: Apollo.QueryHookOptions<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables> & ({ variables: QueryAgentKnowledgeBasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>(QueryAgentKnowledgeBasesDocument, options);
      }
export function useQueryAgentKnowledgeBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>(QueryAgentKnowledgeBasesDocument, options);
        }
// @ts-ignore
export function useQueryAgentKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>): Apollo.UseSuspenseQueryResult<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>;
export function useQueryAgentKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>): Apollo.UseSuspenseQueryResult<QueryAgentKnowledgeBasesQuery | undefined, QueryAgentKnowledgeBasesQueryVariables>;
export function useQueryAgentKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>(QueryAgentKnowledgeBasesDocument, options);
        }
export type QueryAgentKnowledgeBasesQueryHookResult = ReturnType<typeof useQueryAgentKnowledgeBasesQuery>;
export type QueryAgentKnowledgeBasesLazyQueryHookResult = ReturnType<typeof useQueryAgentKnowledgeBasesLazyQuery>;
export type QueryAgentKnowledgeBasesSuspenseQueryHookResult = ReturnType<typeof useQueryAgentKnowledgeBasesSuspenseQuery>;
export type QueryAgentKnowledgeBasesQueryResult = Apollo.QueryResult<QueryAgentKnowledgeBasesQuery, QueryAgentKnowledgeBasesQueryVariables>;
export const KnowledgeBaseUpdatesDocument = gql`
    subscription KnowledgeBaseUpdates($knowledgeBaseId: ID!) {
  knowledgeBaseUpdates(knowledgeBaseId: $knowledgeBaseId) {
    type
    message
    timestamp
    knowledgeBase {
      id
      name
      status
      documentCount
    }
    document {
      id
      filename
      status
      processedAt
    }
  }
}
    `;

/**
 * __useKnowledgeBaseUpdatesSubscription__
 *
 * To run a query within a React component, call `useKnowledgeBaseUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBaseUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBaseUpdatesSubscription({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *   },
 * });
 */
export function useKnowledgeBaseUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<KnowledgeBaseUpdatesSubscription, KnowledgeBaseUpdatesSubscriptionVariables> & ({ variables: KnowledgeBaseUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<KnowledgeBaseUpdatesSubscription, KnowledgeBaseUpdatesSubscriptionVariables>(KnowledgeBaseUpdatesDocument, options);
      }
export type KnowledgeBaseUpdatesSubscriptionHookResult = ReturnType<typeof useKnowledgeBaseUpdatesSubscription>;
export type KnowledgeBaseUpdatesSubscriptionResult = Apollo.SubscriptionResult<KnowledgeBaseUpdatesSubscription>;
export const DocumentProcessingUpdatesDocument = gql`
    subscription DocumentProcessingUpdates($documentId: ID!) {
  documentProcessingUpdates(documentId: $documentId) {
    documentId
    event
    timestamp
    processingResponse {
      trackId
      totalCount
      documents {
        id
        status
        contentSummary
        contentLength
        chunksCount
        errorMsg
        filePath
        createdAt
        updatedAt
        metadata
      }
      statusSummary
    }
  }
}
    `;

/**
 * __useDocumentProcessingUpdatesSubscription__
 *
 * To run a query within a React component, call `useDocumentProcessingUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDocumentProcessingUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentProcessingUpdatesSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentProcessingUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<DocumentProcessingUpdatesSubscription, DocumentProcessingUpdatesSubscriptionVariables> & ({ variables: DocumentProcessingUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DocumentProcessingUpdatesSubscription, DocumentProcessingUpdatesSubscriptionVariables>(DocumentProcessingUpdatesDocument, options);
      }
export type DocumentProcessingUpdatesSubscriptionHookResult = ReturnType<typeof useDocumentProcessingUpdatesSubscription>;
export type DocumentProcessingUpdatesSubscriptionResult = Apollo.SubscriptionResult<DocumentProcessingUpdatesSubscription>;
export const QueryKnowledgeBaseDocument = gql`
    query QueryKnowledgeBase($id: ID!, $query: String!, $topK: Int) {
  queryKnowledgeBase(id: $id, query: $query, topK: $topK) {
    content
    sourceDocuments
    metadata
  }
}
    `;

/**
 * __useQueryKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useQueryKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryKnowledgeBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *      topK: // value for 'topK'
 *   },
 * });
 */
export function useQueryKnowledgeBaseQuery(baseOptions: Apollo.QueryHookOptions<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables> & ({ variables: QueryKnowledgeBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>(QueryKnowledgeBaseDocument, options);
      }
export function useQueryKnowledgeBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>(QueryKnowledgeBaseDocument, options);
        }
// @ts-ignore
export function useQueryKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>): Apollo.UseSuspenseQueryResult<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>;
export function useQueryKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>): Apollo.UseSuspenseQueryResult<QueryKnowledgeBaseQuery | undefined, QueryKnowledgeBaseQueryVariables>;
export function useQueryKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>(QueryKnowledgeBaseDocument, options);
        }
export type QueryKnowledgeBaseQueryHookResult = ReturnType<typeof useQueryKnowledgeBaseQuery>;
export type QueryKnowledgeBaseLazyQueryHookResult = ReturnType<typeof useQueryKnowledgeBaseLazyQuery>;
export type QueryKnowledgeBaseSuspenseQueryHookResult = ReturnType<typeof useQueryKnowledgeBaseSuspenseQuery>;
export type QueryKnowledgeBaseQueryResult = Apollo.QueryResult<QueryKnowledgeBaseQuery, QueryKnowledgeBaseQueryVariables>;
export const GetToolsDocument = gql`
    query GetTools {
  tools {
    name
    description
    enabled
    category
  }
}
    `;

/**
 * __useGetToolsQuery__
 *
 * To run a query within a React component, call `useGetToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetToolsQuery(baseOptions?: Apollo.QueryHookOptions<GetToolsQuery, GetToolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetToolsQuery, GetToolsQueryVariables>(GetToolsDocument, options);
      }
export function useGetToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetToolsQuery, GetToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetToolsQuery, GetToolsQueryVariables>(GetToolsDocument, options);
        }
// @ts-ignore
export function useGetToolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetToolsQuery, GetToolsQueryVariables>): Apollo.UseSuspenseQueryResult<GetToolsQuery, GetToolsQueryVariables>;
export function useGetToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetToolsQuery, GetToolsQueryVariables>): Apollo.UseSuspenseQueryResult<GetToolsQuery | undefined, GetToolsQueryVariables>;
export function useGetToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetToolsQuery, GetToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetToolsQuery, GetToolsQueryVariables>(GetToolsDocument, options);
        }
export type GetToolsQueryHookResult = ReturnType<typeof useGetToolsQuery>;
export type GetToolsLazyQueryHookResult = ReturnType<typeof useGetToolsLazyQuery>;
export type GetToolsSuspenseQueryHookResult = ReturnType<typeof useGetToolsSuspenseQuery>;
export type GetToolsQueryResult = Apollo.QueryResult<GetToolsQuery, GetToolsQueryVariables>;
export const ListJobConfigsDocument = gql`
    query ListJobConfigs($filter: JobConfigFilter, $first: Int, $last: Int, $before: String, $after: String) {
  listJobConfigs(
    filter: $filter
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        description
        enabled
        cronExpr
        toolsApproved
        agent {
          id
          name
        }
        user {
          id
          name
          email
          displayName
        }
        triggers {
          id
          name
          triggerType
          enabled
          cronExpression
          webhookEndpoint {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListJobConfigsQuery__
 *
 * To run a query within a React component, call `useListJobConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListJobConfigsQuery(baseOptions?: Apollo.QueryHookOptions<ListJobConfigsQuery, ListJobConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobConfigsQuery, ListJobConfigsQueryVariables>(ListJobConfigsDocument, options);
      }
export function useListJobConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobConfigsQuery, ListJobConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobConfigsQuery, ListJobConfigsQueryVariables>(ListJobConfigsDocument, options);
        }
// @ts-ignore
export function useListJobConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobConfigsQuery, ListJobConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobConfigsQuery, ListJobConfigsQueryVariables>;
export function useListJobConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobConfigsQuery, ListJobConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobConfigsQuery | undefined, ListJobConfigsQueryVariables>;
export function useListJobConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobConfigsQuery, ListJobConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobConfigsQuery, ListJobConfigsQueryVariables>(ListJobConfigsDocument, options);
        }
export type ListJobConfigsQueryHookResult = ReturnType<typeof useListJobConfigsQuery>;
export type ListJobConfigsLazyQueryHookResult = ReturnType<typeof useListJobConfigsLazyQuery>;
export type ListJobConfigsSuspenseQueryHookResult = ReturnType<typeof useListJobConfigsSuspenseQuery>;
export type ListJobConfigsQueryResult = Apollo.QueryResult<ListJobConfigsQuery, ListJobConfigsQueryVariables>;
export const GetJobConfigDocument = gql`
    query GetJobConfig($id: ID!) {
  getJobConfig(id: $id) {
    id
    name
    description
    enabled
    cronExpr
    prompt
    toolsApproved
    agent {
      id
    }
  }
}
    `;

/**
 * __useGetJobConfigQuery__
 *
 * To run a query within a React component, call `useGetJobConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobConfigQuery(baseOptions: Apollo.QueryHookOptions<GetJobConfigQuery, GetJobConfigQueryVariables> & ({ variables: GetJobConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobConfigQuery, GetJobConfigQueryVariables>(GetJobConfigDocument, options);
      }
export function useGetJobConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobConfigQuery, GetJobConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobConfigQuery, GetJobConfigQueryVariables>(GetJobConfigDocument, options);
        }
// @ts-ignore
export function useGetJobConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobConfigQuery, GetJobConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobConfigQuery, GetJobConfigQueryVariables>;
export function useGetJobConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobConfigQuery, GetJobConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobConfigQuery | undefined, GetJobConfigQueryVariables>;
export function useGetJobConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobConfigQuery, GetJobConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobConfigQuery, GetJobConfigQueryVariables>(GetJobConfigDocument, options);
        }
export type GetJobConfigQueryHookResult = ReturnType<typeof useGetJobConfigQuery>;
export type GetJobConfigLazyQueryHookResult = ReturnType<typeof useGetJobConfigLazyQuery>;
export type GetJobConfigSuspenseQueryHookResult = ReturnType<typeof useGetJobConfigSuspenseQuery>;
export type GetJobConfigQueryResult = Apollo.QueryResult<GetJobConfigQuery, GetJobConfigQueryVariables>;
export const CreateJobConfigDocument = gql`
    mutation CreateJobConfig($input: JobConfigInput!) {
  createJobConfig(input: $input) {
    id
  }
}
    `;
export type CreateJobConfigMutationFn = Apollo.MutationFunction<CreateJobConfigMutation, CreateJobConfigMutationVariables>;

/**
 * __useCreateJobConfigMutation__
 *
 * To run a mutation, you first call `useCreateJobConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobConfigMutation, { data, loading, error }] = useCreateJobConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobConfigMutation, CreateJobConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobConfigMutation, CreateJobConfigMutationVariables>(CreateJobConfigDocument, options);
      }
export type CreateJobConfigMutationHookResult = ReturnType<typeof useCreateJobConfigMutation>;
export type CreateJobConfigMutationResult = Apollo.MutationResult<CreateJobConfigMutation>;
export type CreateJobConfigMutationOptions = Apollo.BaseMutationOptions<CreateJobConfigMutation, CreateJobConfigMutationVariables>;
export const UpdateJobConfigDocument = gql`
    mutation UpdateJobConfig($id: ID!, $input: JobConfigUpdateInput!) {
  updateJobConfig(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateJobConfigMutationFn = Apollo.MutationFunction<UpdateJobConfigMutation, UpdateJobConfigMutationVariables>;

/**
 * __useUpdateJobConfigMutation__
 *
 * To run a mutation, you first call `useUpdateJobConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobConfigMutation, { data, loading, error }] = useUpdateJobConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobConfigMutation, UpdateJobConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobConfigMutation, UpdateJobConfigMutationVariables>(UpdateJobConfigDocument, options);
      }
export type UpdateJobConfigMutationHookResult = ReturnType<typeof useUpdateJobConfigMutation>;
export type UpdateJobConfigMutationResult = Apollo.MutationResult<UpdateJobConfigMutation>;
export type UpdateJobConfigMutationOptions = Apollo.BaseMutationOptions<UpdateJobConfigMutation, UpdateJobConfigMutationVariables>;
export const DeleteJobConfigDocument = gql`
    mutation DeleteJobConfig($id: ID!) {
  deleteJobConfig(id: $id) {
    id
  }
}
    `;
export type DeleteJobConfigMutationFn = Apollo.MutationFunction<DeleteJobConfigMutation, DeleteJobConfigMutationVariables>;

/**
 * __useDeleteJobConfigMutation__
 *
 * To run a mutation, you first call `useDeleteJobConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobConfigMutation, { data, loading, error }] = useDeleteJobConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobConfigMutation, DeleteJobConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobConfigMutation, DeleteJobConfigMutationVariables>(DeleteJobConfigDocument, options);
      }
export type DeleteJobConfigMutationHookResult = ReturnType<typeof useDeleteJobConfigMutation>;
export type DeleteJobConfigMutationResult = Apollo.MutationResult<DeleteJobConfigMutation>;
export type DeleteJobConfigMutationOptions = Apollo.BaseMutationOptions<DeleteJobConfigMutation, DeleteJobConfigMutationVariables>;
export const MarkJobInstanceAsReadDocument = gql`
    mutation MarkJobInstanceAsRead($id: ID!) {
  markJobInstanceAsRead(id: $id) {
    id
    updatedAt
  }
}
    `;
export type MarkJobInstanceAsReadMutationFn = Apollo.MutationFunction<MarkJobInstanceAsReadMutation, MarkJobInstanceAsReadMutationVariables>;

/**
 * __useMarkJobInstanceAsReadMutation__
 *
 * To run a mutation, you first call `useMarkJobInstanceAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkJobInstanceAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markJobInstanceAsReadMutation, { data, loading, error }] = useMarkJobInstanceAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkJobInstanceAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkJobInstanceAsReadMutation, MarkJobInstanceAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkJobInstanceAsReadMutation, MarkJobInstanceAsReadMutationVariables>(MarkJobInstanceAsReadDocument, options);
      }
export type MarkJobInstanceAsReadMutationHookResult = ReturnType<typeof useMarkJobInstanceAsReadMutation>;
export type MarkJobInstanceAsReadMutationResult = Apollo.MutationResult<MarkJobInstanceAsReadMutation>;
export type MarkJobInstanceAsReadMutationOptions = Apollo.BaseMutationOptions<MarkJobInstanceAsReadMutation, MarkJobInstanceAsReadMutationVariables>;
export const GetJobInstanceDocument = gql`
    query GetJobInstance($id: ID!) {
  getJobInstance(id: $id) {
    id
    startedAt
    updatedAt
    status
    errorMessage
    isRead
    jobConfig {
      id
      name
      description
      enabled
      cronExpr
      toolsApproved
      agent {
        id
      }
      user {
        id
        name
        email
        displayName
      }
    }
    agent {
      id
      name
    }
    conversation {
      id
    }
  }
}
    `;

/**
 * __useGetJobInstanceQuery__
 *
 * To run a query within a React component, call `useGetJobInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobInstanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetJobInstanceQuery, GetJobInstanceQueryVariables> & ({ variables: GetJobInstanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobInstanceQuery, GetJobInstanceQueryVariables>(GetJobInstanceDocument, options);
      }
export function useGetJobInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobInstanceQuery, GetJobInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobInstanceQuery, GetJobInstanceQueryVariables>(GetJobInstanceDocument, options);
        }
// @ts-ignore
export function useGetJobInstanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobInstanceQuery, GetJobInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobInstanceQuery, GetJobInstanceQueryVariables>;
export function useGetJobInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobInstanceQuery, GetJobInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobInstanceQuery | undefined, GetJobInstanceQueryVariables>;
export function useGetJobInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobInstanceQuery, GetJobInstanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobInstanceQuery, GetJobInstanceQueryVariables>(GetJobInstanceDocument, options);
        }
export type GetJobInstanceQueryHookResult = ReturnType<typeof useGetJobInstanceQuery>;
export type GetJobInstanceLazyQueryHookResult = ReturnType<typeof useGetJobInstanceLazyQuery>;
export type GetJobInstanceSuspenseQueryHookResult = ReturnType<typeof useGetJobInstanceSuspenseQuery>;
export type GetJobInstanceQueryResult = Apollo.QueryResult<GetJobInstanceQuery, GetJobInstanceQueryVariables>;
export const ListJobInstancesDocument = gql`
    query ListJobInstances($filter: JobInstanceFilter, $first: Int, $last: Int, $before: String, $after: String) {
  listJobInstances(
    filter: $filter
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        startedAt
        updatedAt
        status
        errorMessage
        isRead
        agent {
          id
        }
        conversation {
          id
        }
        jobConfig {
          id
          name
          description
          user {
            id
            name
            email
            displayName
          }
        }
        agent {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useListJobInstancesQuery__
 *
 * To run a query within a React component, call `useListJobInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobInstancesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListJobInstancesQuery(baseOptions?: Apollo.QueryHookOptions<ListJobInstancesQuery, ListJobInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobInstancesQuery, ListJobInstancesQueryVariables>(ListJobInstancesDocument, options);
      }
export function useListJobInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobInstancesQuery, ListJobInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobInstancesQuery, ListJobInstancesQueryVariables>(ListJobInstancesDocument, options);
        }
// @ts-ignore
export function useListJobInstancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobInstancesQuery, ListJobInstancesQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobInstancesQuery, ListJobInstancesQueryVariables>;
export function useListJobInstancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobInstancesQuery, ListJobInstancesQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobInstancesQuery | undefined, ListJobInstancesQueryVariables>;
export function useListJobInstancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobInstancesQuery, ListJobInstancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobInstancesQuery, ListJobInstancesQueryVariables>(ListJobInstancesDocument, options);
        }
export type ListJobInstancesQueryHookResult = ReturnType<typeof useListJobInstancesQuery>;
export type ListJobInstancesLazyQueryHookResult = ReturnType<typeof useListJobInstancesLazyQuery>;
export type ListJobInstancesSuspenseQueryHookResult = ReturnType<typeof useListJobInstancesSuspenseQuery>;
export type ListJobInstancesQueryResult = Apollo.QueryResult<ListJobInstancesQuery, ListJobInstancesQueryVariables>;
export const GetNotableJobInstanceCountsDocument = gql`
    query GetNotableJobInstanceCounts {
  unread: countJobInstancesByAgent(filter: {isRead: false}) {
    agentId
    count
  }
  awaitingConsent: countJobInstancesByAgent(filter: {status: AWAITING_CONSENT}) {
    agentId
    count
  }
}
    `;

/**
 * __useGetNotableJobInstanceCountsQuery__
 *
 * To run a query within a React component, call `useGetNotableJobInstanceCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotableJobInstanceCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotableJobInstanceCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotableJobInstanceCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>(GetNotableJobInstanceCountsDocument, options);
      }
export function useGetNotableJobInstanceCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>(GetNotableJobInstanceCountsDocument, options);
        }
// @ts-ignore
export function useGetNotableJobInstanceCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>;
export function useGetNotableJobInstanceCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotableJobInstanceCountsQuery | undefined, GetNotableJobInstanceCountsQueryVariables>;
export function useGetNotableJobInstanceCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>(GetNotableJobInstanceCountsDocument, options);
        }
export type GetNotableJobInstanceCountsQueryHookResult = ReturnType<typeof useGetNotableJobInstanceCountsQuery>;
export type GetNotableJobInstanceCountsLazyQueryHookResult = ReturnType<typeof useGetNotableJobInstanceCountsLazyQuery>;
export type GetNotableJobInstanceCountsSuspenseQueryHookResult = ReturnType<typeof useGetNotableJobInstanceCountsSuspenseQuery>;
export type GetNotableJobInstanceCountsQueryResult = Apollo.QueryResult<GetNotableJobInstanceCountsQuery, GetNotableJobInstanceCountsQueryVariables>;
export const GetJobConfigCountsDocument = gql`
    query GetJobConfigCounts {
  countJobConfigsByAgent {
    agentId
    count
  }
}
    `;

/**
 * __useGetJobConfigCountsQuery__
 *
 * To run a query within a React component, call `useGetJobConfigCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobConfigCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobConfigCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobConfigCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>(GetJobConfigCountsDocument, options);
      }
export function useGetJobConfigCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>(GetJobConfigCountsDocument, options);
        }
// @ts-ignore
export function useGetJobConfigCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>;
export function useGetJobConfigCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetJobConfigCountsQuery | undefined, GetJobConfigCountsQueryVariables>;
export function useGetJobConfigCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>(GetJobConfigCountsDocument, options);
        }
export type GetJobConfigCountsQueryHookResult = ReturnType<typeof useGetJobConfigCountsQuery>;
export type GetJobConfigCountsLazyQueryHookResult = ReturnType<typeof useGetJobConfigCountsLazyQuery>;
export type GetJobConfigCountsSuspenseQueryHookResult = ReturnType<typeof useGetJobConfigCountsSuspenseQuery>;
export type GetJobConfigCountsQueryResult = Apollo.QueryResult<GetJobConfigCountsQuery, GetJobConfigCountsQueryVariables>;
export const ListSecretsDocument = gql`
    query ListSecrets($after: String, $before: String, $filter: SecretFilterInput, $first: Int, $last: Int) {
  listSecrets(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        name
        type
        updatedAt
        url
        metadata
        agents {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useListSecretsQuery__
 *
 * To run a query within a React component, call `useListSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSecretsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useListSecretsQuery(baseOptions?: Apollo.QueryHookOptions<ListSecretsQuery, ListSecretsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSecretsQuery, ListSecretsQueryVariables>(ListSecretsDocument, options);
      }
export function useListSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSecretsQuery, ListSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSecretsQuery, ListSecretsQueryVariables>(ListSecretsDocument, options);
        }
// @ts-ignore
export function useListSecretsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSecretsQuery, ListSecretsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSecretsQuery, ListSecretsQueryVariables>;
export function useListSecretsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSecretsQuery, ListSecretsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSecretsQuery | undefined, ListSecretsQueryVariables>;
export function useListSecretsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSecretsQuery, ListSecretsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSecretsQuery, ListSecretsQueryVariables>(ListSecretsDocument, options);
        }
export type ListSecretsQueryHookResult = ReturnType<typeof useListSecretsQuery>;
export type ListSecretsLazyQueryHookResult = ReturnType<typeof useListSecretsLazyQuery>;
export type ListSecretsSuspenseQueryHookResult = ReturnType<typeof useListSecretsSuspenseQuery>;
export type ListSecretsQueryResult = Apollo.QueryResult<ListSecretsQuery, ListSecretsQueryVariables>;
export const DeleteSecretDocument = gql`
    mutation DeleteSecret($id: ID!) {
  deleteSecret(id: $id) {
    id
  }
}
    `;
export type DeleteSecretMutationFn = Apollo.MutationFunction<DeleteSecretMutation, DeleteSecretMutationVariables>;

/**
 * __useDeleteSecretMutation__
 *
 * To run a mutation, you first call `useDeleteSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSecretMutation, { data, loading, error }] = useDeleteSecretMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSecretMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSecretMutation, DeleteSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSecretMutation, DeleteSecretMutationVariables>(DeleteSecretDocument, options);
      }
export type DeleteSecretMutationHookResult = ReturnType<typeof useDeleteSecretMutation>;
export type DeleteSecretMutationResult = Apollo.MutationResult<DeleteSecretMutation>;
export type DeleteSecretMutationOptions = Apollo.BaseMutationOptions<DeleteSecretMutation, DeleteSecretMutationVariables>;
export const CreateSecretDocument = gql`
    mutation CreateSecret($input: CreateSecretInput!) {
  createSecret(input: $input) {
    id
    name
    type
    updatedAt
  }
}
    `;
export type CreateSecretMutationFn = Apollo.MutationFunction<CreateSecretMutation, CreateSecretMutationVariables>;

/**
 * __useCreateSecretMutation__
 *
 * To run a mutation, you first call `useCreateSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSecretMutation, { data, loading, error }] = useCreateSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSecretMutation(baseOptions?: Apollo.MutationHookOptions<CreateSecretMutation, CreateSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSecretMutation, CreateSecretMutationVariables>(CreateSecretDocument, options);
      }
export type CreateSecretMutationHookResult = ReturnType<typeof useCreateSecretMutation>;
export type CreateSecretMutationResult = Apollo.MutationResult<CreateSecretMutation>;
export type CreateSecretMutationOptions = Apollo.BaseMutationOptions<CreateSecretMutation, CreateSecretMutationVariables>;
export const UpdateSecretDocument = gql`
    mutation UpdateSecret($id: ID!, $input: UpdateSecretInput!) {
  updateSecret(id: $id, input: $input) {
    id
    name
    updatedAt
  }
}
    `;
export type UpdateSecretMutationFn = Apollo.MutationFunction<UpdateSecretMutation, UpdateSecretMutationVariables>;

/**
 * __useUpdateSecretMutation__
 *
 * To run a mutation, you first call `useUpdateSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSecretMutation, { data, loading, error }] = useUpdateSecretMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSecretMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSecretMutation, UpdateSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSecretMutation, UpdateSecretMutationVariables>(UpdateSecretDocument, options);
      }
export type UpdateSecretMutationHookResult = ReturnType<typeof useUpdateSecretMutation>;
export type UpdateSecretMutationResult = Apollo.MutationResult<UpdateSecretMutation>;
export type UpdateSecretMutationOptions = Apollo.BaseMutationOptions<UpdateSecretMutation, UpdateSecretMutationVariables>;
export const ListAgentSecretsDocument = gql`
    query ListAgentSecrets($agentId: ID!) {
  agentSecrets(agentId: $agentId) {
    id
    name
    type
    updatedAt
  }
}
    `;

/**
 * __useListAgentSecretsQuery__
 *
 * To run a query within a React component, call `useListAgentSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAgentSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAgentSecretsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useListAgentSecretsQuery(baseOptions: Apollo.QueryHookOptions<ListAgentSecretsQuery, ListAgentSecretsQueryVariables> & ({ variables: ListAgentSecretsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>(ListAgentSecretsDocument, options);
      }
export function useListAgentSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>(ListAgentSecretsDocument, options);
        }
// @ts-ignore
export function useListAgentSecretsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>;
export function useListAgentSecretsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAgentSecretsQuery | undefined, ListAgentSecretsQueryVariables>;
export function useListAgentSecretsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>(ListAgentSecretsDocument, options);
        }
export type ListAgentSecretsQueryHookResult = ReturnType<typeof useListAgentSecretsQuery>;
export type ListAgentSecretsLazyQueryHookResult = ReturnType<typeof useListAgentSecretsLazyQuery>;
export type ListAgentSecretsSuspenseQueryHookResult = ReturnType<typeof useListAgentSecretsSuspenseQuery>;
export type ListAgentSecretsQueryResult = Apollo.QueryResult<ListAgentSecretsQuery, ListAgentSecretsQueryVariables>;
export const GrantAgentSecretAccessDocument = gql`
    mutation GrantAgentSecretAccess($input: GrantAgentAccessInput!) {
  grantAgentSecretAccess(input: $input) {
    id
    name
    type
    updatedAt
  }
}
    `;
export type GrantAgentSecretAccessMutationFn = Apollo.MutationFunction<GrantAgentSecretAccessMutation, GrantAgentSecretAccessMutationVariables>;

/**
 * __useGrantAgentSecretAccessMutation__
 *
 * To run a mutation, you first call `useGrantAgentSecretAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantAgentSecretAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantAgentSecretAccessMutation, { data, loading, error }] = useGrantAgentSecretAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantAgentSecretAccessMutation(baseOptions?: Apollo.MutationHookOptions<GrantAgentSecretAccessMutation, GrantAgentSecretAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantAgentSecretAccessMutation, GrantAgentSecretAccessMutationVariables>(GrantAgentSecretAccessDocument, options);
      }
export type GrantAgentSecretAccessMutationHookResult = ReturnType<typeof useGrantAgentSecretAccessMutation>;
export type GrantAgentSecretAccessMutationResult = Apollo.MutationResult<GrantAgentSecretAccessMutation>;
export type GrantAgentSecretAccessMutationOptions = Apollo.BaseMutationOptions<GrantAgentSecretAccessMutation, GrantAgentSecretAccessMutationVariables>;
export const RevokeAgentSecretAccessDocument = gql`
    mutation RevokeAgentSecretAccess($input: RevokeAgentAccessInput!) {
  revokeAgentSecretAccess(input: $input) {
    id
    name
    type
    updatedAt
  }
}
    `;
export type RevokeAgentSecretAccessMutationFn = Apollo.MutationFunction<RevokeAgentSecretAccessMutation, RevokeAgentSecretAccessMutationVariables>;

/**
 * __useRevokeAgentSecretAccessMutation__
 *
 * To run a mutation, you first call `useRevokeAgentSecretAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAgentSecretAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAgentSecretAccessMutation, { data, loading, error }] = useRevokeAgentSecretAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeAgentSecretAccessMutation(baseOptions?: Apollo.MutationHookOptions<RevokeAgentSecretAccessMutation, RevokeAgentSecretAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeAgentSecretAccessMutation, RevokeAgentSecretAccessMutationVariables>(RevokeAgentSecretAccessDocument, options);
      }
export type RevokeAgentSecretAccessMutationHookResult = ReturnType<typeof useRevokeAgentSecretAccessMutation>;
export type RevokeAgentSecretAccessMutationResult = Apollo.MutationResult<RevokeAgentSecretAccessMutation>;
export type RevokeAgentSecretAccessMutationOptions = Apollo.BaseMutationOptions<RevokeAgentSecretAccessMutation, RevokeAgentSecretAccessMutationVariables>;
export const ConversationFilesystemDocument = gql`
    query ConversationFilesystem($conversationId: ID!) {
  conversationFilesystem(conversationId: $conversationId) {
    files {
      path
      type
      content
      createdAt
      modifiedAt
    }
    currentDirectory
  }
}
    `;

/**
 * __useConversationFilesystemQuery__
 *
 * To run a query within a React component, call `useConversationFilesystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationFilesystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationFilesystemQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationFilesystemQuery(baseOptions: Apollo.QueryHookOptions<ConversationFilesystemQuery, ConversationFilesystemQueryVariables> & ({ variables: ConversationFilesystemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>(ConversationFilesystemDocument, options);
      }
export function useConversationFilesystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>(ConversationFilesystemDocument, options);
        }
// @ts-ignore
export function useConversationFilesystemSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>;
export function useConversationFilesystemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationFilesystemQuery | undefined, ConversationFilesystemQueryVariables>;
export function useConversationFilesystemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>(ConversationFilesystemDocument, options);
        }
export type ConversationFilesystemQueryHookResult = ReturnType<typeof useConversationFilesystemQuery>;
export type ConversationFilesystemLazyQueryHookResult = ReturnType<typeof useConversationFilesystemLazyQuery>;
export type ConversationFilesystemSuspenseQueryHookResult = ReturnType<typeof useConversationFilesystemSuspenseQuery>;
export type ConversationFilesystemQueryResult = Apollo.QueryResult<ConversationFilesystemQuery, ConversationFilesystemQueryVariables>;
export const ListWorkflowsDocument = gql`
    query ListWorkflows($first: Int, $after: String, $filter: WorkflowFilter) {
  workflows(first: $first, after: $after, filter: $filter) {
    totalCount
    edges {
      cursor
      node {
        id
        name
        description
        version
        status
        isLatest
        externalWorkflowId
        workflowSpec
        inputSchema
        outputSchema
        outputs
        createdAt
        updatedAt
        createdBy {
          id
          email
          insertedAt
          updatedAt
        }
        latestExecution {
          id
          externalId
          status
          outputs
          startedAt
          completedAt
          createdAt
          updatedAt
          workflowDefinitionId
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useListWorkflowsQuery__
 *
 * To run a query within a React component, call `useListWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(ListWorkflowsDocument, options);
      }
export function useListWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(ListWorkflowsDocument, options);
        }
// @ts-ignore
export function useListWorkflowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkflowsQuery, ListWorkflowsQueryVariables>;
export function useListWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkflowsQuery | undefined, ListWorkflowsQueryVariables>;
export function useListWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkflowsQuery, ListWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkflowsQuery, ListWorkflowsQueryVariables>(ListWorkflowsDocument, options);
        }
export type ListWorkflowsQueryHookResult = ReturnType<typeof useListWorkflowsQuery>;
export type ListWorkflowsLazyQueryHookResult = ReturnType<typeof useListWorkflowsLazyQuery>;
export type ListWorkflowsSuspenseQueryHookResult = ReturnType<typeof useListWorkflowsSuspenseQuery>;
export type ListWorkflowsQueryResult = Apollo.QueryResult<ListWorkflowsQuery, ListWorkflowsQueryVariables>;
export const GetWorkflowCountsDocument = gql`
    query GetWorkflowCounts {
  publishedCount: workflows(first: 0, filter: {status: PUBLISHED}) {
    totalCount
  }
  draftCount: workflows(first: 0, filter: {status: DRAFT}) {
    totalCount
  }
  deprecatedCount: workflows(first: 0, filter: {status: DEPRECATED}) {
    totalCount
  }
}
    `;

/**
 * __useGetWorkflowCountsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>(GetWorkflowCountsDocument, options);
      }
export function useGetWorkflowCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>(GetWorkflowCountsDocument, options);
        }
// @ts-ignore
export function useGetWorkflowCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>;
export function useGetWorkflowCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowCountsQuery | undefined, GetWorkflowCountsQueryVariables>;
export function useGetWorkflowCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>(GetWorkflowCountsDocument, options);
        }
export type GetWorkflowCountsQueryHookResult = ReturnType<typeof useGetWorkflowCountsQuery>;
export type GetWorkflowCountsLazyQueryHookResult = ReturnType<typeof useGetWorkflowCountsLazyQuery>;
export type GetWorkflowCountsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowCountsSuspenseQuery>;
export type GetWorkflowCountsQueryResult = Apollo.QueryResult<GetWorkflowCountsQuery, GetWorkflowCountsQueryVariables>;
export const GetWorkflowDocument = gql`
    query GetWorkflow($id: ID!) {
  workflow(id: $id) {
    id
    name
    description
    version
    status
    isLatest
    engine
    externalWorkflowId
    workflowSpec
    inputSchema
    outputSchema
    outputs
    metadata
    createdAt
    updatedAt
    createdById
    createdBy {
      id
      email
      insertedAt
      updatedAt
    }
    workflowType
    isRoot
    isSubworkflow
    isShared
  }
}
    `;

/**
 * __useGetWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables> & ({ variables: GetWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
      }
export function useGetWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
// @ts-ignore
export function useGetWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowQuery, GetWorkflowQueryVariables>;
export function useGetWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowQuery | undefined, GetWorkflowQueryVariables>;
export function useGetWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowQuery, GetWorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowQuery, GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
export type GetWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowQuery>;
export type GetWorkflowLazyQueryHookResult = ReturnType<typeof useGetWorkflowLazyQuery>;
export type GetWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSuspenseQuery>;
export type GetWorkflowQueryResult = Apollo.QueryResult<GetWorkflowQuery, GetWorkflowQueryVariables>;
export const ListExecutionsDocument = gql`
    query ListExecutions($first: Int, $after: String, $filter: ExecutionFilter) {
  executions(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        id
        externalId
        status
        inputs
        outputs
        errorMessage
        startedAt
        completedAt
        workflowDefinition {
          id
          name
          version
        }
        triggeredBy {
          id
          email
          insertedAt
          updatedAt
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useListExecutionsQuery__
 *
 * To run a query within a React component, call `useListExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExecutionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<ListExecutionsQuery, ListExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListExecutionsQuery, ListExecutionsQueryVariables>(ListExecutionsDocument, options);
      }
export function useListExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListExecutionsQuery, ListExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListExecutionsQuery, ListExecutionsQueryVariables>(ListExecutionsDocument, options);
        }
// @ts-ignore
export function useListExecutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListExecutionsQuery, ListExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListExecutionsQuery, ListExecutionsQueryVariables>;
export function useListExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListExecutionsQuery, ListExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListExecutionsQuery | undefined, ListExecutionsQueryVariables>;
export function useListExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListExecutionsQuery, ListExecutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListExecutionsQuery, ListExecutionsQueryVariables>(ListExecutionsDocument, options);
        }
export type ListExecutionsQueryHookResult = ReturnType<typeof useListExecutionsQuery>;
export type ListExecutionsLazyQueryHookResult = ReturnType<typeof useListExecutionsLazyQuery>;
export type ListExecutionsSuspenseQueryHookResult = ReturnType<typeof useListExecutionsSuspenseQuery>;
export type ListExecutionsQueryResult = Apollo.QueryResult<ListExecutionsQuery, ListExecutionsQueryVariables>;
export const GetExecutionDocument = gql`
    query GetExecution($id: ID!) {
  execution(id: $id) {
    id
    externalId
    status
    inputs
    outputs
    artifacts {
      artifactId
      name
      uri
      size
      hash
      contentType
      storageBackend
      metadata
      createdAt
    }
    errorMessage
    startedAt
    completedAt
    workflowDefinitionId
    workflowDefinition {
      id
      name
      version
      engine
      workflowSpec
    }
    triggeredById
    triggeredBy {
      id
      email
      insertedAt
      updatedAt
    }
    currentStatus {
      status
      phase
      message
      updatedAt
    }
    nodeExecutions {
      nodeId
      displayName
      phase
      startedAt
      updatedAt
      duration
      attempt
      inputs
      outputs
      errorMessage
      logsUri
      inputUri
      outputUri
      cacheStatus
      artifacts {
        artifactId
        name
        uri
        size
        hash
        contentType
        storageBackend
        metadata
        createdAt
      }
      metadata {
        specNodeId
        isParentNode
        isDynamic
        isArray
      }
      subworkflowExecutionInfo {
        isSubworkflow
        childNodeCount
        aggregateStatus
        childPhases {
          nodeId
          phase
        }
        childExecutionId
      }
      workflowNodeMetadata {
        executionId {
          project
          domain
          name
        }
      }
      arrayTaskStatuses {
        total
        succeeded
        running
        failed
        queued
        pending
      }
      taskExecutions {
        retryAttempt
        phase
        startedAt
        duration
        errorMessage
        logsUri
      }
    }
    signals {
      signalId
      type
      value
      hasValue
      schema
    }
    executionStateSnapshot
  }
}
    `;

/**
 * __useGetExecutionQuery__
 *
 * To run a query within a React component, call `useGetExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExecutionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExecutionQuery(baseOptions: Apollo.QueryHookOptions<GetExecutionQuery, GetExecutionQueryVariables> & ({ variables: GetExecutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExecutionQuery, GetExecutionQueryVariables>(GetExecutionDocument, options);
      }
export function useGetExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExecutionQuery, GetExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExecutionQuery, GetExecutionQueryVariables>(GetExecutionDocument, options);
        }
// @ts-ignore
export function useGetExecutionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExecutionQuery, GetExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetExecutionQuery, GetExecutionQueryVariables>;
export function useGetExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExecutionQuery, GetExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetExecutionQuery | undefined, GetExecutionQueryVariables>;
export function useGetExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExecutionQuery, GetExecutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExecutionQuery, GetExecutionQueryVariables>(GetExecutionDocument, options);
        }
export type GetExecutionQueryHookResult = ReturnType<typeof useGetExecutionQuery>;
export type GetExecutionLazyQueryHookResult = ReturnType<typeof useGetExecutionLazyQuery>;
export type GetExecutionSuspenseQueryHookResult = ReturnType<typeof useGetExecutionSuspenseQuery>;
export type GetExecutionQueryResult = Apollo.QueryResult<GetExecutionQuery, GetExecutionQueryVariables>;
export const GetExecutionByExternalIdDocument = gql`
    query GetExecutionByExternalId($externalId: String!) {
  executionByExternalId(externalId: $externalId) {
    id
    externalId
    status
    inputs
    outputs
    artifacts {
      artifactId
      name
      uri
      size
      hash
      contentType
      storageBackend
      metadata
      createdAt
    }
    errorMessage
    startedAt
    completedAt
    workflowDefinitionId
    workflowDefinition {
      id
      name
      version
      engine
      workflowSpec
    }
    triggeredById
    triggeredBy {
      id
      email
      insertedAt
      updatedAt
    }
    currentStatus {
      status
      phase
      message
      updatedAt
    }
    nodeExecutions {
      nodeId
      displayName
      phase
      startedAt
      updatedAt
      duration
      attempt
      inputs
      outputs
      errorMessage
      logsUri
      inputUri
      outputUri
      cacheStatus
      artifacts {
        artifactId
        name
        uri
        size
        hash
        contentType
        storageBackend
        metadata
        createdAt
      }
      metadata {
        specNodeId
        isParentNode
        isDynamic
        isArray
      }
      subworkflowExecutionInfo {
        isSubworkflow
        childNodeCount
        aggregateStatus
        childPhases {
          nodeId
          phase
        }
        childExecutionId
      }
      workflowNodeMetadata {
        executionId {
          project
          domain
          name
        }
      }
      arrayTaskStatuses {
        total
        succeeded
        running
        failed
        queued
        pending
      }
      taskExecutions {
        retryAttempt
        phase
        startedAt
        duration
        errorMessage
        logsUri
      }
    }
    signals {
      signalId
      type
      value
      hasValue
      schema
    }
    executionStateSnapshot
  }
}
    `;

/**
 * __useGetExecutionByExternalIdQuery__
 *
 * To run a query within a React component, call `useGetExecutionByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExecutionByExternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExecutionByExternalIdQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useGetExecutionByExternalIdQuery(baseOptions: Apollo.QueryHookOptions<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables> & ({ variables: GetExecutionByExternalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>(GetExecutionByExternalIdDocument, options);
      }
export function useGetExecutionByExternalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>(GetExecutionByExternalIdDocument, options);
        }
// @ts-ignore
export function useGetExecutionByExternalIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>;
export function useGetExecutionByExternalIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetExecutionByExternalIdQuery | undefined, GetExecutionByExternalIdQueryVariables>;
export function useGetExecutionByExternalIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>(GetExecutionByExternalIdDocument, options);
        }
export type GetExecutionByExternalIdQueryHookResult = ReturnType<typeof useGetExecutionByExternalIdQuery>;
export type GetExecutionByExternalIdLazyQueryHookResult = ReturnType<typeof useGetExecutionByExternalIdLazyQuery>;
export type GetExecutionByExternalIdSuspenseQueryHookResult = ReturnType<typeof useGetExecutionByExternalIdSuspenseQuery>;
export type GetExecutionByExternalIdQueryResult = Apollo.QueryResult<GetExecutionByExternalIdQuery, GetExecutionByExternalIdQueryVariables>;
export const GetExecutionEventsDocument = gql`
    query GetExecutionEvents($id: ID!) {
  executionEvents(executionId: $id) {
    id
    occurredAt
    phase
    producerId
    message
    eventType
  }
}
    `;

/**
 * __useGetExecutionEventsQuery__
 *
 * To run a query within a React component, call `useGetExecutionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExecutionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExecutionEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExecutionEventsQuery(baseOptions: Apollo.QueryHookOptions<GetExecutionEventsQuery, GetExecutionEventsQueryVariables> & ({ variables: GetExecutionEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>(GetExecutionEventsDocument, options);
      }
export function useGetExecutionEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>(GetExecutionEventsDocument, options);
        }
// @ts-ignore
export function useGetExecutionEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>;
export function useGetExecutionEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetExecutionEventsQuery | undefined, GetExecutionEventsQueryVariables>;
export function useGetExecutionEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>(GetExecutionEventsDocument, options);
        }
export type GetExecutionEventsQueryHookResult = ReturnType<typeof useGetExecutionEventsQuery>;
export type GetExecutionEventsLazyQueryHookResult = ReturnType<typeof useGetExecutionEventsLazyQuery>;
export type GetExecutionEventsSuspenseQueryHookResult = ReturnType<typeof useGetExecutionEventsSuspenseQuery>;
export type GetExecutionEventsQueryResult = Apollo.QueryResult<GetExecutionEventsQuery, GetExecutionEventsQueryVariables>;
export const GetMyWorkflowsDocument = gql`
    query GetMyWorkflows($first: Int) {
  myWorkflows(first: $first) {
    edges {
      node {
        id
        name
        description
        version
        status
        isLatest
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetMyWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetMyWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyWorkflowsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetMyWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>(GetMyWorkflowsDocument, options);
      }
export function useGetMyWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>(GetMyWorkflowsDocument, options);
        }
// @ts-ignore
export function useGetMyWorkflowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>;
export function useGetMyWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyWorkflowsQuery | undefined, GetMyWorkflowsQueryVariables>;
export function useGetMyWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>(GetMyWorkflowsDocument, options);
        }
export type GetMyWorkflowsQueryHookResult = ReturnType<typeof useGetMyWorkflowsQuery>;
export type GetMyWorkflowsLazyQueryHookResult = ReturnType<typeof useGetMyWorkflowsLazyQuery>;
export type GetMyWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetMyWorkflowsSuspenseQuery>;
export type GetMyWorkflowsQueryResult = Apollo.QueryResult<GetMyWorkflowsQuery, GetMyWorkflowsQueryVariables>;
export const CreateWorkflowDocument = gql`
    mutation CreateWorkflow($input: CreateWorkflowInput!) {
  createWorkflow(input: $input) {
    id
    name
    description
    version
    status
    workflowSpec
    metadata
    createdById
    createdAt
  }
}
    `;
export type CreateWorkflowMutationFn = Apollo.MutationFunction<CreateWorkflowMutation, CreateWorkflowMutationVariables>;

/**
 * __useCreateWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutation, { data, loading, error }] = useCreateWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(CreateWorkflowDocument, options);
      }
export type CreateWorkflowMutationHookResult = ReturnType<typeof useCreateWorkflowMutation>;
export type CreateWorkflowMutationResult = Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const CreateWorkflowFromTemplateDocument = gql`
    mutation CreateWorkflowFromTemplate($templateId: String!, $name: String, $description: String, $version: String, $metadata: Json) {
  createWorkflowFromTemplate(
    templateId: $templateId
    name: $name
    description: $description
    version: $version
    metadata: $metadata
  ) {
    id
    name
    description
    version
    status
    workflowSpec
    metadata
    createdById
    createdAt
  }
}
    `;
export type CreateWorkflowFromTemplateMutationFn = Apollo.MutationFunction<CreateWorkflowFromTemplateMutation, CreateWorkflowFromTemplateMutationVariables>;

/**
 * __useCreateWorkflowFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowFromTemplateMutation, { data, loading, error }] = useCreateWorkflowFromTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      version: // value for 'version'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateWorkflowFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowFromTemplateMutation, CreateWorkflowFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowFromTemplateMutation, CreateWorkflowFromTemplateMutationVariables>(CreateWorkflowFromTemplateDocument, options);
      }
export type CreateWorkflowFromTemplateMutationHookResult = ReturnType<typeof useCreateWorkflowFromTemplateMutation>;
export type CreateWorkflowFromTemplateMutationResult = Apollo.MutationResult<CreateWorkflowFromTemplateMutation>;
export type CreateWorkflowFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowFromTemplateMutation, CreateWorkflowFromTemplateMutationVariables>;
export const UpdateWorkflowDocument = gql`
    mutation UpdateWorkflow($id: ID!, $input: UpdateWorkflowInput!) {
  updateWorkflow(id: $id, input: $input) {
    id
    name
    description
    version
    status
    workflowSpec
    metadata
    updatedAt
  }
}
    `;
export type UpdateWorkflowMutationFn = Apollo.MutationFunction<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;

/**
 * __useUpdateWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowMutation, { data, loading, error }] = useUpdateWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>(UpdateWorkflowDocument, options);
      }
export type UpdateWorkflowMutationHookResult = ReturnType<typeof useUpdateWorkflowMutation>;
export type UpdateWorkflowMutationResult = Apollo.MutationResult<UpdateWorkflowMutation>;
export type UpdateWorkflowMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const PublishWorkflowDocument = gql`
    mutation PublishWorkflow($id: ID!) {
  publishWorkflow(id: $id) {
    id
    status
    externalWorkflowId
  }
}
    `;
export type PublishWorkflowMutationFn = Apollo.MutationFunction<PublishWorkflowMutation, PublishWorkflowMutationVariables>;

/**
 * __usePublishWorkflowMutation__
 *
 * To run a mutation, you first call `usePublishWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWorkflowMutation, { data, loading, error }] = usePublishWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<PublishWorkflowMutation, PublishWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishWorkflowMutation, PublishWorkflowMutationVariables>(PublishWorkflowDocument, options);
      }
export type PublishWorkflowMutationHookResult = ReturnType<typeof usePublishWorkflowMutation>;
export type PublishWorkflowMutationResult = Apollo.MutationResult<PublishWorkflowMutation>;
export type PublishWorkflowMutationOptions = Apollo.BaseMutationOptions<PublishWorkflowMutation, PublishWorkflowMutationVariables>;
export const CreateWorkflowVersionDocument = gql`
    mutation CreateWorkflowVersion($workflowId: ID!, $version: String!) {
  createWorkflowVersion(workflowId: $workflowId, version: $version) {
    id
    name
    version
    status
    description
    workflowSpec
  }
}
    `;
export type CreateWorkflowVersionMutationFn = Apollo.MutationFunction<CreateWorkflowVersionMutation, CreateWorkflowVersionMutationVariables>;

/**
 * __useCreateWorkflowVersionMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowVersionMutation, { data, loading, error }] = useCreateWorkflowVersionMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useCreateWorkflowVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowVersionMutation, CreateWorkflowVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowVersionMutation, CreateWorkflowVersionMutationVariables>(CreateWorkflowVersionDocument, options);
      }
export type CreateWorkflowVersionMutationHookResult = ReturnType<typeof useCreateWorkflowVersionMutation>;
export type CreateWorkflowVersionMutationResult = Apollo.MutationResult<CreateWorkflowVersionMutation>;
export type CreateWorkflowVersionMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowVersionMutation, CreateWorkflowVersionMutationVariables>;
export const DeleteWorkflowDocument = gql`
    mutation DeleteWorkflow($id: ID!) {
  deleteWorkflow(id: $id) {
    id
    status
  }
}
    `;
export type DeleteWorkflowMutationFn = Apollo.MutationFunction<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;

/**
 * __useDeleteWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowMutation, { data, loading, error }] = useDeleteWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>(DeleteWorkflowDocument, options);
      }
export type DeleteWorkflowMutationHookResult = ReturnType<typeof useDeleteWorkflowMutation>;
export type DeleteWorkflowMutationResult = Apollo.MutationResult<DeleteWorkflowMutation>;
export type DeleteWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;
export const ExecuteWorkflowDocument = gql`
    mutation ExecuteWorkflow($input: ExecuteWorkflowInput!) {
  executeWorkflow(input: $input) {
    id
    externalId
    status
    inputs
    startedAt
    workflowDefinitionId
    triggeredById
  }
}
    `;
export type ExecuteWorkflowMutationFn = Apollo.MutationFunction<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>;

/**
 * __useExecuteWorkflowMutation__
 *
 * To run a mutation, you first call `useExecuteWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeWorkflowMutation, { data, loading, error }] = useExecuteWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>(ExecuteWorkflowDocument, options);
      }
export type ExecuteWorkflowMutationHookResult = ReturnType<typeof useExecuteWorkflowMutation>;
export type ExecuteWorkflowMutationResult = Apollo.MutationResult<ExecuteWorkflowMutation>;
export type ExecuteWorkflowMutationOptions = Apollo.BaseMutationOptions<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>;
export const CancelExecutionDocument = gql`
    mutation CancelExecution($id: ID!) {
  cancelExecution(id: $id) {
    id
    status
  }
}
    `;
export type CancelExecutionMutationFn = Apollo.MutationFunction<CancelExecutionMutation, CancelExecutionMutationVariables>;

/**
 * __useCancelExecutionMutation__
 *
 * To run a mutation, you first call `useCancelExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelExecutionMutation, { data, loading, error }] = useCancelExecutionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelExecutionMutation(baseOptions?: Apollo.MutationHookOptions<CancelExecutionMutation, CancelExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelExecutionMutation, CancelExecutionMutationVariables>(CancelExecutionDocument, options);
      }
export type CancelExecutionMutationHookResult = ReturnType<typeof useCancelExecutionMutation>;
export type CancelExecutionMutationResult = Apollo.MutationResult<CancelExecutionMutation>;
export type CancelExecutionMutationOptions = Apollo.BaseMutationOptions<CancelExecutionMutation, CancelExecutionMutationVariables>;
export const RetryExecutionDocument = gql`
    mutation RetryExecution($id: ID!) {
  retryExecution(id: $id) {
    id
    status
    externalId
    startedAt
    metadata
  }
}
    `;
export type RetryExecutionMutationFn = Apollo.MutationFunction<RetryExecutionMutation, RetryExecutionMutationVariables>;

/**
 * __useRetryExecutionMutation__
 *
 * To run a mutation, you first call `useRetryExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryExecutionMutation, { data, loading, error }] = useRetryExecutionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryExecutionMutation(baseOptions?: Apollo.MutationHookOptions<RetryExecutionMutation, RetryExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryExecutionMutation, RetryExecutionMutationVariables>(RetryExecutionDocument, options);
      }
export type RetryExecutionMutationHookResult = ReturnType<typeof useRetryExecutionMutation>;
export type RetryExecutionMutationResult = Apollo.MutationResult<RetryExecutionMutation>;
export type RetryExecutionMutationOptions = Apollo.BaseMutationOptions<RetryExecutionMutation, RetryExecutionMutationVariables>;
export const ExecuteTaskDocument = gql`
    mutation ExecuteTask($input: ExecuteTaskInput!) {
  executeTask(input: $input) {
    status
    outputs
    error
    errorType
  }
}
    `;
export type ExecuteTaskMutationFn = Apollo.MutationFunction<ExecuteTaskMutation, ExecuteTaskMutationVariables>;

/**
 * __useExecuteTaskMutation__
 *
 * To run a mutation, you first call `useExecuteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeTaskMutation, { data, loading, error }] = useExecuteTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteTaskMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteTaskMutation, ExecuteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteTaskMutation, ExecuteTaskMutationVariables>(ExecuteTaskDocument, options);
      }
export type ExecuteTaskMutationHookResult = ReturnType<typeof useExecuteTaskMutation>;
export type ExecuteTaskMutationResult = Apollo.MutationResult<ExecuteTaskMutation>;
export type ExecuteTaskMutationOptions = Apollo.BaseMutationOptions<ExecuteTaskMutation, ExecuteTaskMutationVariables>;
export const SetSignalDocument = gql`
    mutation SetSignal($executionId: ID!, $signalId: String!, $value: Json!) {
  setSignal(executionId: $executionId, signalId: $signalId, value: $value) {
    success
    message
  }
}
    `;
export type SetSignalMutationFn = Apollo.MutationFunction<SetSignalMutation, SetSignalMutationVariables>;

/**
 * __useSetSignalMutation__
 *
 * To run a mutation, you first call `useSetSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignalMutation, { data, loading, error }] = useSetSignalMutation({
 *   variables: {
 *      executionId: // value for 'executionId'
 *      signalId: // value for 'signalId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetSignalMutation(baseOptions?: Apollo.MutationHookOptions<SetSignalMutation, SetSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSignalMutation, SetSignalMutationVariables>(SetSignalDocument, options);
      }
export type SetSignalMutationHookResult = ReturnType<typeof useSetSignalMutation>;
export type SetSignalMutationResult = Apollo.MutationResult<SetSignalMutation>;
export type SetSignalMutationOptions = Apollo.BaseMutationOptions<SetSignalMutation, SetSignalMutationVariables>;
export const ExecutionUpdatedDocument = gql`
    subscription ExecutionUpdated($id: ID!) {
  executionUpdated(id: $id) {
    id
    externalId
    status
    outputs
    errorMessage
    completedAt
    currentStatus {
      status
      phase
      message
      updatedAt
    }
  }
}
    `;

/**
 * __useExecutionUpdatedSubscription__
 *
 * To run a query within a React component, call `useExecutionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExecutionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutionUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExecutionUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ExecutionUpdatedSubscription, ExecutionUpdatedSubscriptionVariables> & ({ variables: ExecutionUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ExecutionUpdatedSubscription, ExecutionUpdatedSubscriptionVariables>(ExecutionUpdatedDocument, options);
      }
export type ExecutionUpdatedSubscriptionHookResult = ReturnType<typeof useExecutionUpdatedSubscription>;
export type ExecutionUpdatedSubscriptionResult = Apollo.SubscriptionResult<ExecutionUpdatedSubscription>;
export const WorkflowExecutionsDocument = gql`
    subscription WorkflowExecutions($workflowId: ID!) {
  workflowExecutions(workflowId: $workflowId) {
    id
    externalId
    status
    startedAt
    triggeredBy {
      id
      email
    }
  }
}
    `;

/**
 * __useWorkflowExecutionsSubscription__
 *
 * To run a query within a React component, call `useWorkflowExecutionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowExecutionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowExecutionsSubscription({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useWorkflowExecutionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkflowExecutionsSubscription, WorkflowExecutionsSubscriptionVariables> & ({ variables: WorkflowExecutionsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkflowExecutionsSubscription, WorkflowExecutionsSubscriptionVariables>(WorkflowExecutionsDocument, options);
      }
export type WorkflowExecutionsSubscriptionHookResult = ReturnType<typeof useWorkflowExecutionsSubscription>;
export type WorkflowExecutionsSubscriptionResult = Apollo.SubscriptionResult<WorkflowExecutionsSubscription>;
export const GetWorkflowTemplatesDocument = gql`
    query GetWorkflowTemplates($query: String) {
  workflowTemplates(query: $query) {
    id
    name
    description
    category
    icon
    template {
      name
      description
      version
      templateType
      workflowSpec
    }
  }
}
    `;

/**
 * __useGetWorkflowTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTemplatesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetWorkflowTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>(GetWorkflowTemplatesDocument, options);
      }
export function useGetWorkflowTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>(GetWorkflowTemplatesDocument, options);
        }
// @ts-ignore
export function useGetWorkflowTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>;
export function useGetWorkflowTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowTemplatesQuery | undefined, GetWorkflowTemplatesQueryVariables>;
export function useGetWorkflowTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>(GetWorkflowTemplatesDocument, options);
        }
export type GetWorkflowTemplatesQueryHookResult = ReturnType<typeof useGetWorkflowTemplatesQuery>;
export type GetWorkflowTemplatesLazyQueryHookResult = ReturnType<typeof useGetWorkflowTemplatesLazyQuery>;
export type GetWorkflowTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowTemplatesSuspenseQuery>;
export type GetWorkflowTemplatesQueryResult = Apollo.QueryResult<GetWorkflowTemplatesQuery, GetWorkflowTemplatesQueryVariables>;
export const GetWorkflowTemplatesListDocument = gql`
    query GetWorkflowTemplatesList($query: String) {
  workflowTemplatesSummary(query: $query) {
    id
    name
    description
    category
    icon
  }
}
    `;

/**
 * __useGetWorkflowTemplatesListQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTemplatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTemplatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTemplatesListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetWorkflowTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>(GetWorkflowTemplatesListDocument, options);
      }
export function useGetWorkflowTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>(GetWorkflowTemplatesListDocument, options);
        }
// @ts-ignore
export function useGetWorkflowTemplatesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>;
export function useGetWorkflowTemplatesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowTemplatesListQuery | undefined, GetWorkflowTemplatesListQueryVariables>;
export function useGetWorkflowTemplatesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>(GetWorkflowTemplatesListDocument, options);
        }
export type GetWorkflowTemplatesListQueryHookResult = ReturnType<typeof useGetWorkflowTemplatesListQuery>;
export type GetWorkflowTemplatesListLazyQueryHookResult = ReturnType<typeof useGetWorkflowTemplatesListLazyQuery>;
export type GetWorkflowTemplatesListSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowTemplatesListSuspenseQuery>;
export type GetWorkflowTemplatesListQueryResult = Apollo.QueryResult<GetWorkflowTemplatesListQuery, GetWorkflowTemplatesListQueryVariables>;
export const GetWorkflowTemplateDocument = gql`
    query GetWorkflowTemplate($id: ID!) {
  workflowTemplate(id: $id) {
    id
    name
    description
    category
    icon
    template {
      name
      description
      version
      templateType
      workflowSpec
    }
  }
}
    `;

/**
 * __useGetWorkflowTemplateQuery__
 *
 * To run a query within a React component, call `useGetWorkflowTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables> & ({ variables: GetWorkflowTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>(GetWorkflowTemplateDocument, options);
      }
export function useGetWorkflowTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>(GetWorkflowTemplateDocument, options);
        }
// @ts-ignore
export function useGetWorkflowTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>;
export function useGetWorkflowTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowTemplateQuery | undefined, GetWorkflowTemplateQueryVariables>;
export function useGetWorkflowTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>(GetWorkflowTemplateDocument, options);
        }
export type GetWorkflowTemplateQueryHookResult = ReturnType<typeof useGetWorkflowTemplateQuery>;
export type GetWorkflowTemplateLazyQueryHookResult = ReturnType<typeof useGetWorkflowTemplateLazyQuery>;
export type GetWorkflowTemplateSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowTemplateSuspenseQuery>;
export type GetWorkflowTemplateQueryResult = Apollo.QueryResult<GetWorkflowTemplateQuery, GetWorkflowTemplateQueryVariables>;
export const GetNodeExecutionLogsDocument = gql`
    query GetNodeExecutionLogs($executionId: ID!, $nodeId: String!, $tailLines: Int, $sinceSeconds: Int) {
  nodeExecutionLogs(
    executionId: $executionId
    nodeId: $nodeId
    tailLines: $tailLines
    sinceSeconds: $sinceSeconds
  ) {
    lines {
      timestamp
      message
      level
      source
      metadata
    }
    source
    hasMore
    continuationToken
    metadata
  }
}
    `;

/**
 * __useGetNodeExecutionLogsQuery__
 *
 * To run a query within a React component, call `useGetNodeExecutionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeExecutionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeExecutionLogsQuery({
 *   variables: {
 *      executionId: // value for 'executionId'
 *      nodeId: // value for 'nodeId'
 *      tailLines: // value for 'tailLines'
 *      sinceSeconds: // value for 'sinceSeconds'
 *   },
 * });
 */
export function useGetNodeExecutionLogsQuery(baseOptions: Apollo.QueryHookOptions<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables> & ({ variables: GetNodeExecutionLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>(GetNodeExecutionLogsDocument, options);
      }
export function useGetNodeExecutionLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>(GetNodeExecutionLogsDocument, options);
        }
// @ts-ignore
export function useGetNodeExecutionLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>;
export function useGetNodeExecutionLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNodeExecutionLogsQuery | undefined, GetNodeExecutionLogsQueryVariables>;
export function useGetNodeExecutionLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>(GetNodeExecutionLogsDocument, options);
        }
export type GetNodeExecutionLogsQueryHookResult = ReturnType<typeof useGetNodeExecutionLogsQuery>;
export type GetNodeExecutionLogsLazyQueryHookResult = ReturnType<typeof useGetNodeExecutionLogsLazyQuery>;
export type GetNodeExecutionLogsSuspenseQueryHookResult = ReturnType<typeof useGetNodeExecutionLogsSuspenseQuery>;
export type GetNodeExecutionLogsQueryResult = Apollo.QueryResult<GetNodeExecutionLogsQuery, GetNodeExecutionLogsQueryVariables>;
export const GetTaskExecutionLogsDocument = gql`
    query GetTaskExecutionLogs($executionId: ID!, $nodeId: String!, $retryAttempt: Int!, $tailLines: Int, $sinceSeconds: Int) {
  taskExecutionLogs(
    executionId: $executionId
    nodeId: $nodeId
    retryAttempt: $retryAttempt
    tailLines: $tailLines
    sinceSeconds: $sinceSeconds
  ) {
    lines {
      timestamp
      message
      level
      source
      metadata
    }
    source
    hasMore
    continuationToken
    metadata
  }
}
    `;

/**
 * __useGetTaskExecutionLogsQuery__
 *
 * To run a query within a React component, call `useGetTaskExecutionLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskExecutionLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskExecutionLogsQuery({
 *   variables: {
 *      executionId: // value for 'executionId'
 *      nodeId: // value for 'nodeId'
 *      retryAttempt: // value for 'retryAttempt'
 *      tailLines: // value for 'tailLines'
 *      sinceSeconds: // value for 'sinceSeconds'
 *   },
 * });
 */
export function useGetTaskExecutionLogsQuery(baseOptions: Apollo.QueryHookOptions<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables> & ({ variables: GetTaskExecutionLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>(GetTaskExecutionLogsDocument, options);
      }
export function useGetTaskExecutionLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>(GetTaskExecutionLogsDocument, options);
        }
// @ts-ignore
export function useGetTaskExecutionLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>;
export function useGetTaskExecutionLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskExecutionLogsQuery | undefined, GetTaskExecutionLogsQueryVariables>;
export function useGetTaskExecutionLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>(GetTaskExecutionLogsDocument, options);
        }
export type GetTaskExecutionLogsQueryHookResult = ReturnType<typeof useGetTaskExecutionLogsQuery>;
export type GetTaskExecutionLogsLazyQueryHookResult = ReturnType<typeof useGetTaskExecutionLogsLazyQuery>;
export type GetTaskExecutionLogsSuspenseQueryHookResult = ReturnType<typeof useGetTaskExecutionLogsSuspenseQuery>;
export type GetTaskExecutionLogsQueryResult = Apollo.QueryResult<GetTaskExecutionLogsQuery, GetTaskExecutionLogsQueryVariables>;
export const ExecutionLogsStreamDocument = gql`
    subscription ExecutionLogsStream($executionId: ID!, $nodeId: String!) {
  executionLogsStream(executionId: $executionId, nodeId: $nodeId) {
    timestamp
    message
    level
    source
    metadata
  }
}
    `;

/**
 * __useExecutionLogsStreamSubscription__
 *
 * To run a query within a React component, call `useExecutionLogsStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExecutionLogsStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutionLogsStreamSubscription({
 *   variables: {
 *      executionId: // value for 'executionId'
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useExecutionLogsStreamSubscription(baseOptions: Apollo.SubscriptionHookOptions<ExecutionLogsStreamSubscription, ExecutionLogsStreamSubscriptionVariables> & ({ variables: ExecutionLogsStreamSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ExecutionLogsStreamSubscription, ExecutionLogsStreamSubscriptionVariables>(ExecutionLogsStreamDocument, options);
      }
export type ExecutionLogsStreamSubscriptionHookResult = ReturnType<typeof useExecutionLogsStreamSubscription>;
export type ExecutionLogsStreamSubscriptionResult = Apollo.SubscriptionResult<ExecutionLogsStreamSubscription>;
export const ExecutionUpdatesDocument = gql`
    subscription ExecutionUpdates($executionId: ID!) {
  executionUpdates(executionId: $executionId) {
    type
    changeType
    timestamp
    execution {
      id
      externalId
      status
      outputs
      errorMessage
      startedAt
      completedAt
      signals {
        signalId
        type
        value
        hasValue
        schema
      }
    }
    nodeExecution {
      nodeId
      displayName
      phase
      startedAt
      updatedAt
      duration
      errorMessage
      metadata {
        specNodeId
        isParentNode
        isDynamic
        isArray
      }
      subworkflowExecutionInfo {
        isSubworkflow
        childNodeCount
        aggregateStatus
        childPhases {
          nodeId
          phase
        }
      }
      taskExecutions {
        retryAttempt
        phase
        startedAt
        duration
        errorMessage
      }
      workflowNodeMetadata {
        executionId {
          project
          domain
          name
        }
      }
    }
  }
}
    `;

/**
 * __useExecutionUpdatesSubscription__
 *
 * To run a query within a React component, call `useExecutionUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExecutionUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutionUpdatesSubscription({
 *   variables: {
 *      executionId: // value for 'executionId'
 *   },
 * });
 */
export function useExecutionUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ExecutionUpdatesSubscription, ExecutionUpdatesSubscriptionVariables> & ({ variables: ExecutionUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ExecutionUpdatesSubscription, ExecutionUpdatesSubscriptionVariables>(ExecutionUpdatesDocument, options);
      }
export type ExecutionUpdatesSubscriptionHookResult = ReturnType<typeof useExecutionUpdatesSubscription>;
export type ExecutionUpdatesSubscriptionResult = Apollo.SubscriptionResult<ExecutionUpdatesSubscription>;
export const HandoffExecutionEventsDocument = gql`
    subscription HandoffExecutionEvents($executionId: ID!) {
  handoffExecutionEvents(executionId: $executionId) {
    eventType
    data
    timestamp
    executionId
    taskId
  }
}
    `;

/**
 * __useHandoffExecutionEventsSubscription__
 *
 * To run a query within a React component, call `useHandoffExecutionEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHandoffExecutionEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandoffExecutionEventsSubscription({
 *   variables: {
 *      executionId: // value for 'executionId'
 *   },
 * });
 */
export function useHandoffExecutionEventsSubscription(baseOptions: Apollo.SubscriptionHookOptions<HandoffExecutionEventsSubscription, HandoffExecutionEventsSubscriptionVariables> & ({ variables: HandoffExecutionEventsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HandoffExecutionEventsSubscription, HandoffExecutionEventsSubscriptionVariables>(HandoffExecutionEventsDocument, options);
      }
export type HandoffExecutionEventsSubscriptionHookResult = ReturnType<typeof useHandoffExecutionEventsSubscription>;
export type HandoffExecutionEventsSubscriptionResult = Apollo.SubscriptionResult<HandoffExecutionEventsSubscription>;
export const ExecutionEventsStreamDocument = gql`
    subscription ExecutionEventsStream($executionId: ID!) {
  executionEventsStream(executionId: $executionId) {
    id
    occurredAt
    phase
    producerId
    message
    eventType
  }
}
    `;

/**
 * __useExecutionEventsStreamSubscription__
 *
 * To run a query within a React component, call `useExecutionEventsStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExecutionEventsStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutionEventsStreamSubscription({
 *   variables: {
 *      executionId: // value for 'executionId'
 *   },
 * });
 */
export function useExecutionEventsStreamSubscription(baseOptions: Apollo.SubscriptionHookOptions<ExecutionEventsStreamSubscription, ExecutionEventsStreamSubscriptionVariables> & ({ variables: ExecutionEventsStreamSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ExecutionEventsStreamSubscription, ExecutionEventsStreamSubscriptionVariables>(ExecutionEventsStreamDocument, options);
      }
export type ExecutionEventsStreamSubscriptionHookResult = ReturnType<typeof useExecutionEventsStreamSubscription>;
export type ExecutionEventsStreamSubscriptionResult = Apollo.SubscriptionResult<ExecutionEventsStreamSubscription>;
export const WorkflowToolsDocument = gql`
    query WorkflowTools($engine: String) {
  workflowTools(engine: $engine) {
    name
    description
    autoApprove
    parameters {
      type
      properties
      required
    }
    metadata {
      workflowId
      workflowName
      workflowVersion
      toolType
    }
  }
}
    `;

/**
 * __useWorkflowToolsQuery__
 *
 * To run a query within a React component, call `useWorkflowToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowToolsQuery({
 *   variables: {
 *      engine: // value for 'engine'
 *   },
 * });
 */
export function useWorkflowToolsQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowToolsQuery, WorkflowToolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowToolsQuery, WorkflowToolsQueryVariables>(WorkflowToolsDocument, options);
      }
export function useWorkflowToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowToolsQuery, WorkflowToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowToolsQuery, WorkflowToolsQueryVariables>(WorkflowToolsDocument, options);
        }
// @ts-ignore
export function useWorkflowToolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowToolsQuery, WorkflowToolsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowToolsQuery, WorkflowToolsQueryVariables>;
export function useWorkflowToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowToolsQuery, WorkflowToolsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowToolsQuery | undefined, WorkflowToolsQueryVariables>;
export function useWorkflowToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowToolsQuery, WorkflowToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowToolsQuery, WorkflowToolsQueryVariables>(WorkflowToolsDocument, options);
        }
export type WorkflowToolsQueryHookResult = ReturnType<typeof useWorkflowToolsQuery>;
export type WorkflowToolsLazyQueryHookResult = ReturnType<typeof useWorkflowToolsLazyQuery>;
export type WorkflowToolsSuspenseQueryHookResult = ReturnType<typeof useWorkflowToolsSuspenseQuery>;
export type WorkflowToolsQueryResult = Apollo.QueryResult<WorkflowToolsQuery, WorkflowToolsQueryVariables>;
export const ListMcpServersDocument = gql`
    query ListMcpServers {
  listMcpServers {
    templateId
    templateName
    templateDescription
    url
    enabled
    capabilities
    authRequired
    supportedAuthTypes
  }
}
    `;

/**
 * __useListMcpServersQuery__
 *
 * To run a query within a React component, call `useListMcpServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMcpServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMcpServersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMcpServersQuery(baseOptions?: Apollo.QueryHookOptions<ListMcpServersQuery, ListMcpServersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMcpServersQuery, ListMcpServersQueryVariables>(ListMcpServersDocument, options);
      }
export function useListMcpServersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMcpServersQuery, ListMcpServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMcpServersQuery, ListMcpServersQueryVariables>(ListMcpServersDocument, options);
        }
// @ts-ignore
export function useListMcpServersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMcpServersQuery, ListMcpServersQueryVariables>): Apollo.UseSuspenseQueryResult<ListMcpServersQuery, ListMcpServersQueryVariables>;
export function useListMcpServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMcpServersQuery, ListMcpServersQueryVariables>): Apollo.UseSuspenseQueryResult<ListMcpServersQuery | undefined, ListMcpServersQueryVariables>;
export function useListMcpServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMcpServersQuery, ListMcpServersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMcpServersQuery, ListMcpServersQueryVariables>(ListMcpServersDocument, options);
        }
export type ListMcpServersQueryHookResult = ReturnType<typeof useListMcpServersQuery>;
export type ListMcpServersLazyQueryHookResult = ReturnType<typeof useListMcpServersLazyQuery>;
export type ListMcpServersSuspenseQueryHookResult = ReturnType<typeof useListMcpServersSuspenseQuery>;
export type ListMcpServersQueryResult = Apollo.QueryResult<ListMcpServersQuery, ListMcpServersQueryVariables>;
export const ListMcpToolsDocument = gql`
    query ListMcpTools($templateId: String!) {
  listMcpTools(templateId: $templateId) {
    name
    description
    title
    inputSchema
  }
}
    `;

/**
 * __useListMcpToolsQuery__
 *
 * To run a query within a React component, call `useListMcpToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMcpToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMcpToolsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useListMcpToolsQuery(baseOptions: Apollo.QueryHookOptions<ListMcpToolsQuery, ListMcpToolsQueryVariables> & ({ variables: ListMcpToolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMcpToolsQuery, ListMcpToolsQueryVariables>(ListMcpToolsDocument, options);
      }
export function useListMcpToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMcpToolsQuery, ListMcpToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMcpToolsQuery, ListMcpToolsQueryVariables>(ListMcpToolsDocument, options);
        }
// @ts-ignore
export function useListMcpToolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMcpToolsQuery, ListMcpToolsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMcpToolsQuery, ListMcpToolsQueryVariables>;
export function useListMcpToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMcpToolsQuery, ListMcpToolsQueryVariables>): Apollo.UseSuspenseQueryResult<ListMcpToolsQuery | undefined, ListMcpToolsQueryVariables>;
export function useListMcpToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMcpToolsQuery, ListMcpToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMcpToolsQuery, ListMcpToolsQueryVariables>(ListMcpToolsDocument, options);
        }
export type ListMcpToolsQueryHookResult = ReturnType<typeof useListMcpToolsQuery>;
export type ListMcpToolsLazyQueryHookResult = ReturnType<typeof useListMcpToolsLazyQuery>;
export type ListMcpToolsSuspenseQueryHookResult = ReturnType<typeof useListMcpToolsSuspenseQuery>;
export type ListMcpToolsQueryResult = Apollo.QueryResult<ListMcpToolsQuery, ListMcpToolsQueryVariables>;
export const EnableMcpServerDocument = gql`
    mutation EnableMcpServer($input: EnableMcpServerInput!) {
  enableMcpServer(input: $input) {
    success
    message
    validationStatus
    validationMessage
    toolCount
  }
}
    `;
export type EnableMcpServerMutationFn = Apollo.MutationFunction<EnableMcpServerMutation, EnableMcpServerMutationVariables>;

/**
 * __useEnableMcpServerMutation__
 *
 * To run a mutation, you first call `useEnableMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMcpServerMutation, { data, loading, error }] = useEnableMcpServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableMcpServerMutation(baseOptions?: Apollo.MutationHookOptions<EnableMcpServerMutation, EnableMcpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableMcpServerMutation, EnableMcpServerMutationVariables>(EnableMcpServerDocument, options);
      }
export type EnableMcpServerMutationHookResult = ReturnType<typeof useEnableMcpServerMutation>;
export type EnableMcpServerMutationResult = Apollo.MutationResult<EnableMcpServerMutation>;
export type EnableMcpServerMutationOptions = Apollo.BaseMutationOptions<EnableMcpServerMutation, EnableMcpServerMutationVariables>;
export const UpdateMcpServerDocument = gql`
    mutation UpdateMcpServer($templateId: String!, $input: UpdateMcpServerInput!) {
  updateMcpServer(templateId: $templateId, input: $input) {
    success
    message
  }
}
    `;
export type UpdateMcpServerMutationFn = Apollo.MutationFunction<UpdateMcpServerMutation, UpdateMcpServerMutationVariables>;

/**
 * __useUpdateMcpServerMutation__
 *
 * To run a mutation, you first call `useUpdateMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcpServerMutation, { data, loading, error }] = useUpdateMcpServerMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMcpServerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMcpServerMutation, UpdateMcpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMcpServerMutation, UpdateMcpServerMutationVariables>(UpdateMcpServerDocument, options);
      }
export type UpdateMcpServerMutationHookResult = ReturnType<typeof useUpdateMcpServerMutation>;
export type UpdateMcpServerMutationResult = Apollo.MutationResult<UpdateMcpServerMutation>;
export type UpdateMcpServerMutationOptions = Apollo.BaseMutationOptions<UpdateMcpServerMutation, UpdateMcpServerMutationVariables>;
export const DisableMcpServerDocument = gql`
    mutation DisableMcpServer($templateId: String!) {
  disableMcpServer(templateId: $templateId) {
    success
    message
  }
}
    `;
export type DisableMcpServerMutationFn = Apollo.MutationFunction<DisableMcpServerMutation, DisableMcpServerMutationVariables>;

/**
 * __useDisableMcpServerMutation__
 *
 * To run a mutation, you first call `useDisableMcpServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMcpServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMcpServerMutation, { data, loading, error }] = useDisableMcpServerMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDisableMcpServerMutation(baseOptions?: Apollo.MutationHookOptions<DisableMcpServerMutation, DisableMcpServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableMcpServerMutation, DisableMcpServerMutationVariables>(DisableMcpServerDocument, options);
      }
export type DisableMcpServerMutationHookResult = ReturnType<typeof useDisableMcpServerMutation>;
export type DisableMcpServerMutationResult = Apollo.MutationResult<DisableMcpServerMutation>;
export type DisableMcpServerMutationOptions = Apollo.BaseMutationOptions<DisableMcpServerMutation, DisableMcpServerMutationVariables>;
export const GetCaseAlertsDocument = gql`
    query GetCaseAlerts($caseId: String!, $pageNumber: Int, $pageSize: Int, $groupName: String, $xDevoDomain: String) {
  getDevoCaseAlerts(
    caseId: $caseId
    pageNumber: $pageNumber
    pageSize: $pageSize
    groupName: $groupName
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetCaseAlertsQuery__
 *
 * To run a query within a React component, call `useGetCaseAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAlertsQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      groupName: // value for 'groupName'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseAlertsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables> & ({ variables: GetCaseAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>(GetCaseAlertsDocument, options);
      }
export function useGetCaseAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>(GetCaseAlertsDocument, options);
        }
// @ts-ignore
export function useGetCaseAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>;
export function useGetCaseAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsQuery | undefined, GetCaseAlertsQueryVariables>;
export function useGetCaseAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>(GetCaseAlertsDocument, options);
        }
export type GetCaseAlertsQueryHookResult = ReturnType<typeof useGetCaseAlertsQuery>;
export type GetCaseAlertsLazyQueryHookResult = ReturnType<typeof useGetCaseAlertsLazyQuery>;
export type GetCaseAlertsSuspenseQueryHookResult = ReturnType<typeof useGetCaseAlertsSuspenseQuery>;
export type GetCaseAlertsQueryResult = Apollo.QueryResult<GetCaseAlertsQuery, GetCaseAlertsQueryVariables>;
export const GetCaseAlertsGroupedDocument = gql`
    query GetCaseAlertsGrouped($caseId: String!, $pageNumber: Int, $pageSize: Int, $xDevoDomain: String) {
  getDevoCaseAlertsGrouped(
    caseId: $caseId
    pageNumber: $pageNumber
    pageSize: $pageSize
    xDevoDomain: $xDevoDomain
  ) {
    data
  }
}
    `;

/**
 * __useGetCaseAlertsGroupedQuery__
 *
 * To run a query within a React component, call `useGetCaseAlertsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAlertsGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAlertsGroupedQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      xDevoDomain: // value for 'xDevoDomain'
 *   },
 * });
 */
export function useGetCaseAlertsGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables> & ({ variables: GetCaseAlertsGroupedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>(GetCaseAlertsGroupedDocument, options);
      }
export function useGetCaseAlertsGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>(GetCaseAlertsGroupedDocument, options);
        }
// @ts-ignore
export function useGetCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>;
export function useGetCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAlertsGroupedQuery | undefined, GetCaseAlertsGroupedQueryVariables>;
export function useGetCaseAlertsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>(GetCaseAlertsGroupedDocument, options);
        }
export type GetCaseAlertsGroupedQueryHookResult = ReturnType<typeof useGetCaseAlertsGroupedQuery>;
export type GetCaseAlertsGroupedLazyQueryHookResult = ReturnType<typeof useGetCaseAlertsGroupedLazyQuery>;
export type GetCaseAlertsGroupedSuspenseQueryHookResult = ReturnType<typeof useGetCaseAlertsGroupedSuspenseQuery>;
export type GetCaseAlertsGroupedQueryResult = Apollo.QueryResult<GetCaseAlertsGroupedQuery, GetCaseAlertsGroupedQueryVariables>;
export const ListWebhookEndpointsDocument = gql`
    query ListWebhookEndpoints($webhookType: String) {
  listWebhookEndpoints(webhookType: $webhookType) {
    id
    name
    description
    webhookType
    webhookGuid
    status
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useListWebhookEndpointsQuery__
 *
 * To run a query within a React component, call `useListWebhookEndpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebhookEndpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebhookEndpointsQuery({
 *   variables: {
 *      webhookType: // value for 'webhookType'
 *   },
 * });
 */
export function useListWebhookEndpointsQuery(baseOptions?: Apollo.QueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(ListWebhookEndpointsDocument, options);
      }
export function useListWebhookEndpointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(ListWebhookEndpointsDocument, options);
        }
// @ts-ignore
export function useListWebhookEndpointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>): Apollo.UseSuspenseQueryResult<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>;
export function useListWebhookEndpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>): Apollo.UseSuspenseQueryResult<ListWebhookEndpointsQuery | undefined, ListWebhookEndpointsQueryVariables>;
export function useListWebhookEndpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(ListWebhookEndpointsDocument, options);
        }
export type ListWebhookEndpointsQueryHookResult = ReturnType<typeof useListWebhookEndpointsQuery>;
export type ListWebhookEndpointsLazyQueryHookResult = ReturnType<typeof useListWebhookEndpointsLazyQuery>;
export type ListWebhookEndpointsSuspenseQueryHookResult = ReturnType<typeof useListWebhookEndpointsSuspenseQuery>;
export type ListWebhookEndpointsQueryResult = Apollo.QueryResult<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>;
export const GetWebhookEndpointDocument = gql`
    query GetWebhookEndpoint($id: ID!) {
  webhookEndpoint(id: $id) {
    id
    name
    description
    webhookType
    webhookGuid
    status
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetWebhookEndpointQuery__
 *
 * To run a query within a React component, call `useGetWebhookEndpointQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookEndpointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookEndpointQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWebhookEndpointQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables> & ({ variables: GetWebhookEndpointQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>(GetWebhookEndpointDocument, options);
      }
export function useGetWebhookEndpointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>(GetWebhookEndpointDocument, options);
        }
// @ts-ignore
export function useGetWebhookEndpointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>;
export function useGetWebhookEndpointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebhookEndpointQuery | undefined, GetWebhookEndpointQueryVariables>;
export function useGetWebhookEndpointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>(GetWebhookEndpointDocument, options);
        }
export type GetWebhookEndpointQueryHookResult = ReturnType<typeof useGetWebhookEndpointQuery>;
export type GetWebhookEndpointLazyQueryHookResult = ReturnType<typeof useGetWebhookEndpointLazyQuery>;
export type GetWebhookEndpointSuspenseQueryHookResult = ReturnType<typeof useGetWebhookEndpointSuspenseQuery>;
export type GetWebhookEndpointQueryResult = Apollo.QueryResult<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>;
export const CreateWebhookEndpointDocument = gql`
    mutation CreateWebhookEndpoint($input: CreateWebhookEndpointInput!) {
  createWebhookEndpoint(input: $input) {
    webhookEndpoint {
      id
      name
      description
      webhookType
      webhookGuid
      status
    }
  }
}
    `;
export type CreateWebhookEndpointMutationFn = Apollo.MutationFunction<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>;

/**
 * __useCreateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useCreateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookEndpointMutation, { data, loading, error }] = useCreateWebhookEndpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>(CreateWebhookEndpointDocument, options);
      }
export type CreateWebhookEndpointMutationHookResult = ReturnType<typeof useCreateWebhookEndpointMutation>;
export type CreateWebhookEndpointMutationResult = Apollo.MutationResult<CreateWebhookEndpointMutation>;
export type CreateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>;
export const GetTriggerExecutionsDocument = gql`
    query GetTriggerExecutions($triggerId: ID!, $limit: Int) {
  node(id: $triggerId) {
    ... on Trigger {
      id
      name
      triggerType
      targets {
        id
        targetType
        targetId
        workflow {
          id
          name
          version
        }
        job {
          id
          name
        }
      }
      executions(limit: $limit) {
        id
        status
        triggeredAt
        startedAt
        completedAt
        triggerEvent
        targetResults
        errorMessage
        durationMs
        insertedAt
      }
    }
  }
}
    `;

/**
 * __useGetTriggerExecutionsQuery__
 *
 * To run a query within a React component, call `useGetTriggerExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerExecutionsQuery({
 *   variables: {
 *      triggerId: // value for 'triggerId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTriggerExecutionsQuery(baseOptions: Apollo.QueryHookOptions<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables> & ({ variables: GetTriggerExecutionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>(GetTriggerExecutionsDocument, options);
      }
export function useGetTriggerExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>(GetTriggerExecutionsDocument, options);
        }
// @ts-ignore
export function useGetTriggerExecutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>;
export function useGetTriggerExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerExecutionsQuery | undefined, GetTriggerExecutionsQueryVariables>;
export function useGetTriggerExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>(GetTriggerExecutionsDocument, options);
        }
export type GetTriggerExecutionsQueryHookResult = ReturnType<typeof useGetTriggerExecutionsQuery>;
export type GetTriggerExecutionsLazyQueryHookResult = ReturnType<typeof useGetTriggerExecutionsLazyQuery>;
export type GetTriggerExecutionsSuspenseQueryHookResult = ReturnType<typeof useGetTriggerExecutionsSuspenseQuery>;
export type GetTriggerExecutionsQueryResult = Apollo.QueryResult<GetTriggerExecutionsQuery, GetTriggerExecutionsQueryVariables>;
export const TestTriggerDocument = gql`
    mutation TestTrigger($id: ID!, $payload: Json) {
  testTrigger(id: $id, payload: $payload) {
    trigger {
      id
      name
    }
    execution {
      id
      status
      triggeredAt
      triggerEvent
      targetResults
      durationMs
      errorMessage
    }
  }
}
    `;
export type TestTriggerMutationFn = Apollo.MutationFunction<TestTriggerMutation, TestTriggerMutationVariables>;

/**
 * __useTestTriggerMutation__
 *
 * To run a mutation, you first call `useTestTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testTriggerMutation, { data, loading, error }] = useTestTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useTestTriggerMutation(baseOptions?: Apollo.MutationHookOptions<TestTriggerMutation, TestTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestTriggerMutation, TestTriggerMutationVariables>(TestTriggerDocument, options);
      }
export type TestTriggerMutationHookResult = ReturnType<typeof useTestTriggerMutation>;
export type TestTriggerMutationResult = Apollo.MutationResult<TestTriggerMutation>;
export type TestTriggerMutationOptions = Apollo.BaseMutationOptions<TestTriggerMutation, TestTriggerMutationVariables>;
export const UpdateTriggerTargetDocument = gql`
    mutation UpdateTriggerTarget($id: ID!, $input: UpdateTriggerTargetInput!) {
  updateTriggerTarget(id: $id, input: $input) {
    target {
      id
      inputMapping
    }
  }
}
    `;
export type UpdateTriggerTargetMutationFn = Apollo.MutationFunction<UpdateTriggerTargetMutation, UpdateTriggerTargetMutationVariables>;

/**
 * __useUpdateTriggerTargetMutation__
 *
 * To run a mutation, you first call `useUpdateTriggerTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriggerTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriggerTargetMutation, { data, loading, error }] = useUpdateTriggerTargetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriggerTargetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTriggerTargetMutation, UpdateTriggerTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTriggerTargetMutation, UpdateTriggerTargetMutationVariables>(UpdateTriggerTargetDocument, options);
      }
export type UpdateTriggerTargetMutationHookResult = ReturnType<typeof useUpdateTriggerTargetMutation>;
export type UpdateTriggerTargetMutationResult = Apollo.MutationResult<UpdateTriggerTargetMutation>;
export type UpdateTriggerTargetMutationOptions = Apollo.BaseMutationOptions<UpdateTriggerTargetMutation, UpdateTriggerTargetMutationVariables>;
export const ListTriggersForTargetDocument = gql`
    query ListTriggersForTarget($targetType: TriggerTargetType!, $targetId: ID!) {
  triggersForTarget(targetType: $targetType, targetId: $targetId) {
    id
    name
    triggerType
    enabled
    cronExpression
    timezone
    webhookEndpoint {
      id
      name
    }
    targets {
      id
      targetType
      targetId
      inputMapping
    }
  }
}
    `;

/**
 * __useListTriggersForTargetQuery__
 *
 * To run a query within a React component, call `useListTriggersForTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTriggersForTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTriggersForTargetQuery({
 *   variables: {
 *      targetType: // value for 'targetType'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useListTriggersForTargetQuery(baseOptions: Apollo.QueryHookOptions<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables> & ({ variables: ListTriggersForTargetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>(ListTriggersForTargetDocument, options);
      }
export function useListTriggersForTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>(ListTriggersForTargetDocument, options);
        }
// @ts-ignore
export function useListTriggersForTargetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>): Apollo.UseSuspenseQueryResult<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>;
export function useListTriggersForTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>): Apollo.UseSuspenseQueryResult<ListTriggersForTargetQuery | undefined, ListTriggersForTargetQueryVariables>;
export function useListTriggersForTargetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>(ListTriggersForTargetDocument, options);
        }
export type ListTriggersForTargetQueryHookResult = ReturnType<typeof useListTriggersForTargetQuery>;
export type ListTriggersForTargetLazyQueryHookResult = ReturnType<typeof useListTriggersForTargetLazyQuery>;
export type ListTriggersForTargetSuspenseQueryHookResult = ReturnType<typeof useListTriggersForTargetSuspenseQuery>;
export type ListTriggersForTargetQueryResult = Apollo.QueryResult<ListTriggersForTargetQuery, ListTriggersForTargetQueryVariables>;
export const ListTriggersDocument = gql`
    query ListTriggers($first: Int) {
  listTriggers(first: $first) {
    edges {
      node {
        id
        name
        description
        triggerType
        enabled
        cronExpression
        timezone
        payload
        webhookEndpointId
        webhookEndpoint {
          id
          name
          webhookGuid
          status
        }
        targets {
          id
          targetType
          targetId
          enabled
          priority
          inputMapping
        }
        insertedAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useListTriggersQuery__
 *
 * To run a query within a React component, call `useListTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTriggersQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListTriggersQuery(baseOptions?: Apollo.QueryHookOptions<ListTriggersQuery, ListTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTriggersQuery, ListTriggersQueryVariables>(ListTriggersDocument, options);
      }
export function useListTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTriggersQuery, ListTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTriggersQuery, ListTriggersQueryVariables>(ListTriggersDocument, options);
        }
// @ts-ignore
export function useListTriggersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTriggersQuery, ListTriggersQueryVariables>): Apollo.UseSuspenseQueryResult<ListTriggersQuery, ListTriggersQueryVariables>;
export function useListTriggersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTriggersQuery, ListTriggersQueryVariables>): Apollo.UseSuspenseQueryResult<ListTriggersQuery | undefined, ListTriggersQueryVariables>;
export function useListTriggersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTriggersQuery, ListTriggersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTriggersQuery, ListTriggersQueryVariables>(ListTriggersDocument, options);
        }
export type ListTriggersQueryHookResult = ReturnType<typeof useListTriggersQuery>;
export type ListTriggersLazyQueryHookResult = ReturnType<typeof useListTriggersLazyQuery>;
export type ListTriggersSuspenseQueryHookResult = ReturnType<typeof useListTriggersSuspenseQuery>;
export type ListTriggersQueryResult = Apollo.QueryResult<ListTriggersQuery, ListTriggersQueryVariables>;
export const ListWorkflowsForTriggerDocument = gql`
    query ListWorkflowsForTrigger($first: Int) {
  workflows(first: $first, filter: {status: PUBLISHED}) {
    edges {
      node {
        id
        name
        status
        inputSchema
      }
    }
  }
}
    `;

/**
 * __useListWorkflowsForTriggerQuery__
 *
 * To run a query within a React component, call `useListWorkflowsForTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkflowsForTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkflowsForTriggerQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListWorkflowsForTriggerQuery(baseOptions?: Apollo.QueryHookOptions<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>(ListWorkflowsForTriggerDocument, options);
      }
export function useListWorkflowsForTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>(ListWorkflowsForTriggerDocument, options);
        }
// @ts-ignore
export function useListWorkflowsForTriggerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>;
export function useListWorkflowsForTriggerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>): Apollo.UseSuspenseQueryResult<ListWorkflowsForTriggerQuery | undefined, ListWorkflowsForTriggerQueryVariables>;
export function useListWorkflowsForTriggerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>(ListWorkflowsForTriggerDocument, options);
        }
export type ListWorkflowsForTriggerQueryHookResult = ReturnType<typeof useListWorkflowsForTriggerQuery>;
export type ListWorkflowsForTriggerLazyQueryHookResult = ReturnType<typeof useListWorkflowsForTriggerLazyQuery>;
export type ListWorkflowsForTriggerSuspenseQueryHookResult = ReturnType<typeof useListWorkflowsForTriggerSuspenseQuery>;
export type ListWorkflowsForTriggerQueryResult = Apollo.QueryResult<ListWorkflowsForTriggerQuery, ListWorkflowsForTriggerQueryVariables>;
export const ListJobsForTriggerDocument = gql`
    query ListJobsForTrigger($first: Int) {
  listJobConfigs(first: $first) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListJobsForTriggerQuery__
 *
 * To run a query within a React component, call `useListJobsForTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobsForTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobsForTriggerQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListJobsForTriggerQuery(baseOptions?: Apollo.QueryHookOptions<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>(ListJobsForTriggerDocument, options);
      }
export function useListJobsForTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>(ListJobsForTriggerDocument, options);
        }
// @ts-ignore
export function useListJobsForTriggerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>;
export function useListJobsForTriggerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>): Apollo.UseSuspenseQueryResult<ListJobsForTriggerQuery | undefined, ListJobsForTriggerQueryVariables>;
export function useListJobsForTriggerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>(ListJobsForTriggerDocument, options);
        }
export type ListJobsForTriggerQueryHookResult = ReturnType<typeof useListJobsForTriggerQuery>;
export type ListJobsForTriggerLazyQueryHookResult = ReturnType<typeof useListJobsForTriggerLazyQuery>;
export type ListJobsForTriggerSuspenseQueryHookResult = ReturnType<typeof useListJobsForTriggerSuspenseQuery>;
export type ListJobsForTriggerQueryResult = Apollo.QueryResult<ListJobsForTriggerQuery, ListJobsForTriggerQueryVariables>;
export const CreateTriggerDocument = gql`
    mutation CreateTrigger($input: CreateTriggerInput!) {
  createTrigger(input: $input) {
    trigger {
      id
      name
      triggerType
      enabled
      cronExpression
      timezone
    }
  }
}
    `;
export type CreateTriggerMutationFn = Apollo.MutationFunction<CreateTriggerMutation, CreateTriggerMutationVariables>;

/**
 * __useCreateTriggerMutation__
 *
 * To run a mutation, you first call `useCreateTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTriggerMutation, { data, loading, error }] = useCreateTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CreateTriggerMutation, CreateTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTriggerMutation, CreateTriggerMutationVariables>(CreateTriggerDocument, options);
      }
export type CreateTriggerMutationHookResult = ReturnType<typeof useCreateTriggerMutation>;
export type CreateTriggerMutationResult = Apollo.MutationResult<CreateTriggerMutation>;
export type CreateTriggerMutationOptions = Apollo.BaseMutationOptions<CreateTriggerMutation, CreateTriggerMutationVariables>;
export const UpdateTriggerDocument = gql`
    mutation UpdateTrigger($id: ID!, $input: UpdateTriggerInput!) {
  updateTrigger(id: $id, input: $input) {
    trigger {
      id
      name
      triggerType
      enabled
      cronExpression
      timezone
    }
  }
}
    `;
export type UpdateTriggerMutationFn = Apollo.MutationFunction<UpdateTriggerMutation, UpdateTriggerMutationVariables>;

/**
 * __useUpdateTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriggerMutation, { data, loading, error }] = useUpdateTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriggerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTriggerMutation, UpdateTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTriggerMutation, UpdateTriggerMutationVariables>(UpdateTriggerDocument, options);
      }
export type UpdateTriggerMutationHookResult = ReturnType<typeof useUpdateTriggerMutation>;
export type UpdateTriggerMutationResult = Apollo.MutationResult<UpdateTriggerMutation>;
export type UpdateTriggerMutationOptions = Apollo.BaseMutationOptions<UpdateTriggerMutation, UpdateTriggerMutationVariables>;
export const DeleteTriggerDocument = gql`
    mutation DeleteTrigger($id: ID!) {
  deleteTrigger(id: $id) {
    success
    trigger {
      id
    }
  }
}
    `;
export type DeleteTriggerMutationFn = Apollo.MutationFunction<DeleteTriggerMutation, DeleteTriggerMutationVariables>;

/**
 * __useDeleteTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTriggerMutation, { data, loading, error }] = useDeleteTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTriggerMutation, DeleteTriggerMutationVariables>(DeleteTriggerDocument, options);
      }
export type DeleteTriggerMutationHookResult = ReturnType<typeof useDeleteTriggerMutation>;
export type DeleteTriggerMutationResult = Apollo.MutationResult<DeleteTriggerMutation>;
export type DeleteTriggerMutationOptions = Apollo.BaseMutationOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>;
export const EnableTriggerDocument = gql`
    mutation EnableTrigger($id: ID!) {
  enableTrigger(id: $id) {
    trigger {
      id
      enabled
    }
  }
}
    `;
export type EnableTriggerMutationFn = Apollo.MutationFunction<EnableTriggerMutation, EnableTriggerMutationVariables>;

/**
 * __useEnableTriggerMutation__
 *
 * To run a mutation, you first call `useEnableTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTriggerMutation, { data, loading, error }] = useEnableTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableTriggerMutation(baseOptions?: Apollo.MutationHookOptions<EnableTriggerMutation, EnableTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableTriggerMutation, EnableTriggerMutationVariables>(EnableTriggerDocument, options);
      }
export type EnableTriggerMutationHookResult = ReturnType<typeof useEnableTriggerMutation>;
export type EnableTriggerMutationResult = Apollo.MutationResult<EnableTriggerMutation>;
export type EnableTriggerMutationOptions = Apollo.BaseMutationOptions<EnableTriggerMutation, EnableTriggerMutationVariables>;
export const DisableTriggerDocument = gql`
    mutation DisableTrigger($id: ID!) {
  disableTrigger(id: $id) {
    trigger {
      id
      enabled
    }
  }
}
    `;
export type DisableTriggerMutationFn = Apollo.MutationFunction<DisableTriggerMutation, DisableTriggerMutationVariables>;

/**
 * __useDisableTriggerMutation__
 *
 * To run a mutation, you first call `useDisableTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTriggerMutation, { data, loading, error }] = useDisableTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DisableTriggerMutation, DisableTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTriggerMutation, DisableTriggerMutationVariables>(DisableTriggerDocument, options);
      }
export type DisableTriggerMutationHookResult = ReturnType<typeof useDisableTriggerMutation>;
export type DisableTriggerMutationResult = Apollo.MutationResult<DisableTriggerMutation>;
export type DisableTriggerMutationOptions = Apollo.BaseMutationOptions<DisableTriggerMutation, DisableTriggerMutationVariables>;
export const AddTriggerTargetDocument = gql`
    mutation AddTriggerTarget($triggerId: ID!, $input: AddTriggerTargetInput!) {
  addTriggerTarget(triggerId: $triggerId, input: $input) {
    target {
      id
      targetType
      targetId
      enabled
      priority
    }
  }
}
    `;
export type AddTriggerTargetMutationFn = Apollo.MutationFunction<AddTriggerTargetMutation, AddTriggerTargetMutationVariables>;

/**
 * __useAddTriggerTargetMutation__
 *
 * To run a mutation, you first call `useAddTriggerTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTriggerTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTriggerTargetMutation, { data, loading, error }] = useAddTriggerTargetMutation({
 *   variables: {
 *      triggerId: // value for 'triggerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTriggerTargetMutation(baseOptions?: Apollo.MutationHookOptions<AddTriggerTargetMutation, AddTriggerTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTriggerTargetMutation, AddTriggerTargetMutationVariables>(AddTriggerTargetDocument, options);
      }
export type AddTriggerTargetMutationHookResult = ReturnType<typeof useAddTriggerTargetMutation>;
export type AddTriggerTargetMutationResult = Apollo.MutationResult<AddTriggerTargetMutation>;
export type AddTriggerTargetMutationOptions = Apollo.BaseMutationOptions<AddTriggerTargetMutation, AddTriggerTargetMutationVariables>;
export const RemoveTriggerTargetDocument = gql`
    mutation RemoveTriggerTarget($id: ID!) {
  removeTriggerTarget(id: $id) {
    target {
      id
    }
    success
  }
}
    `;
export type RemoveTriggerTargetMutationFn = Apollo.MutationFunction<RemoveTriggerTargetMutation, RemoveTriggerTargetMutationVariables>;

/**
 * __useRemoveTriggerTargetMutation__
 *
 * To run a mutation, you first call `useRemoveTriggerTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTriggerTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTriggerTargetMutation, { data, loading, error }] = useRemoveTriggerTargetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTriggerTargetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTriggerTargetMutation, RemoveTriggerTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTriggerTargetMutation, RemoveTriggerTargetMutationVariables>(RemoveTriggerTargetDocument, options);
      }
export type RemoveTriggerTargetMutationHookResult = ReturnType<typeof useRemoveTriggerTargetMutation>;
export type RemoveTriggerTargetMutationResult = Apollo.MutationResult<RemoveTriggerTargetMutation>;
export type RemoveTriggerTargetMutationOptions = Apollo.BaseMutationOptions<RemoveTriggerTargetMutation, RemoveTriggerTargetMutationVariables>;
export const TeamMembersDocument = gql`
    query TeamMembers {
  teamMembers {
    id
    name
    email
    role
  }
}
    `;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
// @ts-ignore
export function useTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>): Apollo.UseSuspenseQueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>): Apollo.UseSuspenseQueryResult<TeamMembersQuery | undefined, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersSuspenseQuery>;
export type TeamMembersQueryResult = Apollo.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($id: ID!, $role: UserRole!) {
  updateUserRole(id: $id, role: $role) {
    id
    name
    email
    role
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const GetTokenUsageStatsDocument = gql`
    query GetTokenUsageStats {
  tokenUsageStats {
    daily {
      usage
      limit
      percentage
      warningThreshold
      status
    }
    weekly {
      usage
      limit
      percentage
      warningThreshold
      status
    }
    monthly {
      usage
      limit
      percentage
      warningThreshold
      status
    }
    isLimited
    userDate
  }
}
    `;

/**
 * __useGetTokenUsageStatsQuery__
 *
 * To run a query within a React component, call `useGetTokenUsageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenUsageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenUsageStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTokenUsageStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>(GetTokenUsageStatsDocument, options);
      }
export function useGetTokenUsageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>(GetTokenUsageStatsDocument, options);
        }
// @ts-ignore
export function useGetTokenUsageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>;
export function useGetTokenUsageStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTokenUsageStatsQuery | undefined, GetTokenUsageStatsQueryVariables>;
export function useGetTokenUsageStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>(GetTokenUsageStatsDocument, options);
        }
export type GetTokenUsageStatsQueryHookResult = ReturnType<typeof useGetTokenUsageStatsQuery>;
export type GetTokenUsageStatsLazyQueryHookResult = ReturnType<typeof useGetTokenUsageStatsLazyQuery>;
export type GetTokenUsageStatsSuspenseQueryHookResult = ReturnType<typeof useGetTokenUsageStatsSuspenseQuery>;
export type GetTokenUsageStatsQueryResult = Apollo.QueryResult<GetTokenUsageStatsQuery, GetTokenUsageStatsQueryVariables>;
export const GetTenantUsageStatsDocument = gql`
    query GetTenantUsageStats {
  tenantUsageStats {
    daily {
      usage
      limit
      enforced
    }
    weekly {
      usage
      limit
      enforced
    }
    monthly {
      usage
      limit
      enforced
    }
  }
}
    `;

/**
 * __useGetTenantUsageStatsQuery__
 *
 * To run a query within a React component, call `useGetTenantUsageStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantUsageStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantUsageStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantUsageStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>(GetTenantUsageStatsDocument, options);
      }
export function useGetTenantUsageStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>(GetTenantUsageStatsDocument, options);
        }
// @ts-ignore
export function useGetTenantUsageStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>;
export function useGetTenantUsageStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantUsageStatsQuery | undefined, GetTenantUsageStatsQueryVariables>;
export function useGetTenantUsageStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>(GetTenantUsageStatsDocument, options);
        }
export type GetTenantUsageStatsQueryHookResult = ReturnType<typeof useGetTenantUsageStatsQuery>;
export type GetTenantUsageStatsLazyQueryHookResult = ReturnType<typeof useGetTenantUsageStatsLazyQuery>;
export type GetTenantUsageStatsSuspenseQueryHookResult = ReturnType<typeof useGetTenantUsageStatsSuspenseQuery>;
export type GetTenantUsageStatsQueryResult = Apollo.QueryResult<GetTenantUsageStatsQuery, GetTenantUsageStatsQueryVariables>;
export const DeleteMyWorkspaceDocument = gql`
    mutation DeleteMyWorkspace {
  deleteMyWorkspace {
    success
    message
  }
}
    `;
export type DeleteMyWorkspaceMutationFn = Apollo.MutationFunction<DeleteMyWorkspaceMutation, DeleteMyWorkspaceMutationVariables>;

/**
 * __useDeleteMyWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteMyWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyWorkspaceMutation, { data, loading, error }] = useDeleteMyWorkspaceMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMyWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMyWorkspaceMutation, DeleteMyWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMyWorkspaceMutation, DeleteMyWorkspaceMutationVariables>(DeleteMyWorkspaceDocument, options);
      }
export type DeleteMyWorkspaceMutationHookResult = ReturnType<typeof useDeleteMyWorkspaceMutation>;
export type DeleteMyWorkspaceMutationResult = Apollo.MutationResult<DeleteMyWorkspaceMutation>;
export type DeleteMyWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteMyWorkspaceMutation, DeleteMyWorkspaceMutationVariables>;
export const McpCatalogServersDocument = gql`
    query McpCatalogServers($filter: McpCatalogFilterInput) {
  mcpCatalogServers(filter: $filter) {
    id
    slug
    name
    description
    url
    category
    vendor
    authRequired
    supportedAuthTypes
    capabilities
    metadata
    publishedAt
    deprecatedAt
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useMcpCatalogServersQuery__
 *
 * To run a query within a React component, call `useMcpCatalogServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpCatalogServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpCatalogServersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMcpCatalogServersQuery(baseOptions?: Apollo.QueryHookOptions<McpCatalogServersQuery, McpCatalogServersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpCatalogServersQuery, McpCatalogServersQueryVariables>(McpCatalogServersDocument, options);
      }
export function useMcpCatalogServersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpCatalogServersQuery, McpCatalogServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpCatalogServersQuery, McpCatalogServersQueryVariables>(McpCatalogServersDocument, options);
        }
// @ts-ignore
export function useMcpCatalogServersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McpCatalogServersQuery, McpCatalogServersQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogServersQuery, McpCatalogServersQueryVariables>;
export function useMcpCatalogServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogServersQuery, McpCatalogServersQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogServersQuery | undefined, McpCatalogServersQueryVariables>;
export function useMcpCatalogServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogServersQuery, McpCatalogServersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McpCatalogServersQuery, McpCatalogServersQueryVariables>(McpCatalogServersDocument, options);
        }
export type McpCatalogServersQueryHookResult = ReturnType<typeof useMcpCatalogServersQuery>;
export type McpCatalogServersLazyQueryHookResult = ReturnType<typeof useMcpCatalogServersLazyQuery>;
export type McpCatalogServersSuspenseQueryHookResult = ReturnType<typeof useMcpCatalogServersSuspenseQuery>;
export type McpCatalogServersQueryResult = Apollo.QueryResult<McpCatalogServersQuery, McpCatalogServersQueryVariables>;
export const McpCatalogServerDocument = gql`
    query McpCatalogServer($idOrSlug: String!) {
  mcpCatalogServer(idOrSlug: $idOrSlug) {
    id
    slug
    name
    description
    url
    category
    vendor
    authRequired
    supportedAuthTypes
    capabilities
    metadata
    publishedAt
    deprecatedAt
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useMcpCatalogServerQuery__
 *
 * To run a query within a React component, call `useMcpCatalogServerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpCatalogServerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpCatalogServerQuery({
 *   variables: {
 *      idOrSlug: // value for 'idOrSlug'
 *   },
 * });
 */
export function useMcpCatalogServerQuery(baseOptions: Apollo.QueryHookOptions<McpCatalogServerQuery, McpCatalogServerQueryVariables> & ({ variables: McpCatalogServerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpCatalogServerQuery, McpCatalogServerQueryVariables>(McpCatalogServerDocument, options);
      }
export function useMcpCatalogServerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpCatalogServerQuery, McpCatalogServerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpCatalogServerQuery, McpCatalogServerQueryVariables>(McpCatalogServerDocument, options);
        }
// @ts-ignore
export function useMcpCatalogServerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McpCatalogServerQuery, McpCatalogServerQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogServerQuery, McpCatalogServerQueryVariables>;
export function useMcpCatalogServerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogServerQuery, McpCatalogServerQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogServerQuery | undefined, McpCatalogServerQueryVariables>;
export function useMcpCatalogServerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogServerQuery, McpCatalogServerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McpCatalogServerQuery, McpCatalogServerQueryVariables>(McpCatalogServerDocument, options);
        }
export type McpCatalogServerQueryHookResult = ReturnType<typeof useMcpCatalogServerQuery>;
export type McpCatalogServerLazyQueryHookResult = ReturnType<typeof useMcpCatalogServerLazyQuery>;
export type McpCatalogServerSuspenseQueryHookResult = ReturnType<typeof useMcpCatalogServerSuspenseQuery>;
export type McpCatalogServerQueryResult = Apollo.QueryResult<McpCatalogServerQuery, McpCatalogServerQueryVariables>;
export const McpCatalogInstancesDocument = gql`
    query McpCatalogInstances($filter: McpInstanceFilterInput) {
  mcpCatalogInstances(filter: $filter) {
    id
    tenantId
    serverId
    enabled
    url
    consentMode
    timeout
    installedAt
    installedById
    metadata
    toolConfigs
    insertedAt
    updatedAt
    server {
      id
      slug
      name
      description
      category
      vendor
      authRequired
      capabilities
    }
  }
}
    `;

/**
 * __useMcpCatalogInstancesQuery__
 *
 * To run a query within a React component, call `useMcpCatalogInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpCatalogInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpCatalogInstancesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMcpCatalogInstancesQuery(baseOptions?: Apollo.QueryHookOptions<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>(McpCatalogInstancesDocument, options);
      }
export function useMcpCatalogInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>(McpCatalogInstancesDocument, options);
        }
// @ts-ignore
export function useMcpCatalogInstancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>;
export function useMcpCatalogInstancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogInstancesQuery | undefined, McpCatalogInstancesQueryVariables>;
export function useMcpCatalogInstancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>(McpCatalogInstancesDocument, options);
        }
export type McpCatalogInstancesQueryHookResult = ReturnType<typeof useMcpCatalogInstancesQuery>;
export type McpCatalogInstancesLazyQueryHookResult = ReturnType<typeof useMcpCatalogInstancesLazyQuery>;
export type McpCatalogInstancesSuspenseQueryHookResult = ReturnType<typeof useMcpCatalogInstancesSuspenseQuery>;
export type McpCatalogInstancesQueryResult = Apollo.QueryResult<McpCatalogInstancesQuery, McpCatalogInstancesQueryVariables>;
export const McpCatalogInstanceDocument = gql`
    query McpCatalogInstance($id: ID!) {
  mcpCatalogInstance(id: $id) {
    id
    tenantId
    serverId
    enabled
    url
    consentMode
    timeout
    installedAt
    installedById
    metadata
    insertedAt
    updatedAt
    server {
      id
      slug
      name
      description
      category
      vendor
      authRequired
      capabilities
    }
  }
}
    `;

/**
 * __useMcpCatalogInstanceQuery__
 *
 * To run a query within a React component, call `useMcpCatalogInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpCatalogInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpCatalogInstanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMcpCatalogInstanceQuery(baseOptions: Apollo.QueryHookOptions<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables> & ({ variables: McpCatalogInstanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>(McpCatalogInstanceDocument, options);
      }
export function useMcpCatalogInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>(McpCatalogInstanceDocument, options);
        }
// @ts-ignore
export function useMcpCatalogInstanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>;
export function useMcpCatalogInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogInstanceQuery | undefined, McpCatalogInstanceQueryVariables>;
export function useMcpCatalogInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>(McpCatalogInstanceDocument, options);
        }
export type McpCatalogInstanceQueryHookResult = ReturnType<typeof useMcpCatalogInstanceQuery>;
export type McpCatalogInstanceLazyQueryHookResult = ReturnType<typeof useMcpCatalogInstanceLazyQuery>;
export type McpCatalogInstanceSuspenseQueryHookResult = ReturnType<typeof useMcpCatalogInstanceSuspenseQuery>;
export type McpCatalogInstanceQueryResult = Apollo.QueryResult<McpCatalogInstanceQuery, McpCatalogInstanceQueryVariables>;
export const AgentToolsDocument = gql`
    query AgentTools($agentId: ID!) {
  agentTools(agentId: $agentId)
}
    `;

/**
 * __useAgentToolsQuery__
 *
 * To run a query within a React component, call `useAgentToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentToolsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useAgentToolsQuery(baseOptions: Apollo.QueryHookOptions<AgentToolsQuery, AgentToolsQueryVariables> & ({ variables: AgentToolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentToolsQuery, AgentToolsQueryVariables>(AgentToolsDocument, options);
      }
export function useAgentToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentToolsQuery, AgentToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentToolsQuery, AgentToolsQueryVariables>(AgentToolsDocument, options);
        }
// @ts-ignore
export function useAgentToolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentToolsQuery, AgentToolsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentToolsQuery, AgentToolsQueryVariables>;
export function useAgentToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentToolsQuery, AgentToolsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentToolsQuery | undefined, AgentToolsQueryVariables>;
export function useAgentToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentToolsQuery, AgentToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentToolsQuery, AgentToolsQueryVariables>(AgentToolsDocument, options);
        }
export type AgentToolsQueryHookResult = ReturnType<typeof useAgentToolsQuery>;
export type AgentToolsLazyQueryHookResult = ReturnType<typeof useAgentToolsLazyQuery>;
export type AgentToolsSuspenseQueryHookResult = ReturnType<typeof useAgentToolsSuspenseQuery>;
export type AgentToolsQueryResult = Apollo.QueryResult<AgentToolsQuery, AgentToolsQueryVariables>;
export const SystemToolsCatalogDocument = gql`
    query SystemToolsCatalog {
  systemToolsCatalog
}
    `;

/**
 * __useSystemToolsCatalogQuery__
 *
 * To run a query within a React component, call `useSystemToolsCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemToolsCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemToolsCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemToolsCatalogQuery(baseOptions?: Apollo.QueryHookOptions<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>(SystemToolsCatalogDocument, options);
      }
export function useSystemToolsCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>(SystemToolsCatalogDocument, options);
        }
// @ts-ignore
export function useSystemToolsCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>;
export function useSystemToolsCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<SystemToolsCatalogQuery | undefined, SystemToolsCatalogQueryVariables>;
export function useSystemToolsCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>(SystemToolsCatalogDocument, options);
        }
export type SystemToolsCatalogQueryHookResult = ReturnType<typeof useSystemToolsCatalogQuery>;
export type SystemToolsCatalogLazyQueryHookResult = ReturnType<typeof useSystemToolsCatalogLazyQuery>;
export type SystemToolsCatalogSuspenseQueryHookResult = ReturnType<typeof useSystemToolsCatalogSuspenseQuery>;
export type SystemToolsCatalogQueryResult = Apollo.QueryResult<SystemToolsCatalogQuery, SystemToolsCatalogQueryVariables>;
export const InstallMcpCatalogServerDocument = gql`
    mutation InstallMcpCatalogServer($input: InstallMcpServerInput!) {
  installMcpCatalogServer(input: $input) {
    id
    enabled
    consentMode
    server {
      id
      slug
      name
      description
      category
    }
  }
}
    `;
export type InstallMcpCatalogServerMutationFn = Apollo.MutationFunction<InstallMcpCatalogServerMutation, InstallMcpCatalogServerMutationVariables>;

/**
 * __useInstallMcpCatalogServerMutation__
 *
 * To run a mutation, you first call `useInstallMcpCatalogServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallMcpCatalogServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installMcpCatalogServerMutation, { data, loading, error }] = useInstallMcpCatalogServerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInstallMcpCatalogServerMutation(baseOptions?: Apollo.MutationHookOptions<InstallMcpCatalogServerMutation, InstallMcpCatalogServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InstallMcpCatalogServerMutation, InstallMcpCatalogServerMutationVariables>(InstallMcpCatalogServerDocument, options);
      }
export type InstallMcpCatalogServerMutationHookResult = ReturnType<typeof useInstallMcpCatalogServerMutation>;
export type InstallMcpCatalogServerMutationResult = Apollo.MutationResult<InstallMcpCatalogServerMutation>;
export type InstallMcpCatalogServerMutationOptions = Apollo.BaseMutationOptions<InstallMcpCatalogServerMutation, InstallMcpCatalogServerMutationVariables>;
export const UninstallMcpCatalogServerDocument = gql`
    mutation UninstallMcpCatalogServer($instanceId: ID!) {
  uninstallMcpCatalogServer(instanceId: $instanceId)
}
    `;
export type UninstallMcpCatalogServerMutationFn = Apollo.MutationFunction<UninstallMcpCatalogServerMutation, UninstallMcpCatalogServerMutationVariables>;

/**
 * __useUninstallMcpCatalogServerMutation__
 *
 * To run a mutation, you first call `useUninstallMcpCatalogServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUninstallMcpCatalogServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uninstallMcpCatalogServerMutation, { data, loading, error }] = useUninstallMcpCatalogServerMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useUninstallMcpCatalogServerMutation(baseOptions?: Apollo.MutationHookOptions<UninstallMcpCatalogServerMutation, UninstallMcpCatalogServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UninstallMcpCatalogServerMutation, UninstallMcpCatalogServerMutationVariables>(UninstallMcpCatalogServerDocument, options);
      }
export type UninstallMcpCatalogServerMutationHookResult = ReturnType<typeof useUninstallMcpCatalogServerMutation>;
export type UninstallMcpCatalogServerMutationResult = Apollo.MutationResult<UninstallMcpCatalogServerMutation>;
export type UninstallMcpCatalogServerMutationOptions = Apollo.BaseMutationOptions<UninstallMcpCatalogServerMutation, UninstallMcpCatalogServerMutationVariables>;
export const EnableMcpCatalogInstanceDocument = gql`
    mutation EnableMcpCatalogInstance($instanceId: ID!) {
  enableMcpCatalogInstance(instanceId: $instanceId) {
    id
    enabled
  }
}
    `;
export type EnableMcpCatalogInstanceMutationFn = Apollo.MutationFunction<EnableMcpCatalogInstanceMutation, EnableMcpCatalogInstanceMutationVariables>;

/**
 * __useEnableMcpCatalogInstanceMutation__
 *
 * To run a mutation, you first call `useEnableMcpCatalogInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMcpCatalogInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMcpCatalogInstanceMutation, { data, loading, error }] = useEnableMcpCatalogInstanceMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useEnableMcpCatalogInstanceMutation(baseOptions?: Apollo.MutationHookOptions<EnableMcpCatalogInstanceMutation, EnableMcpCatalogInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableMcpCatalogInstanceMutation, EnableMcpCatalogInstanceMutationVariables>(EnableMcpCatalogInstanceDocument, options);
      }
export type EnableMcpCatalogInstanceMutationHookResult = ReturnType<typeof useEnableMcpCatalogInstanceMutation>;
export type EnableMcpCatalogInstanceMutationResult = Apollo.MutationResult<EnableMcpCatalogInstanceMutation>;
export type EnableMcpCatalogInstanceMutationOptions = Apollo.BaseMutationOptions<EnableMcpCatalogInstanceMutation, EnableMcpCatalogInstanceMutationVariables>;
export const DisableMcpCatalogInstanceDocument = gql`
    mutation DisableMcpCatalogInstance($instanceId: ID!) {
  disableMcpCatalogInstance(instanceId: $instanceId) {
    id
    enabled
  }
}
    `;
export type DisableMcpCatalogInstanceMutationFn = Apollo.MutationFunction<DisableMcpCatalogInstanceMutation, DisableMcpCatalogInstanceMutationVariables>;

/**
 * __useDisableMcpCatalogInstanceMutation__
 *
 * To run a mutation, you first call `useDisableMcpCatalogInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMcpCatalogInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMcpCatalogInstanceMutation, { data, loading, error }] = useDisableMcpCatalogInstanceMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useDisableMcpCatalogInstanceMutation(baseOptions?: Apollo.MutationHookOptions<DisableMcpCatalogInstanceMutation, DisableMcpCatalogInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableMcpCatalogInstanceMutation, DisableMcpCatalogInstanceMutationVariables>(DisableMcpCatalogInstanceDocument, options);
      }
export type DisableMcpCatalogInstanceMutationHookResult = ReturnType<typeof useDisableMcpCatalogInstanceMutation>;
export type DisableMcpCatalogInstanceMutationResult = Apollo.MutationResult<DisableMcpCatalogInstanceMutation>;
export type DisableMcpCatalogInstanceMutationOptions = Apollo.BaseMutationOptions<DisableMcpCatalogInstanceMutation, DisableMcpCatalogInstanceMutationVariables>;
export const UpdateMcpCatalogInstanceDocument = gql`
    mutation UpdateMcpCatalogInstance($input: UpdateMcpInstanceInput!) {
  updateMcpCatalogInstance(input: $input) {
    id
    consentMode
    timeout
    metadata
  }
}
    `;
export type UpdateMcpCatalogInstanceMutationFn = Apollo.MutationFunction<UpdateMcpCatalogInstanceMutation, UpdateMcpCatalogInstanceMutationVariables>;

/**
 * __useUpdateMcpCatalogInstanceMutation__
 *
 * To run a mutation, you first call `useUpdateMcpCatalogInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcpCatalogInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcpCatalogInstanceMutation, { data, loading, error }] = useUpdateMcpCatalogInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMcpCatalogInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMcpCatalogInstanceMutation, UpdateMcpCatalogInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMcpCatalogInstanceMutation, UpdateMcpCatalogInstanceMutationVariables>(UpdateMcpCatalogInstanceDocument, options);
      }
export type UpdateMcpCatalogInstanceMutationHookResult = ReturnType<typeof useUpdateMcpCatalogInstanceMutation>;
export type UpdateMcpCatalogInstanceMutationResult = Apollo.MutationResult<UpdateMcpCatalogInstanceMutation>;
export type UpdateMcpCatalogInstanceMutationOptions = Apollo.BaseMutationOptions<UpdateMcpCatalogInstanceMutation, UpdateMcpCatalogInstanceMutationVariables>;
export const UpdateAgentToolsDocument = gql`
    mutation UpdateAgentTools($agentId: ID!, $tools: Json!) {
  updateAgentTools(agentId: $agentId, tools: $tools) {
    id
    tools
  }
}
    `;
export type UpdateAgentToolsMutationFn = Apollo.MutationFunction<UpdateAgentToolsMutation, UpdateAgentToolsMutationVariables>;

/**
 * __useUpdateAgentToolsMutation__
 *
 * To run a mutation, you first call `useUpdateAgentToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentToolsMutation, { data, loading, error }] = useUpdateAgentToolsMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      tools: // value for 'tools'
 *   },
 * });
 */
export function useUpdateAgentToolsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentToolsMutation, UpdateAgentToolsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentToolsMutation, UpdateAgentToolsMutationVariables>(UpdateAgentToolsDocument, options);
      }
export type UpdateAgentToolsMutationHookResult = ReturnType<typeof useUpdateAgentToolsMutation>;
export type UpdateAgentToolsMutationResult = Apollo.MutationResult<UpdateAgentToolsMutation>;
export type UpdateAgentToolsMutationOptions = Apollo.BaseMutationOptions<UpdateAgentToolsMutation, UpdateAgentToolsMutationVariables>;
export const McpCatalogToolsDocument = gql`
    query McpCatalogTools($serverIdOrSlug: String!) {
  mcpCatalogTools(serverIdOrSlug: $serverIdOrSlug) {
    name
    description
    inputSchema
  }
}
    `;

/**
 * __useMcpCatalogToolsQuery__
 *
 * To run a query within a React component, call `useMcpCatalogToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpCatalogToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpCatalogToolsQuery({
 *   variables: {
 *      serverIdOrSlug: // value for 'serverIdOrSlug'
 *   },
 * });
 */
export function useMcpCatalogToolsQuery(baseOptions: Apollo.QueryHookOptions<McpCatalogToolsQuery, McpCatalogToolsQueryVariables> & ({ variables: McpCatalogToolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>(McpCatalogToolsDocument, options);
      }
export function useMcpCatalogToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>(McpCatalogToolsDocument, options);
        }
// @ts-ignore
export function useMcpCatalogToolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>;
export function useMcpCatalogToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>): Apollo.UseSuspenseQueryResult<McpCatalogToolsQuery | undefined, McpCatalogToolsQueryVariables>;
export function useMcpCatalogToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>(McpCatalogToolsDocument, options);
        }
export type McpCatalogToolsQueryHookResult = ReturnType<typeof useMcpCatalogToolsQuery>;
export type McpCatalogToolsLazyQueryHookResult = ReturnType<typeof useMcpCatalogToolsLazyQuery>;
export type McpCatalogToolsSuspenseQueryHookResult = ReturnType<typeof useMcpCatalogToolsSuspenseQuery>;
export type McpCatalogToolsQueryResult = Apollo.QueryResult<McpCatalogToolsQuery, McpCatalogToolsQueryVariables>;
export const UpdateMcpToolConfigsDocument = gql`
    mutation UpdateMcpToolConfigs($input: UpdateMcpToolConfigsInput!) {
  updateMcpToolConfigs(input: $input) {
    id
    toolConfigs
  }
}
    `;
export type UpdateMcpToolConfigsMutationFn = Apollo.MutationFunction<UpdateMcpToolConfigsMutation, UpdateMcpToolConfigsMutationVariables>;

/**
 * __useUpdateMcpToolConfigsMutation__
 *
 * To run a mutation, you first call `useUpdateMcpToolConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcpToolConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcpToolConfigsMutation, { data, loading, error }] = useUpdateMcpToolConfigsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMcpToolConfigsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMcpToolConfigsMutation, UpdateMcpToolConfigsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMcpToolConfigsMutation, UpdateMcpToolConfigsMutationVariables>(UpdateMcpToolConfigsDocument, options);
      }
export type UpdateMcpToolConfigsMutationHookResult = ReturnType<typeof useUpdateMcpToolConfigsMutation>;
export type UpdateMcpToolConfigsMutationResult = Apollo.MutationResult<UpdateMcpToolConfigsMutation>;
export type UpdateMcpToolConfigsMutationOptions = Apollo.BaseMutationOptions<UpdateMcpToolConfigsMutation, UpdateMcpToolConfigsMutationVariables>;